import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵelement, ɵɵadvance, ɵɵproperty, ɵɵlistener, ɵɵtemplate, ɵɵinject, Inject, ɵɵgetCurrentView, ɵɵrestoreView, ɵɵnextContext, ɵɵtextInterpolate1, ɵɵtextInterpolate, EventEmitter, ɵɵdirectiveInject, ɵɵNgOnChangesFeature, Input, Output, ɵɵstaticViewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ViewChild, ɵɵsanitizeHtml, ɵɵstyleProp, ɵɵviewQuery, ɵɵnamespaceSVG, ɵɵattribute, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵpureFunction0, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DxPopupComponent, DxScrollViewComponent, DxNumberBoxComponent, DxSelectBoxComponent, DxDropDownBoxComponent, DxTreeViewComponent, DxLoadIndicatorComponent, DxButtonComponent, DxDataGridComponent, DxNumberBoxModule, DxDataGridModule, DxDropDownBoxModule, DxTreeViewModule, DxSelectBoxModule, DxLoadIndicatorModule, DxButtonModule, DxPopupModule, DxScrollViewModule } from 'devextreme-angular';
import { NgIf, NgForOf, NgClass, CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { DxTemplateDirective } from 'devextreme-angular/core';
import { QuantityPipe, SystemOfUnits, NgUnitsModule } from 'ng-units';
import { HttpClient, HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { catchError, tap, map, concatMap, filter, take } from 'rxjs/operators';
import { of, Subject, interval } from 'rxjs';
import { DxoPagingComponent, DxoEditingComponent, DxiColumnComponent, DxoLookupComponent, DxoFormatComponent, DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';
import { MsalService, MsalBroadcastService, MsalInterceptor, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalModule } from '@azure/msal-angular';
import { EventType, PublicClientApplication, BrowserCacheLocation, LogLevel, InteractionType } from '@azure/msal-browser';

class PumpcalcCoreService {
    constructor() { }
}
PumpcalcCoreService.ɵfac = function PumpcalcCoreService_Factory(t) { return new (t || PumpcalcCoreService)(); };
PumpcalcCoreService.ɵprov = ɵɵdefineInjectable({ token: PumpcalcCoreService, factory: PumpcalcCoreService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PumpcalcCoreService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class PumpcalcCoreComponent {
    constructor() { }
    ngOnInit() {
    }
}
PumpcalcCoreComponent.ɵfac = function PumpcalcCoreComponent_Factory(t) { return new (t || PumpcalcCoreComponent)(); };
PumpcalcCoreComponent.ɵcmp = ɵɵdefineComponent({ type: PumpcalcCoreComponent, selectors: [["lib-pumpcalc-core"]], decls: 2, vars: 0, template: function PumpcalcCoreComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, " pumpcalc-core works! here ");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PumpcalcCoreComponent, [{
        type: Component,
        args: [{
                selector: 'lib-pumpcalc-core',
                template: `
    <p>
      pumpcalc-core works! here
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

function FooterComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 8);
    ɵɵelementStart(1, "p");
    ɵɵelementStart(2, "b");
    ɵɵtext(3, "Developed and maintained by:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelement(4, "p");
    ɵɵelementStart(5, "p");
    ɵɵtext(6, "Analytical Services");
    ɵɵelementEnd();
    ɵɵelementStart(7, "p");
    ɵɵtext(8, "Vacuum Technique Technology Group");
    ɵɵelementEnd();
    ɵɵelementStart(9, "p");
    ɵɵtext(10, "Innovation Drive");
    ɵɵelementEnd();
    ɵɵelementStart(11, "p");
    ɵɵtext(12, "Burgess Hill, West Sussex");
    ɵɵelementEnd();
    ɵɵelementStart(13, "p");
    ɵɵtext(14, "RH15 9TW, UK");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function FooterComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 8);
    ɵɵelementStart(1, "dx-scroll-view", 9);
    ɵɵelementStart(2, "div");
    ɵɵelementStart(3, "h2");
    ɵɵelementStart(4, "strong");
    ɵɵtext(5, "THIS AGREEMENT RELATING TO THE USE OF PUMPCALC BETWEEN");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "p");
    ɵɵtext(7, "1.");
    ɵɵelementStart(8, "strong");
    ɵɵtext(9, " EDWARDS LIMITED,");
    ɵɵelementEnd();
    ɵɵtext(10, " a incorporated in England (Company registered number 06124650), whose registered office is Innovation Drive, Burgess Hill, West Sussex, RH15 9TW, United Kingdom (the \u201C");
    ɵɵelementStart(11, "strong");
    ɵɵtext(12, "Licensor");
    ɵɵelementEnd();
    ɵɵtext(13, "\u201D);");
    ɵɵelementEnd();
    ɵɵelementStart(14, "p");
    ɵɵtext(15, "AND");
    ɵɵelementEnd();
    ɵɵelementStart(16, "p");
    ɵɵtext(17, "2. the \u201C");
    ɵɵelementStart(18, "strong");
    ɵɵtext(19, "Licensee");
    ɵɵelementEnd();
    ɵɵtext(20, "\u201D (as such term is defined below);");
    ɵɵelementEnd();
    ɵɵelementStart(21, "p");
    ɵɵtext(22, "The Licensor and the Licensee are each referred to in this Agreement individually as a \u201CParty\u201D and collectively as the \u201CParties\u201D.");
    ɵɵelementEnd();
    ɵɵelementStart(23, "p");
    ɵɵelementStart(24, "strong");
    ɵɵtext(25, "WHEREAS");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(26, "p");
    ɵɵtext(27, "A. The Licensor owns and provides the Service (as such term is defined below).");
    ɵɵelementEnd();
    ɵɵelementStart(28, "p");
    ɵɵtext(29, "B. The Licensee has requested the right to use the Service. The Licensor has agreed to grant rights to the Licensee to use the Service. The Parties are therefore entering into this Agreement to govern, inter alia, the use of the Service.\u00A0");
    ɵɵelementEnd();
    ɵɵelementStart(30, "p");
    ɵɵtext(31, "In consideration of the mutual promises in this Agreement, the Parties ");
    ɵɵelementStart(32, "strong");
    ɵɵtext(33, "HEREBY AGREE AS FOLLOWS");
    ɵɵelementEnd();
    ɵɵtext(34, ":");
    ɵɵelementEnd();
    ɵɵelementStart(35, "h2");
    ɵɵtext(36, "1. DEFINITIONS AND INTERPRETATION");
    ɵɵelementEnd();
    ɵɵelementStart(37, "p");
    ɵɵtext(38, "1.1 In this Agreement the following expressions shall have the following meanings unless the context requires otherwise:");
    ɵɵelementEnd();
    ɵɵelementStart(39, "table", 10);
    ɵɵelementStart(40, "tbody");
    ɵɵelementStart(41, "tr");
    ɵɵelementStart(42, "td", 11);
    ɵɵelementStart(43, "p");
    ɵɵtext(44, "\u201C");
    ɵɵelementStart(45, "strong");
    ɵɵtext(46, "Licensee");
    ɵɵelementEnd();
    ɵɵtext(47, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(48, "td", 12);
    ɵɵelementStart(49, "p");
    ɵɵtext(50, "means any person to whom the Software is supplied pursuant to and on the terms of this Licence;");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(51, "tr");
    ɵɵelementStart(52, "td", 11);
    ɵɵelementStart(53, "p");
    ɵɵtext(54, "\u201C");
    ɵɵelementStart(55, "strong");
    ɵɵtext(56, "Affiliate");
    ɵɵelementEnd();
    ɵɵtext(57, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(58, "td", 12);
    ɵɵelementStart(59, "p");
    ɵɵtext(60, "means in relation to a Party, any person, firm or corporate body (wherever incorporated) which is directly or indirectly controlled by, controls or is under common control with that Party, where for the purposes of this definition, control means the ability to exercise, directly or indirectly, more than fifty percent (50%) of the voting rights generally exercisable in respect of such entity or the ability to appoint a majority of the board of directors of such entity;");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(61, "tr");
    ɵɵelementStart(62, "td", 11);
    ɵɵelementStart(63, "p");
    ɵɵtext(64, "\u201C");
    ɵɵelementStart(65, "strong");
    ɵɵtext(66, "Authorised User");
    ɵɵelementEnd();
    ɵɵtext(67, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(68, "td", 12);
    ɵɵelementStart(69, "p");
    ɵɵtext(70, "means an employee of the Licensee who is authorised by the Licensor to use the Service and the Service Documentation;");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(71, "tr");
    ɵɵelementStart(72, "td", 11);
    ɵɵelementStart(73, "p");
    ɵɵtext(74, "\u201C");
    ɵɵelementStart(75, "strong");
    ɵɵtext(76, "Confidential Information");
    ɵɵelementEnd();
    ɵɵtext(77, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(78, "td", 12);
    ɵɵelementStart(79, "p");
    ɵɵtext(80, "means all information in whatever form, (including, without limitation, written, oral, visual and electronic) disclosed, directly or indirectly, by a Party (or an Affiliate of a Party) under this Agreement from time to time, including but not limited to, all knowledge, information or materials, whether of a technical, commercial, operational or financial nature or otherwise and whether or not subject to or protected by any Intellectual Property Rights or otherwise. For the avoidance of doubt, (i) the Service and the Service Documentation is or shall be the Confidential Information of the Licensor; and (ii) the Licensee Data is or shall be the Confidential Information of the Licensee;");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(81, "tr");
    ɵɵelementStart(82, "td", 11);
    ɵɵelementStart(83, "p");
    ɵɵtext(84, "\u201C");
    ɵɵelementStart(85, "strong");
    ɵɵtext(86, "Data Protection Legislation");
    ɵɵelementEnd();
    ɵɵtext(87, "\u201D\u00A0");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(88, "td", 12);
    ɵɵelementStart(89, "p");
    ɵɵtext(90, "means the UK Data Protection Legislation and any other European Union legislation relating to personal data and all other legislation and regulatory requirements in force from time to time which apply to a Party relating to the use of personal data (including, without limitation, the privacy of electronic communications);");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(91, "tr");
    ɵɵelementStart(92, "td", 11);
    ɵɵelementStart(93, "p");
    ɵɵtext(94, "\u201C");
    ɵɵelementStart(95, "strong");
    ɵɵtext(96, "Effective Date");
    ɵɵelementEnd();
    ɵɵtext(97, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(98, "td", 12);
    ɵɵelementStart(99, "p");
    ɵɵtext(100, "means the date of this Agreement;");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(101, "tr");
    ɵɵelementStart(102, "td", 11);
    ɵɵelementStart(103, "p");
    ɵɵtext(104, "\u201C");
    ɵɵelementStart(105, "strong");
    ɵɵtext(106, "Intellectual Property Rights");
    ɵɵelementEnd();
    ɵɵtext(107, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(108, "td", 12);
    ɵɵelementStart(109, "p");
    ɵɵtext(110, "means all intellectual property rights, including (without limitation) patents, petty patents, utility models, Know-How, trade marks, database rights, rights in designs, copyright, topography rights (whether or not any of these rights are registered, and including, without limitation applications and the right to apply for registration of any such rights) and all inventions and other proprietary knowledge and information, and all rights and forms of protection of a similar nature or having equivalent or similar effect to any of these which may subsist anywhere in the world, in each case for their full term, and together with any renewals or extensions;");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(111, "tr");
    ɵɵelementStart(112, "td", 11);
    ɵɵelementStart(113, "p");
    ɵɵtext(114, "\u201C");
    ɵɵelementStart(115, "strong");
    ɵɵtext(116, "Know-How");
    ɵɵelementEnd();
    ɵɵtext(117, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(118, "td", 12);
    ɵɵelementStart(119, "p");
    ɵɵtext(120, "means any unpatented information, knowledge, experience, formulae and data of all kinds, whether subject to statutory protection or not, including, but not limited to, inventions, discoveries, concepts, methodologies, models, technical data packages, test results, trade secrets, techniques, improvements, analyses, manufacturing processes and information, specifications and other information that is not in the public domain;");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(121, "tr");
    ɵɵelementStart(122, "td", 11);
    ɵɵelementStart(123, "p");
    ɵɵtext(124, "\u201C");
    ɵɵelementStart(125, "strong");
    ɵɵtext(126, "Licensee Data");
    ɵɵelementEnd();
    ɵɵtext(127, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(128, "td", 12);
    ɵɵelementStart(129, "p");
    ɵɵtext(130, "means the data inputted by the Licensee, Authorised Users for the purpose of using the Services;");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(131, "tr");
    ɵɵelementStart(132, "td", 11);
    ɵɵelementStart(133, "p");
    ɵɵtext(134, "\u201C");
    ɵɵelementStart(135, "strong");
    ɵɵtext(136, "Purpose");
    ɵɵelementEnd();
    ɵɵtext(137, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(138, "td", 12);
    ɵɵelementStart(139, "p");
    ɵɵtext(140, "means modelling of vacuum systems;");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(141, "tr");
    ɵɵelementStart(142, "td", 11);
    ɵɵelementStart(143, "p");
    ɵɵtext(144, "\u201C");
    ɵɵelementStart(145, "strong");
    ɵɵtext(146, "Service");
    ɵɵelementEnd();
    ɵɵtext(147, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(148, "td", 12);
    ɵɵelementStart(149, "p");
    ɵɵtext(150, "means the vacuum simulation software known as PUMPCALC;");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(151, "tr");
    ɵɵelementStart(152, "td", 11);
    ɵɵelementStart(153, "p");
    ɵɵtext(154, "\u201C");
    ɵɵelementStart(155, "strong");
    ɵɵtext(156, "Service Documentation");
    ɵɵelementEnd();
    ɵɵtext(157, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(158, "td", 12);
    ɵɵelementStart(159, "p");
    ɵɵtext(160, "means any and all documentation (whether in human or machine readable form), including, but not limited to operating manuals, user instruction manuals and training materials and any other documents associated with the use of the Service, that may be made available within or as part of the Service by the Licensor, from time to time;");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(161, "tr");
    ɵɵelementStart(162, "td", 11);
    ɵɵelementStart(163, "p");
    ɵɵtext(164, "\u201C");
    ɵɵelementStart(165, "strong");
    ɵɵtext(166, "Term");
    ɵɵelementEnd();
    ɵɵtext(167, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(168, "td", 12);
    ɵɵelementStart(169, "p");
    ɵɵtext(170, "means the Initial Period and any Renewal Periods (as such terms are defined in Clause 9.1;");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(171, "tr");
    ɵɵelementStart(172, "td", 11);
    ɵɵelementStart(173, "p");
    ɵɵtext(174, "\u201C");
    ɵɵelementStart(175, "strong");
    ɵɵtext(176, "Trade Marks");
    ɵɵelementEnd();
    ɵɵtext(177, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(178, "td", 12);
    ɵɵelementStart(179, "p");
    ɵɵtext(180, "means the trade mark PUMPCALC and any and all rights, of whatever nature, in and to the name PUMPCALC and any other trade marks of the Licensor; and");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(181, "tr");
    ɵɵelementStart(182, "td", 11);
    ɵɵelementStart(183, "p");
    ɵɵtext(184, "\u201C");
    ɵɵelementStart(185, "strong");
    ɵɵtext(186, "UK Data Protection Legislation");
    ɵɵelementEnd();
    ɵɵtext(187, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(188, "td", 12);
    ɵɵelementStart(189, "p");
    ɵɵtext(190, "means all applicable data protection and privacy legislation in force from time to time in the UK including the General Data Protection Regulation ((EU) 2016/679); the Data Protection Act 2018; the Privacy and Electronic Communications Directive 2002/58/EC (as updated by Directive 2009/136/EC) and the Privacy and Electronic Communications Regulations 2003 (SI 2003/2426) as amended; and");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(191, "tr");
    ɵɵelementStart(192, "td", 11);
    ɵɵelementStart(193, "p");
    ɵɵtext(194, "\u201C");
    ɵɵelementStart(195, "strong");
    ɵɵtext(196, "User Access");
    ɵɵelementEnd();
    ɵɵtext(197, "\u201D");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(198, "td", 12);
    ɵɵelementStart(199, "p");
    ɵɵtext(200, "means the access to the Service via a link to a log in process with an associated password, as provided by the Licensor.");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(201, "p");
    ɵɵtext(202, "1.2 In this Agreement unless otherwise expressly provided or unless the context requires otherwise:");
    ɵɵelementEnd();
    ɵɵelementStart(203, "p");
    ɵɵtext(204, "1.2.1 references to the singular include the plural and vice versa;");
    ɵɵelementEnd();
    ɵɵelementStart(205, "p");
    ɵɵtext(206, "1.2.2 references to Clauses are to clauses of this Agreement;");
    ɵɵelementEnd();
    ɵɵelementStart(207, "p");
    ɵɵtext(208, "1.2.3 references to laws and statutory provisions shall include reference to any subordinate legislation made pursuant thereto and shall be construed as referring to those laws, provisions and subordinate legislation as respectively amended or re-enacted from time to time;");
    ɵɵelementEnd();
    ɵɵelementStart(209, "p");
    ɵɵtext(210, "1.2.4 the headings of this Agreement are for ease of reference only and are not part of this Agreement for purposes of construction; and");
    ɵɵelementEnd();
    ɵɵelementStart(211, "p");
    ɵɵtext(212, "1.2.5 references to a Party or the Parties include their respective successors in title, permitted assigns and legal personal representatives.");
    ɵɵelementEnd();
    ɵɵelementStart(213, "h2");
    ɵɵtext(214, "2. LICENCE");
    ɵɵelementEnd();
    ɵɵelementStart(215, "p");
    ɵɵtext(216, "2.1 The Licensor hereby grants to the Licensee a non-exclusive, royalty-free, non-transferable, revocable licence for the Authorised User to use the Service for the Purpose for the Term (unless terminated earlier in accordance with this Agreement), subject to the terms and conditions of this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(217, "p");
    ɵɵtext(218, "2.2 For each Authorised User, the Licensor shall provide the Licensee with User Access to enable that Authorised User to access the Service. The licence granted under this Agreement is for one (1) Authorised User only. If the Licensee wishes to replace the Authorise User or requires any additional users of the Service, it shall notify the Licensor in writing. The Licensor shall evaluate such request for a replacement or additional user and if the Licensor approves the request, the Licensor shall provide the Licensee with replacement or additional User Access (as the case may be) for any such replacement or additional Authorised User.");
    ɵɵelementEnd();
    ɵɵelementStart(219, "p");
    ɵɵtext(220, "2.3 The Licensee:");
    ɵɵelementEnd();
    ɵɵelementStart(221, "p");
    ɵɵtext(222, "2.3.1 shall not provide and shall not allow any User Access or password to be provided to or used by anyone other the relevant individual Authorised User to which it was issued, unless it has been reassigned in its entirety to another individual Authorised User in accordance with Clause 2.2, in which case the prior Authorised User shall no longer have any right to access or use the Service and/or any of the Service Documentation;");
    ɵɵelementEnd();
    ɵɵelementStart(223, "p");
    ɵɵtext(224, "2.3.2 shall, and shall ensure that each Authorised User shall, keep the password for its use of the Service and Service Documentation secure and confidential; and");
    ɵɵelementEnd();
    ɵɵelementStart(225, "p");
    ɵɵtext(226, "2.3.3 shall maintain a written, up to date list of current Authorised Users and provide such list to the Licensor promptly after any request from the Licensor.");
    ɵɵelementEnd();
    ɵɵelementStart(227, "p");
    ɵɵtext(228, "2.4 The Licensee may use the Service Documentation in support of the use of the Service by the Authorised User for the Purpose only.");
    ɵɵelementEnd();
    ɵɵelementStart(229, "p");
    ɵɵtext(230, "2.5 The Licensee shall not grant any sub-licences of any of the Service or Service Documentation.");
    ɵɵelementEnd();
    ɵɵelementStart(231, "p");
    ɵɵtext(232, "2.6 The Licensee agrees and acknowledges that:");
    ɵɵelementEnd();
    ɵɵelementStart(233, "p");
    ɵɵtext(234, "2.6.1 it uses the Service and Service Documentation at its own risk and the Licensor shall have no responsibility for any use made by the Licensee of the Service and Service Documentation , including, but not limited to, any calculations made by the Licensee using the Service and Service Documentation and/or any conclusions drawn from such calculations; and");
    ɵɵelementEnd();
    ɵɵelementStart(235, "p");
    ɵɵtext(236, "2.6.2 nothing in this Agreement shall oblige the Licensor to update, maintain, maintain availability, continue to licence and/or provide access to any of the Service and/or Service Documentation and that, accordingly, the Licensor may withdraw the Service and/or Service Documentation at any time at its sole discretion.");
    ɵɵelementEnd();
    ɵɵelementStart(237, "p");
    ɵɵtext(238, "2.7 For the avoidance of doubt, nothing in this Agreement shall grant, imply or oblige the grant of any rights to or access to any of the source code for the Service to the Licensee.");
    ɵɵelementEnd();
    ɵɵelementStart(239, "h2");
    ɵɵtext(240, "3. INTELLECTUAL PROPERTY RIGHTS");
    ɵɵelementEnd();
    ɵɵelementStart(241, "p");
    ɵɵtext(242, "3.1 The Licensee acknowledges that all Intellectual Property Rights in or relating to the Service and the Service Documentation belongs and shall belong to the Licensor (or its licensor), and the Licensee shall have no rights in or to the Service and the Service Documentation other than the rights to use the Service and the Service Documentation expressly granted in this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(243, "p");
    ɵɵtext(244, "3.2 No rights are granted to the Licensee to use the Trade Mark. All rights, title and interest in and to the Trade Mark shall remain vested in the Licensor (and/or its Affiliates, as the case may be) and the Licensee shall not obtain any rights in or to the Trade Mark other than as expressly provided in this Agreement. All goodwill that may be generated by or arises from the use of the Trade Mark shall ensure to the benefit of the Licensor and the Licensee shall do such acts and execute such documents as may be necessary to fully vest all such goodwill in the Licensor.");
    ɵɵelementEnd();
    ɵɵelementStart(245, "h2");
    ɵɵtext(246, "4. LICENSEE OBLIGATIONS");
    ɵɵelementEnd();
    ɵɵelementStart(247, "p");
    ɵɵtext(248, "4.1 Save as expressly provided in this Agreement or as permitted by any applicable law, the Licensee shall: ");
    ɵɵelementEnd();
    ɵɵelementStart(249, "p");
    ɵɵtext(250, "4.1.1 not copy the Service, any software within the Service or Service Documentation except where such copying is incidental to normal use of the Service;");
    ɵɵelementEnd();
    ɵɵelementStart(251, "p");
    ɵɵtext(252, "4.1.2 not rent, lease, sub-license, loan, translate, merge, adapt, vary or modify the Service, any software within the Service or any of the Service Documentation;");
    ɵɵelementEnd();
    ɵɵelementStart(253, "p");
    ɵɵtext(254, "4.1.3 not make alterations to, or modifications of, the whole or any part of the Service, nor permit the Service, any software within the Service or any part of it to be combined with, or become incorporated in, any other programs;");
    ɵɵelementEnd();
    ɵɵelementStart(255, "p");
    ɵɵtext(256, "4.1.4 not make alterations to, or modifications of, the whole or any part of the Service Documentation, nor permit the Service Documentation or any part of it to be combined with, or become incorporated in, any other material of whatever nature;");
    ɵɵelementEnd();
    ɵɵelementStart(257, "p");
    ɵɵtext(258, "4.1.5 not disassemble, decompile, reverse-engineer or create derivative works based on the whole or any part of the Service nor attempt to do any such thing;");
    ɵɵelementEnd();
    ɵɵelementStart(259, "p");
    ɵɵtext(260, "4.1.6 supervise and control use of the Service and ensure that the Service is used by the Authorised Users only and in accordance with the terms of this Agreement;");
    ɵɵelementEnd();
    ɵɵelementStart(261, "p");
    ɵɵtext(262, "4.1.7 include the Licensor\u2019s copyright notice on all entire and partial copies of the Services and/or Service Documentation on any medium;");
    ɵɵelementEnd();
    ɵɵelementStart(263, "p");
    ɵɵtext(264, "4.1.8 not introduce or permit the introduction of, any viruses, worms, trojan horses, ");
    ɵɵelementStart(265, "span", 13);
    ɵɵtext(266, "spyware");
    ɵɵelementEnd();
    ɵɵtext(267, "and any other similar malware or devices or ");
    ɵɵelementStart(268, "span", 13);
    ɵɵtext(269, "security ");
    ɵɵelementEnd();
    ɵɵtext(270, "vulnerability into the Licensor\u2019s network and information systems; and");
    ɵɵelementEnd();
    ɵɵelementStart(271, "p");
    ɵɵtext(272, "4.1.9 not provide or otherwise make available the Service and/or Service Documentation, in whole or in part (including but not limited to program listings, object and source program listings, object code and source code), in any form, to any third party.");
    ɵɵelementEnd();
    ɵɵelementStart(273, "h2");
    ɵɵtext(274, "5. LICENSEE DATA");
    ɵɵelementEnd();
    ɵɵelementStart(275, "p");
    ɵɵtext(276, "5.1 Nothing in this Agreement shall affect the rights in or to the Licensee Data which shall remain vested in the Licensee.");
    ɵɵelementEnd();
    ɵɵelementStart(277, "p");
    ɵɵtext(278, "5.2 The Licensee agrees and acknowledges that the Licensor will store, use and retain the Licensee Data and any calculations made using the Licensee Data in the Service and for the purposes of providing the Service and the maintenance, enhancement and improvement of the Service and to improve products, services and support to the Licensee and for other business purposes.\u00A0");
    ɵɵelementEnd();
    ɵɵelementStart(279, "h2");
    ɵɵtext(280, "6. DATA PROTECTION");
    ɵɵelementEnd();
    ɵɵelementStart(281, "p");
    ɵɵtext(282, "6.1 Both Parties shall comply with all applicable requirements of the Data Protection Legislation. This Clause 6 is in addition to, and does not relieve, remove or replace, a Party\u2019s obligations or rights under the Data Protection Legislation.");
    ɵɵelementEnd();
    ɵɵelementStart(283, "p");
    ɵɵtext(284, "6.2 The Licensor may share the Licensee's data with third party service providers who have been appointed as data processors to perform functions and services on its behalf and who will be provided only with personal data necessary to perform the services on its behalf but are not authorised by the Licensor to use such data for any other purposes.");
    ɵɵelementEnd();
    ɵɵelementStart(285, "p");
    ɵɵtext(286, "6.3 Without prejudice to the generality of Clause 6.1, the Licensee shall ensure that it has all necessary appropriate consents and notices in place to enable lawful transfer of any personal data to the Licensor for the purposes of this Agreement so that the Licensor may lawfully use for the purposes of this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(287, "h2");
    ɵɵtext(288, "7. CONFIDENTIALITY");
    ɵɵelementEnd();
    ɵɵelementStart(289, "p");
    ɵɵtext(290, "7.1 Each Party (the \"Receiving Party\") agrees and acknowledges that it may receive Confidential Information directly or indirectly from the other Party (the \"Disclosing Party\"), that the Confidential Information is proprietary to the Disclosing Party and is confidential. Except as may be expressly provided in this Agreement, no licence is granted to the Receiving Party to use the Confidential Information of the Disclosing Party and/or any Intellectual Property Rights in that Confidential Information.");
    ɵɵelementEnd();
    ɵɵelementStart(291, "p");
    ɵɵtext(292, "7.2 Subject to the provisions of this Clause 7, the Receiving Party shall at all times keep the Confidential Information of the Disclosing Party confidential. The Receiving Party may use the Confidential Information of the Disclosing Party for the purpose of this Agreement only and it shall not use it for any other purpose.\u00A0");
    ɵɵelementEnd();
    ɵɵelementStart(293, "p");
    ɵɵtext(294, "7.3 Except as expressly provided in this Agreement, the Receiving Party shall not use or disclose or permit any of its Affiliates or any third party to use or disclose any of the Confidential Information of the Disclosing Party.");
    ɵɵelementEnd();
    ɵɵelementStart(295, "p");
    ɵɵtext(296, "7.4 Any Confidential Information disclosed to the Receiving Party under this Agreement, irrespective of whether it is marked \u201CConfidential\u201D or not, shall be treated by the Receiving Party as confidential and the Receiving Party shall use at least the same standard of care in the storage, transportation and handling of that Confidential Information as the Receiving Party normally uses in respect of its own proprietary and confidential data and information so as to prevent misuse, theft and/or unauthorised copying or disclosure of the Confidential Information, such standard of care in any event not being less than a reasonable standard of care.");
    ɵɵelementEnd();
    ɵɵelementStart(297, "p");
    ɵɵtext(298, "7.5 The Receiving Party may disclose the Confidential Information to its duly authorised employees, officers and directors only where such disclosure is necessary for the purposes of this Agreement (and to the extent that it is necessary only).\u00A0");
    ɵɵelementEnd();
    ɵɵelementStart(299, "p");
    ɵɵtext(300, "7.6 The Receiving Party shall ensure that prior to any disclosure pursuant to Clause 7.5, any persons receiving any of the Confidential Information pursuant to Clause 7.5 are aware of the confidential nature of that Confidential Information and shall hold such Confidential Information confidential and shall ensure that such persons are bound by confidentiality obligations on terms equivalent to those set out in this Agreement. ");
    ɵɵelementEnd();
    ɵɵelementStart(301, "p");
    ɵɵtext(302, "7.7 This Agreement and the term Confidential Information shall not apply to anything disclosed under this Agreement which:");
    ɵɵelementEnd();
    ɵɵelementStart(303, "p");
    ɵɵtext(304, "7.7.1 is or becomes publicly known through no wrongful act, default or omission of the Receiving Party;\u00A0 ");
    ɵɵelementEnd();
    ɵɵelementStart(305, "p");
    ɵɵtext(306, "7.7.2 was rightfully in the possession of the Receiving Party prior to the disclosure of that information to it by the Disclosing Party and that the Receiving Party was not under any obligation of confidence in respect of that information as evidenced by the written records of the Receiving Party;");
    ɵɵelementEnd();
    ɵɵelementStart(307, "p");
    ɵɵtext(308, "7.7.3 is developed by the Receiving Party independently of its receipt from the Disclosing Party; or");
    ɵɵelementEnd();
    ɵɵelementStart(309, "p");
    ɵɵtext(310, "7.7.4 becomes rightfully known to the Receiving Party without confidentiality restriction from a source other than the Disclosing Party.");
    ɵɵelementEnd();
    ɵɵelementStart(311, "p");
    ɵɵtext(312, "7.8 Upon request of any Court, government or inter-governmental agency or other official judicial or regulatory body, the Receiving Party may disclose the Confidential Information of the Disclosing Party to the extent required by any applicable law, or other official order, decree, regulation or rule (including, without limitation, any regulation or rule of any regulatory agency, securities commission or stock exchange on which the securities of the Receiving Party or those of the Receiving Party\u2019s Affiliates are or are to be listed), but shall:");
    ɵɵelementEnd();
    ɵɵelementStart(313, "p");
    ɵɵtext(314, "7.8.1 so far as it is legal to do so, notify the Disclosing Party prior to such disclosure specifying what Confidential Information is required to be disclosed, and to whom;");
    ɵɵelementEnd();
    ɵɵelementStart(315, "p");
    ɵɵtext(316, "7.8.2 take and/or allow and assist the Disclosing Party to take such steps as may be reasonably possible to minimise the Confidential Information disclosed; and");
    ɵɵelementEnd();
    ɵɵelementStart(317, "p");
    ɵɵtext(318, "7.8.3 use reasonable endeavours to ensure the Confidential Information is kept confidential by the recipient. ");
    ɵɵelementEnd();
    ɵɵelementStart(319, "p");
    ɵɵtext(320, "7.9 All copies of the Confidential Information of the Disclosing Party supplied to or otherwise obtained or generated by the Receiving Party shall remain the property of the Disclosing Party and shall be treated as if they were originals of the Confidential Information supplied under this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(321, "p");
    ɵɵtext(322, "7.10 The Receiving Party shall at its cost either return to the Disclosing Party or destroy as directed by the Disclosing Party all documents or other materials containing or referring to the Confidential Information of the Disclosing Party which are in its possession, power or control or in the possession, power or control of persons who may have received that Confidential Information from it under Clause 7.5, at any time if requested to do so by the Disclosing Party and in any event following the termination or expiry of this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(323, "p");
    ɵɵtext(324, "7.11 The Licensor may disclose the Confidential Information of the Licensee to its Affiliates to the extent necessary for the purposes of this Agreement only, provided that it procures that such Affiliate(s) are bound by confidentiality obligations equivalent to those of this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(325, "p");
    ɵɵtext(326, "7.12 Each Party recognises that improper use of the Confidential Information of the Disclosing Party may cause irreparable damage to the Disclosing Party and agrees that the Disclosing Party shall be entitled to injunctive relief against a defaulting Party to prevent or minimise misuse or unauthorised disclosure of such Confidential Information and/or any other obligation breached or being breached under this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(327, "p");
    ɵɵtext(328, "7.13 The obligations contained in this Clause 7 shall survive the termination or expiry of this Agreement for a period of five (5) years.");
    ɵɵelementEnd();
    ɵɵelementStart(329, "h2");
    ɵɵtext(330, "8. ENFORCEMENT");
    ɵɵelementEnd();
    ɵɵelementStart(331, "p");
    ɵɵtext(332, "8.1 The Licensee shall immediately notify the Licensor in writing giving full particulars if it becomes aware of any actual, suspected or threatened infringement of any of the Service and/or Service Documentation or any claim made or threatened that the Service and/or Service Documentation infringes the rights of any third party.");
    ɵɵelementEnd();
    ɵɵelementStart(333, "p");
    ɵɵtext(334, "8.2 As between the Licensee and the Licensor, the Licensor shall at its discretion, decide what action to take, if any, in relation to any enforcement of any rights in or relating to the Service and/or Service Documentation and/or claim or allegation made in relation to the Service and/or Service Documentation . The Licensor shall have control over and conduct of any such claims and proceedings. The Licensee shall not make any admissions in relation to or settle any such claims or proceedings without the prior written consent of the Licensor. The Licensee shall provide the Licensor with all assistance that the Licensor may reasonably require in the conduct of any such claims or proceedings. The Licensor shall bear the cost of any proceedings and shall be entitled to retain all sums recovered in any action for its own account.");
    ɵɵelementEnd();
    ɵɵelementStart(335, "h2");
    ɵɵtext(336, "9. TERM AND TERMINATION");
    ɵɵelementEnd();
    ɵɵelementStart(337, "p");
    ɵɵtext(338, "9.1 This Agreement shall commence on the Effective Date and shall continue in accordance with its terms for a period of twelve (12) months (the \u201CInitial Term\u201D) and thereafter, this Agreement shall automatically renew for successive periods of twelve (12) months (each a \u201CRenewal Period), unless terminated earlier in accordance with the terms of this Agreement.\u00A0");
    ɵɵelementEnd();
    ɵɵelementStart(339, "p");
    ɵɵtext(340, "9.2 A Party (the \u201CTerminating Party\u201D) may, without prejudice to its other rights and remedies and without liability, terminate this Agreement by immediate written notice to the other Party if:");
    ɵɵelementEnd();
    ɵɵelementStart(341, "p");
    ɵɵtext(342, "9.2.1 the other Party commits any breach of any provision of this Agreement which is incapable of remedy or which, if capable of remedy, has not been remedied within thirty (30) days of receipt of a written notice from the Terminating Party specifying the breach and requesting the same to be remedied;");
    ɵɵelementEnd();
    ɵɵelementStart(343, "p");
    ɵɵtext(344, "9.2.2 the other Party goes into liquidation other than for the purposes of reconstruction or amalgamation, becomes insolvent, is declared bankrupt by any competent tribunal, makes any general assignment of its assets for the benefit of its creditors or is unable to meet any of its obligations as they become due.");
    ɵɵelementEnd();
    ɵɵelementStart(345, "p");
    ɵɵtext(346, "9.3 The Licensor may, without prejudice to its other rights and remedies and without liability, terminate this Agreement by immediate written notice to the Licensee if the ownership or control of the Licensee shall pass into the hands of any legal person, which the Licensor in its reasonable discretion considers unsuitable for any reason whatsoever.");
    ɵɵelementEnd();
    ɵɵelementStart(347, "p");
    ɵɵtext(348, "9.4 Either Party may, without prejudice to its other rights and remedies and without liability, terminate this Agreement by thirty (30) days written notice to the other Party.\u00A0");
    ɵɵelementEnd();
    ɵɵelementStart(349, "h2");
    ɵɵtext(350, "10. CONSEQUENCES OF TERMINATION");
    ɵɵelementEnd();
    ɵɵelementStart(351, "p");
    ɵɵtext(352, "10.1 Upon the expiry or termination of this Agreement for whatever reason:");
    ɵɵelementEnd();
    ɵɵelementStart(353, "p");
    ɵɵtext(354, "10.1.1 all rights granted to the Licensee under this Agreement immediately shall cease;");
    ɵɵelementEnd();
    ɵɵelementStart(355, "p");
    ɵɵtext(356, "10.1.2 the Licensee shall immediately destroy all copies of the Service, any software within the Service and Service Documentation then in its possession, custody or control and, in the case of destruction and/or removal, certify to the Licensor that it has done so;");
    ɵɵelementEnd();
    ɵɵelementStart(357, "p");
    ɵɵtext(358, "10.1.3 all User Accesses shall immediately terminate and the Licensee and Authorised User shall cease using the Service and Service Documentation;");
    ɵɵelementEnd();
    ɵɵelementStart(359, "p");
    ɵɵtext(360, "10.1.4 each Party shall promptly, as the other Party may direct, either return to the other Party or destroy and certify the destruction of all copies of Confidential Information of the other Party in its possession or control, save as may be expressly provided in this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(361, "p");
    ɵɵtext(362, "10.2 Clauses 2.6, 3, 5, 7, 8, 10, 11, 12 and 23 together with such other Clauses that are expressed to survive or by their nature survive or are necessary for the interpretation or enforcement of this Agreement shall survive the termination or expiry of this Agreement and shall continue in accordance with their terms. ");
    ɵɵelementEnd();
    ɵɵelementStart(363, "p");
    ɵɵtext(364, "10.3 Termination or expiry of this Agreement shall not affect any rights, remedies, obligations or liabilities of the Parties that have accrued up to the date of termination or expiry, including, but not limited to, the right to claim damages in respect of any breach of the Agreement which existed at or before the date of termination or expiry.");
    ɵɵelementEnd();
    ɵɵelementStart(365, "h2");
    ɵɵtext(366, "11. FORCE MAJEURE");
    ɵɵelementEnd();
    ɵɵelementStart(367, "p");
    ɵɵtext(368, "11.1 Neither Party shall be responsible for any failure to perform or delay in performing any of its obligations under this Agreement where and to the extent that such failure or delay results from causes outside the reasonable control of that Party. Such causes shall include, without limitation, Acts of God, fires, floods, epidemics, quarantine restrictions, freight embargoes, war, civil disturbances, strikes, labour disputes or the like.");
    ɵɵelementEnd();
    ɵɵelementStart(369, "h2");
    ɵɵtext(370, "12. NOTICES");
    ɵɵelementEnd();
    ɵɵelementStart(371, "p");
    ɵɵtext(372, "12.1 Any notice required to be given under this Agreement shall be given in writing and delivered personally, by first class prepaid letter or pre-paid airmail and sent to the address set out at the beginning of this Agreement for the Party or such other address as a Party may notify the other Party of in writing from time to time. Any such notice shall be deemed to have been received, in the case of deliveries by hand, at the time of delivery, in the case of first class post, 48 hours after posting or, in the case of pre-paid airmail, 5 business days after posting. For the avoidance of doubt, notice given under this Agreement shall not be validly served if sent by email.");
    ɵɵelementEnd();
    ɵɵelementStart(373, "h2");
    ɵɵtext(374, "13. LIABILITY");
    ɵɵelementEnd();
    ɵɵelementStart(375, "p");
    ɵɵtext(376, "13.1 The Licensee agrees and acknowledges that the Service and Service Documentation is or will be made available to it by the Licensor \u201Cas is\u201D and that the Service and Service Documentation is used by the Licensee entirely at its own sole risk. Nothing in this Agreement shall constitute any representation or warranty by the Licensor or liability for the Licensor under this Agreement and/or in relation to the Service and Service Documentation and their use, in particular, but without limitation, that:");
    ɵɵelementEnd();
    ɵɵelementStart(377, "p");
    ɵɵtext(378, "13.1.1 the Service and/or Service Documentation will meet the requirements of the Licensee;");
    ɵɵelementEnd();
    ɵɵelementStart(379, "p");
    ɵɵtext(380, "13.1.2 the Service and/or Service Documentation are or will be fit for any particular purpose;");
    ɵɵelementEnd();
    ɵɵelementStart(381, "p");
    ɵɵtext(382, "13.1.3 the Service and/or Service Documentation are free of errors or omissions;");
    ɵɵelementEnd();
    ɵɵelementStart(383, "p");
    ɵɵtext(384, "13.1.4 the Service will be and will continue to be available at any time;");
    ɵɵelementEnd();
    ɵɵelementStart(385, "p");
    ɵɵtext(386, "13.1.5 the use of the Service and/or Service Documentation do not and/or will not infringe any Intellectual Property Rights of any third party; and");
    ɵɵelementEnd();
    ɵɵelementStart(387, "p");
    ɵɵtext(388, "13.1.6 the Trade Marks do not and/or will not infringe any Intellectual Property Rights of any third party. ");
    ɵɵelementEnd();
    ɵɵelementStart(389, "p");
    ɵɵtext(390, "13.2 The Licensor shall not be responsible for any delays, delivery failures or any other loss or damage resulting from the transfer of data over communications networks and facilities, including the internet, and the Licensee acknowledges that the Services and Service Documentation may be subject to limitations, delays and other problems inherent in the use of such communications facilities.");
    ɵɵelementEnd();
    ɵɵelementStart(391, "p");
    ɵɵtext(392, "13.3 Neither Party shall be liable the other in contract, tort or otherwise for any loss of profits, loss of data or loss of contracts, or for any consequential, special or indirect loss or damage arising out of or in relation to this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(393, "h2");
    ɵɵtext(394, "14. ENTIRE AGREEMENT");
    ɵɵelementEnd();
    ɵɵelementStart(395, "p");
    ɵɵtext(396, "14.1 This Agreement constitutes the entire agreement and understanding of the Parties relating to the subject matter of this Agreement and supersedes any previous agreement or understanding between the Parties in relation to such subject matter.");
    ɵɵelementEnd();
    ɵɵelementStart(397, "p");
    ɵɵtext(398, "14.2 Each Party acknowledges and agrees that in entering into this Agreement, it has not relied on any statement, representation, warranty, understanding, undertaking, promise or assurance other than as expressly set out in this Agreement. All warranties, representations, conditions and all other terms of any kind whatsoever implied by statute or common law are, to the fullest extent permitted by applicable law, excluded from this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(399, "p");
    ɵɵtext(400, "14.3 Each Party irrevocably and unconditionally waives all claims, rights and remedies which but for this Clause it might otherwise have had in relation to any representation, warranty or promise made prior to the Effective Date, unless it was made fraudulently.");
    ɵɵelementEnd();
    ɵɵelementStart(401, "p");
    ɵɵtext(402, "14.4 Nothing in this Agreement shall exclude or limit the liability of either Party to the other Party for death or personal injury resulting from its negligence, fraud or fraudulent misrepresentation or for any other liability for which exclusion or limitation is expressly prohibited by law.");
    ɵɵelementEnd();
    ɵɵelementStart(403, "h2");
    ɵɵtext(404, "15. NO PARTNERSHIP");
    ɵɵelementEnd();
    ɵɵelementStart(405, "p");
    ɵɵtext(406, "Nothing in this Agreement shall, is intended to, or shall be deemed to, establish any relationship of partnership, joint venture, agency or employment between the Parties (including, but not limited to, their Affiliates), nor authorise any Party nor their Affiliates to make or enter into any commitments for or on behalf of the other Party.");
    ɵɵelementEnd();
    ɵɵelementStart(407, "h2");
    ɵɵtext(408, "16. AMENDMENT");
    ɵɵelementEnd();
    ɵɵelementStart(409, "p");
    ɵɵtext(410, "No amendment or other variation to this Agreement shall be effective unless and until it is in writing and signed by or on behalf of each of the Parties. For the avoidance of doubt, no modification or variation of this Agreement shall be valid if made by email.");
    ɵɵelementEnd();
    ɵɵelementStart(411, "h2");
    ɵɵtext(412, "17. WAIVER");
    ɵɵelementEnd();
    ɵɵelementStart(413, "p");
    ɵɵtext(414, "No failure or delay by a Party in exercise of any right or remedy under this Agreement or at law shall constitute a waiver of that or any other right or remedy, nor shall it preclude or restrict the further exercise of that or any other right or remedy. No single or partial exercise of such right or remedy shall preclude or restrict the further exercise of that or any other right or remedy. The rights and remedies provided under this Agreement are in addition to, and not exclusive of, any rights or remedies provided by law.");
    ɵɵelementEnd();
    ɵɵelementStart(415, "h2");
    ɵɵtext(416, "18. SEVERABILITY");
    ɵɵelementEnd();
    ɵɵelementStart(417, "p");
    ɵɵtext(418, "If any part of this Agreement is found by any court or other authority of competent jurisdiction to be invalid, illegal or unenforceable, that part shall, to the extent required, be deemed not to form part of this Agreement, and the validity and enforceability of the other parts of this Agreement shall not be affected. The Parties shall negotiate in good faith to amend such affected part so that, as amended, it is legal, valid and enforceable, and, to the greatest extent possible, achieves the Parties' original commercial intention.");
    ɵɵelementEnd();
    ɵɵelementStart(419, "h2");
    ɵɵtext(420, "19. FURTHER ASSURANCE");
    ɵɵelementEnd();
    ɵɵelementStart(421, "p");
    ɵɵtext(422, "The Licensee shall, at the reasonable expense of the Licensor, execute or cause to be executed all documents and do or cause to be done all further acts and things consistent with the terms of this Agreement that the Licensor may require from time to time in order to give full effect to the terms of this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(423, "h2");
    ɵɵtext(424, "20. ASSIGNMENT AND SUB-CONTRACTING");
    ɵɵelementEnd();
    ɵɵelementStart(425, "p");
    ɵɵtext(426, "20.1 The Licensee shall not assign, subcontract, sub-licence or deal within any manner the whole or any part of this Agreement or any of its rights and obligations under this Agreement without the prior written consent of the Licensor.\u00A0");
    ɵɵelementEnd();
    ɵɵelementStart(427, "p");
    ɵɵtext(428, "20.2 The Licensor may at any time assign, sub-contract, sub-licence or otherwise deal in any other manner with any or all of its rights under or which are the subject matter of this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(429, "h2");
    ɵɵtext(430, "21. THIRD PARTY RIGHTS");
    ɵɵelementEnd();
    ɵɵelementStart(431, "p");
    ɵɵtext(432, "The Affiliates of the Licensor may enforce this Agreement. Save as provided by this Clause, a party who is not a Party has no right under the Contracts (Rights of Third Parties) Act 1999 to rely on or enforce any term of this Agreement but this does not affect any right or remedy of a third party which exists or is available apart from under that act.");
    ɵɵelementEnd();
    ɵɵelementStart(433, "h2");
    ɵɵtext(434, "22. COSTS");
    ɵɵelementEnd();
    ɵɵelementStart(435, "p");
    ɵɵtext(436, "Each Party shall bear its own costs and expenses in connection with the negotiation, preparation, execution, and performance of this Agreement and any documents referred to in it.");
    ɵɵelementEnd();
    ɵɵelementStart(437, "h2");
    ɵɵtext(438, "23. COUNTERPARTS");
    ɵɵelementEnd();
    ɵɵelementStart(439, "p");
    ɵɵtext(440, "This Agreement may be executed in any number of counterparts, each of which, when executed and delivered, shall be an original, and all the counterparts together shall constitute one and the same document.");
    ɵɵelementEnd();
    ɵɵelementStart(441, "h2");
    ɵɵtext(442, "24. COMPLIANCE");
    ɵɵelementEnd();
    ɵɵelementStart(443, "p");
    ɵɵtext(444, "Each Party shall abide by and comply with all applicable laws and regulations, including but not limited to those relating to data protection, discrimination and anti-bribery and anti-corruption (including but not limited to, the UK Bribery Act 2010, the U.S. Foreign Corrupt Practices Act 1977 and any other anti-corruption laws and regulations) in relation to this Agreement.");
    ɵɵelementEnd();
    ɵɵelementStart(445, "p");
    ɵɵelementStart(446, "span", 13);
    ɵɵtext(447, "The Licensee shall comply with the Licensor\u2019s Business Code of Practice which may be in published form from time to time, a copy of which ");
    ɵɵelementEnd();
    ɵɵtext(448, "may be obtained at:");
    ɵɵelementEnd();
    ɵɵelementStart(449, "p");
    ɵɵelementStart(450, "a", 14);
    ɵɵtext(451, "https://www.atlascopcogroup.com/en/sustainability/our-business-code-of-practice/download");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(452, "h2");
    ɵɵtext(453, "25. GOVERNING LAW");
    ɵɵelementEnd();
    ɵɵelementStart(454, "p");
    ɵɵtext(455, "25.1 This Agreement and any dispute or claim arising out of or in connection with it or its subject matter or formation (including non-contractual disputes or claims) shall be governed by and construed in accordance with the laws of England and Wales.");
    ɵɵelementEnd();
    ɵɵelementStart(456, "p");
    ɵɵtext(457, "25.2 The Courts of England shall have non-exclusive jurisdiction over any disputes arising under this Agreement.");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("width", 550)("height", 500);
} }
class FooterComponent {
    constructor() {
        this.creditsPopUpVisible = false;
        this.tandCPopUpVisible = false;
    }
    ngOnInit() {
    }
}
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
FooterComponent.ɵcmp = ɵɵdefineComponent({ type: FooterComponent, selectors: [["lib-footer"]], decls: 13, vars: 12, consts: [[1, "footer"], [1, "footerlinks"], [3, "click"], [1, "footer_logo", 2, "background-image", "url(assets/img/logo-footer.svg)"], [1, "copyrightnotice"], ["title", "Credits", 1, "popup", 2, "padding", "0px", 3, "width", "height", "showTitle", "closeOnOutsideClick", "visible", "visibleChange"], ["style", "padding:0px", 4, "dxTemplate", "dxTemplateOf"], ["title", "Terms and Conditions Of Use", 1, "popup", 2, "padding", "0px", 3, "width", "height", "showTitle", "closeOnOutsideClick", "visible", "visibleChange"], [2, "padding", "0px"], [2, "padding", "20px", "text-align", "justify", "background-color", "#EAEAEB", 3, "width", "height"], ["border", "0", "width", "574", "cellspacing", "0", "cellpadding", "0"], ["width", "227"], ["width", "347"], ["lang", "EN-US"], ["href", "https://www.atlascopcogroup.com/en/sustainability/our-business-code-of-practice/download", "target", "_blank"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "footer", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵlistener("click", function FooterComponent_Template_div_click_2_listener() { return ctx.tandCPopUpVisible = !ctx.tandCPopUpVisible; });
        ɵɵtext(3, "Terms and Conditions");
        ɵɵelementEnd();
        ɵɵelementStart(4, "div", 2);
        ɵɵlistener("click", function FooterComponent_Template_div_click_4_listener() { return ctx.creditsPopUpVisible = !ctx.creditsPopUpVisible; });
        ɵɵtext(5, "Credits");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(6, "div", 3);
        ɵɵelementStart(7, "div", 4);
        ɵɵtext(8, "\u00A9 2019 Copyright. All rights reserved.");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(9, "dx-popup", 5);
        ɵɵlistener("visibleChange", function FooterComponent_Template_dx_popup_visibleChange_9_listener($event) { return ctx.creditsPopUpVisible = $event; });
        ɵɵtemplate(10, FooterComponent_div_10_Template, 15, 0, "div", 6);
        ɵɵelementEnd();
        ɵɵelementStart(11, "dx-popup", 7);
        ɵɵlistener("visibleChange", function FooterComponent_Template_dx_popup_visibleChange_11_listener($event) { return ctx.tandCPopUpVisible = $event; });
        ɵɵtemplate(12, FooterComponent_div_12_Template, 458, 2, "div", 6);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(9);
        ɵɵproperty("width", 300)("height", 400)("showTitle", true)("closeOnOutsideClick", true)("visible", ctx.creditsPopUpVisible);
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "content");
        ɵɵadvance(1);
        ɵɵproperty("width", 600)("height", 600)("showTitle", true)("closeOnOutsideClick", true)("visible", ctx.tandCPopUpVisible);
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "content");
    } }, directives: [DxPopupComponent, DxTemplateDirective, DxScrollViewComponent], styles: [".footer[_ngcontent-%COMP%]{background-color:#c4262e;color:#fff;flex-shrink:0;height:40px;text-align:center}.footer_logo[_ngcontent-%COMP%]{background-position:50%;background-repeat:no-repeat;background-size:contain;float:left;height:80%;transform:translateY(12%);width:45%}.footerlinks[_ngcontent-%COMP%]{color:#fff;float:left;justify-content:center;vertical-align:middle;width:30%}.footerlinks[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{float:left;line-height:35px;padding-left:5px;padding-right:20px}.footerlinks[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:hover{color:#828789}.copyrightnotice[_ngcontent-%COMP%]{color:#fff;float:right;line-height:35px;padding-right:10px;text-align:right;width:20%}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'lib-footer',
                templateUrl: './footer.component.html',
                styleUrls: ['./footer.component.css']
            }]
    }], function () { return []; }, null); })();

class RestDataService {
    constructor(http) {
        this.http = http;
    }
    get(fromUrl) {
        return this.http.get(fromUrl).pipe(catchError(this.handleError('get')));
    }
    put(toUrl, data) {
        return this.http.put(toUrl, data).pipe(catchError(this.handleError('get')));
    }
    post(toUrl, data) {
        return this.http.post(toUrl, data).pipe(catchError(this.handleError('get')));
    }
    handleError(operation = 'operation') {
        return (error) => {
            console.error(error);
            throw error;
        };
    }
    addIdToURL(id, url) {
        return url.replace('<id>', id);
    }
}
RestDataService.ɵfac = function RestDataService_Factory(t) { return new (t || RestDataService)(ɵɵinject(HttpClient)); };
RestDataService.ɵprov = ɵɵdefineInjectable({ token: RestDataService, factory: RestDataService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RestDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

class User {
}
//Manages the "claimed" user from a login and the user id in the pumpCalcApi
class UserService {
    constructor(restDataService, environment) {
        this.restDataService = restDataService;
        this.environment = environment;
        console.log(environment);
    }
    getUserId() {
        return this.user ? this.user.userId : null;
    }
    getRootCollectionId() {
        return this.rootCollectionId;
    }
    setRootCollectionId(rootCollectionId) {
        this.rootCollectionId = rootCollectionId;
    }
    getUserForEmail(email) {
        if (this.user)
            return of(this.user);
        return this.restDataService.get((this.environment.app_config ? this.environment.app_config.userURL : this.environment.userURL) + "/" + email).pipe(tap(user => { this.user = user; }));
    }
    createUser(user) {
        return this.restDataService.post(this.environment.app_config ? this.environment.app_config.userURL : this.environment.userURL, this.user).pipe(tap(user => { this.user = user; }));
    }
    getUser() {
        return this.user;
    }
    setUser() {
        return this.user;
    }
    setUserDetailsClaim(email, firstName, surName) {
        this.userDetailsClaim = {
            email: email,
            firstName: firstName,
            surName: surName,
        };
    }
    checkUserIsSetUp(email) {
        return new Promise((resolve) => {
            //if user already set, return quickly
            if (this.user) {
                resolve(true);
                return;
            }
            //otherwise check
            this.getUserForEmail(email).subscribe(result => {
                resolve(true);
            }, error => {
                if (error.status == "404") {
                    this.createUser({ userId: null, email: email, firstName: "", surName: "" }).subscribe(result => {
                        resolve(true);
                    }, error => {
                        console.log("Unable to create new user");
                        resolve(false);
                    });
                }
            });
        });
    }
}
UserService.ɵfac = function UserService_Factory(t) { return new (t || UserService)(ɵɵinject(RestDataService), ɵɵinject('app_config')); };
UserService.ɵprov = ɵɵdefineInjectable({ token: UserService, factory: UserService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UserService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: RestDataService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['app_config']
            }] }]; }, null); })();

class Quantity {
}
Quantity.PRESSURE = "Pressure";
Quantity.SPEED = "Speed";
Quantity.THROUGHPUT = "Throughput";
Quantity.POWER = "Power";
Quantity.FREQUENCY = "Frequency";
Quantity.LENGTH = "Length";
Quantity.XDIM = "XDim";
Quantity.THROUGHPUT_MASS_FLOW = "Throughput Mass Flow";
Quantity.THROUGHPUT_MOLAR_FLOW = "Throughput Molar Flow";
Quantity.VOLUME = "Volume";
Quantity.AREA = "Area";
Quantity.TIME = "Time";
Quantity.TEMPERATURE = "Temperature";
Quantity.OUTGASSING = "Outgassing";
class Preset {
}
Preset.PRESET_EUROPEAN = "European";
Preset.PRESET_US = "US";
Preset.PRESET_SI = "SI";
Preset.PRESET_CUSTOM = "Custom";
Preset.PRESET_EUROPEAN_SETTINGS = [
    [Quantity.THROUGHPUT, 'mbar\u00B7m\u00B3/h'],
    [Quantity.PRESSURE, 'mbar'],
    [Quantity.SPEED, 'm\u00B3/h'],
    [Quantity.XDIM, 'mm'],
    [Quantity.LENGTH, 'm'],
    [Quantity.FREQUENCY, 'Hz'],
    [Quantity.THROUGHPUT_MOLAR_FLOW, 'slm'],
    [Quantity.THROUGHPUT_MASS_FLOW, 'kg/s'],
    [Quantity.VOLUME, 'l'],
    [Quantity.TEMPERATURE, '°C'],
    [Quantity.TIME, 's'],
    [Quantity.AREA, 'm²'],
    [Quantity.POWER, 'W'],
    [Quantity.OUTGASSING, 'mbar.l/s/cm²'],
];
Preset.PRESET_US_SETTINGS = [
    [Quantity.THROUGHPUT, 'Torr\u00B7ft\u00B3/min'],
    [Quantity.PRESSURE, 'Torr'],
    [Quantity.SPEED, 'ft\u00B3/min'],
    [Quantity.XDIM, 'in'],
    [Quantity.LENGTH, 'ft'],
    [Quantity.FREQUENCY, 'Hz'],
    [Quantity.THROUGHPUT_MOLAR_FLOW, 'slm'],
    [Quantity.THROUGHPUT_MASS_FLOW, 'lb/hr'],
    [Quantity.VOLUME, 'ft³'],
    [Quantity.TEMPERATURE, '°C'],
    [Quantity.TIME, 's'],
    [Quantity.AREA, 'ft²'],
    [Quantity.POWER, 'W'],
    [Quantity.OUTGASSING, 'mbar.l/s/cm²'],
];
Preset.PRESET_SI_SETTINGS = [
    [Quantity.THROUGHPUT, 'Pa\u00B7m\u00B3/s'],
    [Quantity.PRESSURE, 'Pa'],
    [Quantity.SPEED, 'm\u00B3/s'],
    [Quantity.XDIM, 'm'],
    [Quantity.LENGTH, 'm'],
    [Quantity.FREQUENCY, 'Hz'],
    [Quantity.THROUGHPUT_MOLAR_FLOW, 'mol/s'],
    [Quantity.THROUGHPUT_MASS_FLOW, 'kg/s'],
    [Quantity.VOLUME, 'm³'],
    [Quantity.TEMPERATURE, 'K'],
    [Quantity.TIME, 's'],
    [Quantity.AREA, 'm²'],
    [Quantity.POWER, 'W'],
    [Quantity.OUTGASSING, 'Pa.m/s'],
];
class UnitSetting {
}

class UnitsService {
    constructor(systemOfUnits, userService, restDataService, environment) {
        this.systemOfUnits = systemOfUnits;
        this.userService = userService;
        this.restDataService = restDataService;
        this.environment = environment;
        this.unitChangeAnnouncedSource = new Subject();
        this.unitChangeAnnounced = this.unitChangeAnnouncedSource.asObservable();
        this.unitServiceStateSource = new Subject();
        this.unitServiceState = this.unitServiceStateSource.asObservable();
        this.checkedSavedSettings = false;
        this.savedSettings = false;
        this.presetSettings = new Map();
        this.preset = Preset;
        this.quantityPipe = new QuantityPipe(systemOfUnits);
        this.presetSettings = new Map();
        this.presetSettings.set(Preset.PRESET_EUROPEAN, Preset.PRESET_EUROPEAN_SETTINGS);
        this.presetSettings.set(Preset.PRESET_US, Preset.PRESET_US_SETTINGS);
        this.presetSettings.set(Preset.PRESET_SI, Preset.PRESET_SI_SETTINGS);
        this.unitsUrl = this.environment.app_config ? this.environment.app_config.unitsURL : this.environment.unitsURL;
        //this.setAsPreset(Preset.PRESET_SI);
    }
    setAsPreset(preset, silent) {
        if (preset != Preset.PRESET_CUSTOM) {
            this.presetSettings.get(preset).forEach(setting => {
                this.setUnitForQuantity(setting[0], setting[1]);
            });
        }
        this.flushSystemOfUnits();
        this.unitSetting.preset = preset;
        if (silent)
            return;
        this.unitChangeAnnouncedSource.next({ quantityName: "all", fromUnit: null, toUnit: null });
    }
    getUnitsForQuantity(quantityName) {
        let units = [];
        this.systemOfUnits.quantities.find(quantity => { return quantity.name === quantityName; }).units.forEach(unit => { units.push(unit.symbol); });
        return units;
    }
    getSelectedUnitForQuantity(quantityName) {
        if (!quantityName)
            return "";
        return this.systemOfUnits.quantities.find(quantity => { return quantity.name === quantityName; }).unit.symbol;
    }
    setUnitForQuantity(quantityName, unit, intialisingCustomPreset) {
        if (this.getSelectedUnitForQuantity(quantityName) != unit && !intialisingCustomPreset) {
            this.setAsPreset("Custom");
        }
        this.systemOfUnits.selectUnit(this.systemOfUnits.quantities.find(quantity => { return quantity.name === quantityName; }), unit);
    }
    flushSystemOfUnits() {
        this.unitSetting = {
            _id: this.unitSetting && this.unitSetting._id ? this.unitSetting._id : null,
            pressure: this.getSelectedUnitForQuantity(Quantity.PRESSURE),
            throughput: this.getSelectedUnitForQuantity(Quantity.THROUGHPUT),
            throughputMolarFlow: this.getSelectedUnitForQuantity(Quantity.THROUGHPUT_MOLAR_FLOW),
            throughputMassFlow: this.getSelectedUnitForQuantity(Quantity.THROUGHPUT_MASS_FLOW),
            frequency: this.getSelectedUnitForQuantity(Quantity.FREQUENCY),
            power: this.getSelectedUnitForQuantity(Quantity.POWER),
            length: this.getSelectedUnitForQuantity(Quantity.LENGTH),
            xDim: this.getSelectedUnitForQuantity(Quantity.XDIM),
            speed: this.getSelectedUnitForQuantity(Quantity.SPEED),
            preset: this.unitSetting && this.unitSetting.preset ? this.unitSetting.preset : null,
            area: this.getSelectedUnitForQuantity(Quantity.AREA),
            volume: this.getSelectedUnitForQuantity(Quantity.VOLUME),
            time: this.getSelectedUnitForQuantity(Quantity.TIME),
            temperature: this.getSelectedUnitForQuantity(Quantity.TEMPERATURE),
            outgassing: this.getSelectedUnitForQuantity(Quantity.OUTGASSING),
        };
    }
    convertFromSIForQuantity(quantityName, value) {
        return this.systemOfUnits.get(quantityName).fromBase(value);
    }
    convertToSIForQuantity(quantityName, value) {
        return this.systemOfUnits.get(quantityName).toBase(value);
    }
    setUnitForQuantityAndAnnounce(quantityName, unit) {
        let fromUnit = this.getSelectedUnitForQuantity(quantityName);
        this.setUnitForQuantity(quantityName, unit, true);
        this.setAsPreset(this.getPresetForUnitSelection(), true);
        this.announceUnitChange({ quantityName: quantityName, fromUnit: fromUnit, toUnit: unit });
    }
    // convertValueFromGivenUnitToSI(quantityName: string, givenUnitName: string, value: number): number {
    //   let unit: any = this.systemOfUnits.get(quantityName).findUnit(givenUnitName);
    //   if (unit && unit.factor != 0) {
    //     return (value + unit.offset) / unit.factor;
    //   } else {
    //     return null;
    //   }
    // }
    // convertValueFromGivenUnitToSelectedUnit(quantityName: string, givenUnitName: string, value: number): number {
    //   let valueInSI = this.convertValueFromGivenUnitToSI(quantityName, givenUnitName, value);
    //   if (valueInSI) {
    //     return this.convertFromSIForQuantity(quantityName, valueInSI);
    //   } else {
    //     return null;
    //   }
    // }
    init() {
        return this.hasSavedSettings().pipe(map(hasSettings => {
            if (hasSettings) {
                return of(this.unitSetting);
            }
            else {
                this.setAsPreset("European");
                this.unitServiceStateSource.next("ready");
            }
        }));
        // .catch(err => {
        //   console.log(err);
        //   throw (err);
        // })
    }
    saveSettings() {
        this.flushSystemOfUnits();
        this.savedSettings = true;
        if (this.unitSetting._id) {
            return this.putUnitSetting(this.unitSetting, this.userService.getUserId()).pipe(map(result => { return this.unitSetting; }));
        }
        else {
            this.unitSetting.userId = this.userService.getUserId();
            return this.postUnitSetting(this.unitSetting).pipe(map(result => { this.unitSetting = result; this.savedSettings = true; return this.unitSetting; }));
        }
    }
    hasSavedSettings() {
        if (this.checkedSavedSettings) {
            return of(this.savedSettings);
        }
        return this.getUnitSetting(this.userService.getUserId()).pipe(map((unitSetting) => {
            this.savedSettings = true;
            this.checkedSavedSettings = true;
            this.unitSetting = unitSetting;
            if (this.unitSetting.preset == Preset.PRESET_CUSTOM) {
                this.setUnitForQuantity(Quantity.PRESSURE, this.unitSetting.pressure, true);
                this.setUnitForQuantity(Quantity.THROUGHPUT, this.unitSetting.throughput, true);
                this.setUnitForQuantity(Quantity.THROUGHPUT_MOLAR_FLOW, this.unitSetting.throughputMolarFlow, true);
                this.setUnitForQuantity(Quantity.THROUGHPUT_MASS_FLOW, this.unitSetting.throughputMassFlow, true);
                this.setUnitForQuantity(Quantity.FREQUENCY, this.unitSetting.frequency, true);
                this.setUnitForQuantity(Quantity.POWER, this.unitSetting.power, true);
                this.setUnitForQuantity(Quantity.LENGTH, this.unitSetting.length, true);
                this.setUnitForQuantity(Quantity.XDIM, this.unitSetting.xDim, true);
                this.setUnitForQuantity(Quantity.SPEED, this.unitSetting.speed, true);
                this.setUnitForQuantity(Quantity.AREA, this.unitSetting.area, true);
                this.setUnitForQuantity(Quantity.VOLUME, this.unitSetting.volume, true);
                this.setUnitForQuantity(Quantity.TIME, this.unitSetting.time, true);
                this.setUnitForQuantity(Quantity.TEMPERATURE, this.unitSetting.temperature, true);
                this.setUnitForQuantity(Quantity.POWER, this.unitSetting.power, true);
                this.setUnitForQuantity(Quantity.OUTGASSING, this.unitSetting.outgassing, true);
            }
            else {
                this.setAsPreset(this.unitSetting.preset);
            }
            this.unitServiceStateSource.next("ready");
            this.unitChangeAnnouncedSource.next({ quantityName: "all", fromUnit: null, toUnit: null });
            return this.savedSettings;
        })
        // .catch(err => {
        //   this.checkedSavedSettings = true;
        //   //if no unit setting then create and save one
        //   if (err.status && err.status == 404) {
        //     this.savedSettings = false;
        //     return of(false);
        //   }
        //   else throw (err);
        // })
        );
    }
    getPreset() {
        return this.unitSetting ? this.unitSetting.preset : null;
    }
    getPresetForUnitSelection() {
        let result = Preset.PRESET_CUSTOM;
        Array.from(this.presetSettings.keys()).forEach(preset => {
            let match = true;
            this.presetSettings.get(preset).forEach(setting => {
                if (this.getSelectedUnitForQuantity(setting[0]) != setting[1]) {
                    match = false;
                    return;
                }
            });
            if (match) {
                result = preset;
            }
            ;
            return;
        });
        return result;
    }
    getThroughPutUnitAsSpeedxPressure() {
        let throughputUnits = this.getUnitsForQuantity(Quantity.THROUGHPUT);
        let selectedThroughputUnit = null;
        throughputUnits.forEach(unit => {
            if (selectedThroughputUnit) {
                return;
            }
            if (unit.indexOf(this.getSelectedUnitForQuantity(Quantity.SPEED)) > -1 && unit.indexOf(this.getSelectedUnitForQuantity(Quantity.PRESSURE)) > -1) {
                selectedThroughputUnit = unit;
            }
        });
        return selectedThroughputUnit;
    }
    postUnitSetting(unitSetting) {
        return this.restDataService.post(this.unitsUrl, unitSetting);
    }
    putUnitSetting(unitSetting, userID) {
        return this.restDataService.put(this.unitsUrl + "/" + userID, unitSetting);
    }
    getUnitSetting(userID) {
        return this.restDataService.get(this.unitsUrl + '/' + userID);
    }
    reload() {
        this.checkedSavedSettings = false;
        this.savedSettings = false;
        return this.init();
    }
    announceUnitChange(change) {
        this.unitChangeAnnouncedSource.next(change);
    }
}
UnitsService.PRESETS = [Preset.PRESET_EUROPEAN, Preset.PRESET_US, Preset.PRESET_SI, Preset.PRESET_CUSTOM];
UnitsService.quantity = Quantity;
UnitsService.ɵfac = function UnitsService_Factory(t) { return new (t || UnitsService)(ɵɵinject(SystemOfUnits), ɵɵinject(UserService), ɵɵinject(RestDataService), ɵɵinject('app_config')); };
UnitsService.ɵprov = ɵɵdefineInjectable({ token: UnitsService, factory: UnitsService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UnitsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: SystemOfUnits }, { type: UserService }, { type: RestDataService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['app_config']
            }] }]; }, null); })();

class FormattingService {
    constructor() { }
    formatNumber(value) {
        if (value == null) {
            return "";
        }
        let abv = Math.abs(value);
        let result = "" + value;
        if (abv >= 1 && abv <= 10000) {
            result = value.toFixed(3);
        }
        else if (abv > 10000) {
            result = value.toExponential(3);
        }
        else if (abv == 0) {
            result = value.toFixed(1);
        }
        else if (abv < 0.01) {
            result = value.toExponential(3);
        }
        else if (abv < 1) {
            result = value.toFixed(4);
        }
        return result;
    }
    truncate(value, decimalPlaces) {
        return value.toString().match(new RegExp('^-?\\d+(?:\.\\d{0,' + decimalPlaces + '})?', "i"))[0];
    }
    parseNumber(value) {
        return parseFloat(value.replace(/[^0-9.e|e+|e-]/g, ""));
    }
    isNumber(value) {
        if (typeof value !== 'number') {
            return false;
        }
        if (value !== Number(value)) {
            return false;
        }
        if (value === Infinity) {
            return false;
        }
        return true;
    }
}
FormattingService.ɵfac = function FormattingService_Factory(t) { return new (t || FormattingService)(); };
FormattingService.ɵprov = ɵɵdefineInjectable({ token: FormattingService, factory: FormattingService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FormattingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function NumberFieldComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 8);
    ɵɵelementStart(1, "dx-select-box", 9);
    ɵɵlistener("onValueChanged", function NumberFieldComponent_div_0_div_3_Template_dx_select_box_onValueChanged_1_listener($event) { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(2); return ctx_r3.throughPutQuantityChanged($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("dataSource", ctx_r2.throughPutQuantities)("searchEnabled", false)("value", ctx_r2.throughPutQuantity);
} }
function NumberFieldComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵtemplate(3, NumberFieldComponent_div_0_div_3_Template, 2, 3, "div", 4);
    ɵɵelementStart(4, "div", 5);
    ɵɵelementStart(5, "dx-number-box", 6);
    ɵɵlistener("valueChange", function NumberFieldComponent_div_0_Template_dx_number_box_valueChange_5_listener($event) { ɵɵrestoreView(_r6); const ctx_r5 = ɵɵnextContext(); return ctx_r5.displayValue = $event; })("onValueChanged", function NumberFieldComponent_div_0_Template_dx_number_box_onValueChanged_5_listener() { ɵɵrestoreView(_r6); const ctx_r7 = ɵɵnextContext(); return ctx_r7.announceChange(); })("onKeyDown", function NumberFieldComponent_div_0_Template_dx_number_box_onKeyDown_5_listener($event) { ɵɵrestoreView(_r6); const ctx_r8 = ɵɵnextContext(); return ctx_r8.keyDown($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 7);
    ɵɵtext(7);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ctx_r0.label, "");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.offerQuantitySelectionForThroughput);
    ɵɵadvance(2);
    ɵɵproperty("step", 0)("min", ctx_r0.min)("disabled", ctx_r0.disabled)("readOnly", ctx_r0.readonly)("value", ctx_r0.displayValue);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r0.unit);
} }
function NumberFieldComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r1.error);
} }
class NumberFieldComponent {
    constructor(unitsService, formattingService) {
        this.unitsService = unitsService;
        this.formattingService = formattingService;
        this.min = 0;
        this.visible = true;
        this.valueChange = new EventEmitter();
        this.valueChangeWithQuantity = new EventEmitter();
        this.isInteger = false;
        this.offerQuantitySelectionForThroughput = false;
        this.belowZeroTemperatures = false;
        this.throughPutQuantities = [
            { id: "as Throughput", value: Quantity.THROUGHPUT },
            { id: "as Mass Flow", value: Quantity.THROUGHPUT_MASS_FLOW },
            { id: "as Molar Flow", value: Quantity.THROUGHPUT_MOLAR_FLOW }
        ];
        this.throughPutQuantity = this.throughPutQuantities[0];
        this.unitsService.unitChangeAnnounced.subscribe(event => {
            this.updateView();
        });
    }
    ngOnChanges(changes) {
        if (changes["quantity"]) {
            this.updateView();
        }
        else if (this.value != this.lastInputChange) {
            this.updateView();
        }
    }
    updateView() {
        this.updateUnit();
        this.setMin();
        this.displayValue = this.quantity && this.value ? this.unitsService.convertFromSIForQuantity(this.quantity, this.value) : this.value;
    }
    updateUnit() {
        this.unit = this.quantity ? this.unitsService.getSelectedUnitForQuantity(this.quantity) : null;
        if (this.offerQuantitySelectionForThroughput) {
            this.throughPutQuantities.forEach(option => {
                this.throughPutQuantity = option.value == this.quantity ? option : this.throughPutQuantity;
            });
        }
    }
    announceChange() {
        this.lastInputChange = this.quantity ? this.unitsService.convertToSIForQuantity(this.quantity, this.displayValue) : this.displayValue;
        this.value = this.lastInputChange;
        if (this.offerQuantitySelectionForThroughput) {
            this.announceChangeWithQuantity();
            return;
        }
        this.valueChange.emit(this.value);
    }
    keyDown(e) {
        if (!this.isInteger) {
            return;
        }
        const event = e.event;
        const str = event.key || String.fromCharCode(event.which);
        if (/^[.,e]$/.test(str)) {
            event.preventDefault();
        }
    }
    throughPutQuantityChanged(event) {
        this.quantity = event.value.value;
        this.unit = this.quantity ? this.unitsService.getSelectedUnitForQuantity(this.quantity) : null;
        this.announceChange();
    }
    announceChangeWithQuantity() {
        this.valueChangeWithQuantity.emit({ quantity: this.quantity, value: this.value });
    }
    setMin() {
        this.min = this.belowZeroTemperatures &&
            (this.quantity == Quantity.TEMPERATURE && this.unitsService.getSelectedUnitForQuantity(Quantity.TEMPERATURE) != "K") ?
            undefined : this.min;
    }
}
NumberFieldComponent.ɵfac = function NumberFieldComponent_Factory(t) { return new (t || NumberFieldComponent)(ɵɵdirectiveInject(UnitsService), ɵɵdirectiveInject(FormattingService)); };
NumberFieldComponent.ɵcmp = ɵɵdefineComponent({ type: NumberFieldComponent, selectors: [["lib-number-field"]], inputs: { label: "label", value: "value", error: "error", quantity: "quantity", disabled: "disabled", readonly: "readonly", min: "min", visible: "visible", isInteger: "isInteger", offerQuantitySelectionForThroughput: "offerQuantitySelectionForThroughput", belowZeroTemperatures: "belowZeroTemperatures" }, outputs: { valueChange: "valueChange", valueChangeWithQuantity: "valueChangeWithQuantity" }, features: [ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "pcc-field", 4, "ngIf"], ["class", "pcc-field-error", 4, "ngIf"], [1, "pcc-field"], [1, "pcc-field-label"], ["class", "number-field-with-quantity-quantity", 4, "ngIf"], [1, "pcc-field-value"], ["width", "100", 3, "step", "min", "disabled", "readOnly", "value", "valueChange", "onValueChanged", "onKeyDown"], [1, "pcc-field-unit"], [1, "number-field-with-quantity-quantity"], ["displayExpr", "id", 3, "dataSource", "searchEnabled", "value", "onValueChanged"], [1, "pcc-field-error"]], template: function NumberFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, NumberFieldComponent_div_0_Template, 8, 8, "div", 0);
        ɵɵtemplate(1, NumberFieldComponent_div_1_Template, 2, 1, "div", 1);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.visible);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.error && ctx.visible);
    } }, directives: [NgIf, DxNumberBoxComponent, DxSelectBoxComponent], styles: [".number-field-with-quantity-quantity[_ngcontent-%COMP%]{width:220px}.number-field-with-quantity-prefix[_ngcontent-%COMP%]{padding-left:10px;padding-right:10px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NumberFieldComponent, [{
        type: Component,
        args: [{
                selector: 'lib-number-field',
                templateUrl: './number-field.component.html',
                styleUrls: ['./number-field.component.css']
            }]
    }], function () { return [{ type: UnitsService }, { type: FormattingService }]; }, { label: [{
            type: Input
        }], value: [{
            type: Input
        }], error: [{
            type: Input
        }], quantity: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }], min: [{
            type: Input
        }], visible: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], valueChangeWithQuantity: [{
            type: Output
        }], isInteger: [{
            type: Input
        }], offerQuantitySelectionForThroughput: [{
            type: Input
        }], belowZeroTemperatures: [{
            type: Input
        }] }); })();

class Pipe {
    constructor(id) {
        this.bends = 0;
        this.flexible = false;
        this.length = 0;
        this.parallel = 1;
        this.section = "Circular";
        this.xdim1 = 0;
        this.xdim2 = 0;
        this.entrance = false;
        this.id = id ? id : null;
        this.selected = false;
        this.bends = 0.0;
        this.flexible = false;
        this.length = 0.0;
        this.parallel = 1.0;
        this.section = "Circular";
        this.xdim1 = 0.0;
        this.xdim2 = 0.0;
        this.entrance = false;
    }
}
class Gas {
}
class DatatypesService {
    constructor() { }
}
DatatypesService.ɵfac = function DatatypesService_Factory(t) { return new (t || DatatypesService)(); };
DatatypesService.ɵprov = ɵɵdefineInjectable({ token: DatatypesService, factory: DatatypesService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DatatypesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["dropdown"];
function StandardPipeSelectorComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "dx-tree-view", 3);
    ɵɵlistener("onItemSelectionChanged", function StandardPipeSelectorComponent_div_2_Template_dx_tree_view_onItemSelectionChanged_1_listener($event) { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(); return ctx_r3.selectPipe($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("dataSource", ctx_r1.pipes)("selectByClick", true);
} }
class StandardPipeSelectorComponent {
    constructor() {
        this.onPipeSelect = new EventEmitter();
        this.str_8 = String.fromCharCode(0x215B);
        this.str_4 = String.fromCharCode(0xBC);
        this.str_2 = String.fromCharCode(0xBD);
        this.str_3_8 = String.fromCharCode(0x215C);
        this.str_3_4 = String.fromCharCode(0xBE);
        this.str_inch = '"';
        this.pipes = [
            { id: '1', category: "ISO", text: "ISO" },
            { id: '1_1', category: "ISO", text: "ISO63", diameter: 0.070, parentId: 1 },
            { id: '1_2', category: "ISO", text: "ISO80", diameter: 0.083, parentId: 1 },
            { id: '1_3', category: "ISO", text: "ISO100", diameter: 0.102, parentId: 1 },
            { id: '1_4', category: "ISO", text: "ISO160", diameter: 0.153, parentId: 1 },
            { id: '1_5', category: "ISO", text: "ISO200", diameter: 0.213, parentId: 1 },
            { id: '1_6', category: "ISO", text: "ISO250", diameter: 0.261, parentId: 1 },
            { id: '1_7', category: "ISO", text: "ISO320", diameter: 0.318, parentId: 1 },
            { id: '1_8', category: "ISO", text: "ISO400", diameter: 0.400, parentId: 1 },
            { id: '1_9', category: "ISO", text: "ISO500", diameter: 0.501, parentId: 1 },
            { id: '2', category: "NW", text: "NW" },
            { id: '2_1', category: "NW", text: "NW10", diameter: 0.010, parentId: 2 },
            { id: '2_2', category: "NW", text: "NW16", diameter: 0.016, parentId: 2 },
            { id: '2_3', category: "NW", text: "NW20", diameter: 0.021, parentId: 2 },
            { id: '2_4', category: "NW", text: "NW25", diameter: 0.024, parentId: 2 },
            { id: '2_5', category: "NW", text: "NW32 ", diameter: 0.034, parentId: 2 },
            { id: '2_6', category: "NW", text: "NW40 Edwards Catalogue (40.5 mm) ", diameter: 0.0405, parentId: 2 },
            { id: '2_7', category: "NW", text: "NW40 Common US Value (35 mm)", diameter: 0.035, parentId: 2 },
            { id: '2_8', category: "NW", text: "NW50", diameter: 0.051, parentId: 2 },
            { id: '3', category: "JIS A B", text: "JIS A B" },
            { id: '3_1', category: "JIS A B ", text: "6A " + this.str_8 + "B", diameter: 0.0081, parentId: 3 },
            { id: '3_2', category: "JIS A B ", text: "8A " + this.str_4 + "B", diameter: 0.0104, parentId: 3 },
            { id: '3_3', category: "JIS A B ", text: "10A " + this.str_3_8 + "B", diameter: 0.0139, parentId: 3 },
            { id: '3_4', category: "JIS A B ", text: "15A " + this.str_2 + "B", diameter: 0.0175, parentId: 3 },
            { id: '3_5', category: "JIS A B ", text: "20A " + this.str_3_4 + "B", diameter: 0.023, parentId: 3 },
            { id: '3_6', category: "JIS A B ", text: "25A 1B' ", diameter: 0.0284, parentId: 3 },
            { id: '3_7', category: "JIS A B ", text: "32A 1" + this.str_4 + "B", diameter: 0.0371, parentId: 3 },
            { id: '3_8', category: "JIS A B ", text: "40A 1" + this.str_2 + "B", diameter: 0.043, parentId: 3 },
            { id: '3_9', category: "JIS A B ", text: "50A 2B", diameter: 0.0549, parentId: 3 },
            { id: '3_10', category: "JIS A B ", text: "65A 2" + this.str_2 + "B", diameter: 0.0703, parentId: 3 },
            { id: '3_11', category: "JIS A B ", text: "80A 3B", diameter: 0.0831, parentId: 3 },
            { id: '3_12', category: "JIS A B ", text: "90A 3" + this.str_2 + "B", diameter: 0.0956, parentId: 3 },
            { id: '3_13', category: "JIS A B ", text: "100A 4B", diameter: 0.1083, parentId: 3 },
            { id: '3_14', category: "JIS A B ", text: "125A 5B", diameter: 0.133, parentId: 3 },
            { id: '3_15', category: "JIS A B ", text: " 150A 6B", diameter: 0.1584, parentId: 3 },
            { id: '3_16', category: "JIS A B ", text: " 200A 8B", diameter: 0.2083, parentId: 3 },
            { id: '3_17', category: "JIS A B ", text: " 250A 10B", diameter: 0.2594, parentId: 3 },
            { id: '3_18', category: "JIS A B ", text: "300A 12B", diameter: 0.03095, parentId: 3 },
            { id: '3_19', category: "JIS A B ", text: "350A 14B", diameter: 0.3456, parentId: 3 },
            { id: '3_20', category: "JIS A B ", text: "400A 16B", diameter: 0.3964, parentId: 3 },
            { id: '3_21', category: "JIS A B ", text: "450A 18B", diameter: 0.4472, parentId: 3 },
            { id: '3_22', category: "JIS A B ", text: "500A 20B", diameter: 0.497, parentId: 3 },
            { id: '3_23', category: "JIS A B ", text: "550A 22B", diameter: 0.5478, parentId: 3 },
            { id: '3_24', category: "JIS A B ", text: "600A 24B", diameter: 0.5966, parentId: 3 },
            { id: '3_25', category: "JIS A B ", text: "650A 26B", diameter: 0.6444, parentId: 3 },
            { id: '3_26', category: "JIS A B ", text: "700A 28B", diameter: 0.6952, parentId: 3 },
            { id: '3_27', category: "JIS A B ", text: "750A 30B", diameter: 0.746, parentId: 3 },
            { id: '3_28', category: "JIS A B ", text: "800A 32B", diameter: 0.7968, parentId: 3 },
            { id: '3_29', category: "JIS A B ", text: "850A 34B", diameter: 0.8476, parentId: 3 },
            { id: '3_30', category: "JIS A B ", text: "900A 36B", diameter: 0.8984, parentId: 3 },
            { id: '3_31', category: "JIS A B ", text: "1000A 40B", diameter: 0.997, parentId: 3 },
            { id: '4', category: "VG", text: "VG" },
            { id: '4_1', category: "VG", text: "VG20", diameter: 0.0257, parentId: 4 },
            { id: '4_2', category: "VG", text: "VG25", diameter: 0.0325, parentId: 4 },
            { id: '4_3', category: "VG", text: "VG40", diameter: 0.0471, parentId: 4 },
            { id: '4_4', category: "VG", text: "VG50", diameter: 0.059, parentId: 4 },
            { id: '4_5', category: "VG", text: "VG65", diameter: 0.0743, parentId: 4 },
            { id: '4_6', category: "VG", text: "VG80", diameter: 0.0871, parentId: 4 },
            { id: '4_7', category: "VG", text: "VG100", diameter: 0.1123, parentId: 4 },
            { id: '4_8', category: "VG", text: "VG125", diameter: 0.1368, parentId: 4 },
            { id: '4_9', category: "VG", text: "VG150", diameter: 0.1622, parentId: 4 },
            { id: '4_10', category: "VG", text: "VG200", diameter: 0.2133, parentId: 4 },
            { id: '4_11', category: "VG", text: "VG250", diameter: 0.2644, parentId: 4 },
            { id: '4_12', category: "VG", text: "VG300", diameter: 0.3145, parentId: 4 },
            { id: '4_13', category: "VG", text: "VG350", diameter: 0.3516, parentId: 4 },
            { id: '4_14', category: "VG", text: "VG400", diameter: 0.4024, parentId: 4 },
            { id: '5', category: "ANSI", text: "ANSI" },
            { id: '5_1', category: "ANSI", text: this.str_8 + this.str_inch, diameter: 0.0068326, parentId: 5 },
            { id: '5_2', category: "ANSI", text: this.str_4 + this.str_inch, diameter: 0.0092456, parentId: 5 },
            { id: '5_3', category: "ANSI", text: this.str_3_8 + this.str_inch, diameter: 0.0125222, parentId: 5 },
            { id: '5_4', category: "ANSI", text: this.str_2 + this.str_inch, diameter: 0.0157988, parentId: 5 },
            { id: '5_5', category: "ANSI", text: this.str_3_4 + this.str_inch, diameter: 0.0209296, parentId: 5 },
            { id: '5_6', category: "ANSI", text: "1" + this.str_inch, diameter: 0.0266446, parentId: 5 },
            { id: '5_7', category: "ANSI", text: "1" + this.str_4 + this.str_inch, diameter: 0.035052, parentId: 5 },
            { id: '5_8', category: "ANSI", text: "1" + this.str_2 + this.str_inch, diameter: 0.040894, parentId: 5 },
            { id: '5_9', category: "ANSI", text: "2" + this.str_inch, diameter: 0.0525018, parentId: 5 },
            { id: '5_10', category: "ANSI", text: "2" + this.str_2 + this.str_inch, diameter: 0.0627126, parentId: 5 },
            { id: '5_11', category: "ANSI", text: "3" + this.str_inch, diameter: 0.0779272, parentId: 5 },
            { id: '5_12', category: "ANSI", text: "3" + this.str_2 + this.str_inch, diameter: 0.0901192, parentId: 5 },
            { id: '5_13', category: "ANSI", text: "4" + this.str_inch, diameter: 0.1022604, parentId: 5 },
            { id: '5_14', category: "ANSI", text: "5" + this.str_inch, diameter: 0.1281938, parentId: 5 },
            { id: '5_15', category: "ANSI", text: "6" + this.str_inch, diameter: 0.154051, parentId: 5 },
            { id: '5_16', category: "ANSI", text: "8" + this.str_inch, diameter: 0.2027174, parentId: 5 },
            { id: '5_17', category: "ANSI", text: "10" + this.str_inch, diameter: 0.254508, parentId: 5 },
            { id: '5_18', category: "ANSI", text: "12" + this.str_inch, diameter: 0.3048, parentId: 5 },
            { id: '6', category: "DN", text: "DN" },
            { id: '6_1', category: "DN", text: "DN6", diameter: 0.00782, parentId: 6 },
            { id: '6_2', category: "DN", text: "DN8", diameter: 0.0104, parentId: 6 },
            { id: '6_3', category: "DN", text: "DN10", diameter: 0.0138, parentId: 6 },
            { id: '6_4', category: "DN", text: "DN15", diameter: 0.01708, parentId: 6 },
            { id: '6_5', category: "DN", text: "DN20", diameter: 0.02248, parentId: 6 },
            { id: '6_6', category: "DN", text: "DN25", diameter: 0.02786, parentId: 6 },
            { id: '6_7', category: "DN", text: "DN32", diameter: 0.03666, parentId: 6 },
            { id: '6_8', category: "DN", text: "DN40", diameter: 0.04276, parentId: 6 },
            { id: '6_9', category: "DN", text: "DN50", diameter: 0.05476, parentId: 6 },
            { id: '6_10', category: "DN", text: "DN65", diameter: 0.0669, parentId: 6 },
            { id: '6_11', category: "DN", text: "DN80", diameter: 0.0828, parentId: 6 },
            { id: '6_12', category: "DN", text: "DN90", diameter: 0.0955, parentId: 6 },
            { id: '6_13', category: "DN", text: "DN100", diameter: 0.1082, parentId: 6 },
            { id: '6_14', category: "DN", text: "DN125", diameter: 0.1345, parentId: 6 },
            { id: '6_15', category: "DN", text: "DN150", diameter: 0.01615, parentId: 6 },
            { id: '6_16', category: "DN", text: "DN200", diameter: 0.21158, parentId: 6 },
            { id: '6_17', category: "DN", text: "DN250", diameter: 0.26472, parentId: 6 },
            { id: '6_18', category: "DN", text: "DN300", diameter: 0.31476, parentId: 6 },
            { id: '6_19', category: "DN", text: "DN350", diameter: 0.34604, parentId: 6 },
            { id: '6_20', category: "DN", text: "DN400", diameter: 0.39684, parentId: 6 },
            { id: '6_21', category: "DN", text: "DN450", diameter: 0.44764, parentId: 6 },
            { id: '6_22', category: "DN", text: "DN500", diameter: 0.49692, parentId: 6 },
            { id: '6_23', category: "DN", text: "DN600", diameter: 0.5969, parentId: 6 },
            { id: '6_24', category: "DN", text: "DN750", diameter: 0.74294, parentId: 6 },
            { id: '6_25', category: "DN", text: "DN900", diameter: 0.89534, parentId: 6 }
        ];
    }
    selectPipe($event) {
        if (!$event.itemData.diameter) {
            return;
        }
        this.selectedPipe = $event.component.getSelectedNodeKeys();
        this.onPipeSelect.emit($event.itemData);
        this.dropdown.instance.close();
    }
    clearSelection() {
        this.selectedPipe = null;
    }
}
StandardPipeSelectorComponent.ɵfac = function StandardPipeSelectorComponent_Factory(t) { return new (t || StandardPipeSelectorComponent)(); };
StandardPipeSelectorComponent.ɵcmp = ɵɵdefineComponent({ type: StandardPipeSelectorComponent, selectors: [["lib-standard-pipe-selector"]], viewQuery: function StandardPipeSelectorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.dropdown = _t.first);
    } }, outputs: { onPipeSelect: "onPipeSelect" }, decls: 3, vars: 3, consts: [["valueExpr", "id", "displayExpr", "text", "placeholder", "Select...", 3, "value", "dataSource", "valueChange"], ["dropdown", ""], [4, "dxTemplate", "dxTemplateOf"], ["dataStructure", "plain", "keyExpr", "id", "parentIdExpr", "parentId", "selectionMode", "single", "displayExpr", "text", 3, "dataSource", "selectByClick", "onItemSelectionChanged"]], template: function StandardPipeSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-drop-down-box", 0, 1);
        ɵɵlistener("valueChange", function StandardPipeSelectorComponent_Template_dx_drop_down_box_valueChange_0_listener($event) { return ctx.selectedPipe = $event; });
        ɵɵtemplate(2, StandardPipeSelectorComponent_div_2_Template, 2, 2, "div", 2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("value", ctx.selectedPipe)("dataSource", ctx.pipes);
        ɵɵadvance(2);
        ɵɵproperty("dxTemplateOf", "content");
    } }, directives: [DxDropDownBoxComponent, DxTemplateDirective, DxTreeViewComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(StandardPipeSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'lib-standard-pipe-selector',
                templateUrl: './standard-pipe-selector.component.html',
                styleUrls: ['./standard-pipe-selector.component.css']
            }]
    }], function () { return []; }, { onPipeSelect: [{
            type: Output
        }], dropdown: [{
            type: ViewChild,
            args: ["dropdown", { static: true }]
        }] }); })();

class DataCacheService {
    constructor() {
        this.cache = [];
    }
    put(name, data) {
        this.cache[name] = data;
    }
    get(name) {
        return this.cache[name] ? this.cache[name] : null;
    }
}
DataCacheService.ɵfac = function DataCacheService_Factory(t) { return new (t || DataCacheService)(); };
DataCacheService.ɵprov = ɵɵdefineInjectable({ token: DataCacheService, factory: DataCacheService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DataCacheService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class GasService {
    constructor(dataCacheService, restDataService, environment) {
        this.dataCacheService = dataCacheService;
        this.restDataService = restDataService;
        this.environment = environment;
    }
    getGases() {
        if (this.dataCacheService.get("gases")) {
            return of(this.dataCacheService.get("gases"));
        }
        return this.restDataService.get(this.environment.app_config ? this.environment.app_config.gasUrl : this.environment.gasUrl)
            .pipe(tap(gases => this.dataCacheService.put("gases", gases)));
    }
}
GasService.ɵfac = function GasService_Factory(t) { return new (t || GasService)(ɵɵinject(DataCacheService), ɵɵinject(RestDataService), ɵɵinject('app_config')); };
GasService.ɵprov = ɵɵdefineInjectable({ token: GasService, factory: GasService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GasService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DataCacheService }, { type: RestDataService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['app_config']
            }] }]; }, null); })();

class GasSelectorComponent {
    constructor(gasService) {
        this.gasService = gasService;
        this.valueChange = new EventEmitter();
        this.gases = [];
        this.placeholder = "Loading..";
    }
    ngAfterViewChecked() {
        setTimeout(() => {
            this.gasService.getGases().subscribe(gases => {
                this.gases = gases;
                this.gasId = this.gases[0].id;
                this.lastSelectedGas = this.gases[0];
                this.placeholder = "Select";
            });
        });
    }
    ngOnInit() {
    }
    valueChanged() {
        this.valueChange.emit({ gas: this.lastSelectedGas, temperature: this.temperature });
    }
    gasSelectionChanged($event) {
        this.lastSelectedGas = $event.selectedItem;
        this.valueChanged();
    }
}
GasSelectorComponent.ɵfac = function GasSelectorComponent_Factory(t) { return new (t || GasSelectorComponent)(ɵɵdirectiveInject(GasService)); };
GasSelectorComponent.ɵcmp = ɵɵdefineComponent({ type: GasSelectorComponent, selectors: [["lib-gas-selector"]], inputs: { error: "error", temperature: "temperature" }, outputs: { valueChange: "valueChange" }, decls: 3, vars: 7, consts: [["displayExpr", "name", "valueExpr", "id", 3, "dataSource", "searchEnabled", "placeholder", "value", "onSelectionChanged"], [2, "padding-top", "20px"], ["label", "Temperature", "quantity", "Temperature", 3, "belowZeroTemperatures", "error", "value", "valueChange"]], template: function GasSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-select-box", 0);
        ɵɵlistener("onSelectionChanged", function GasSelectorComponent_Template_dx_select_box_onSelectionChanged_0_listener($event) { return ctx.gasSelectionChanged($event); });
        ɵɵelementEnd();
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "lib-number-field", 2);
        ɵɵlistener("valueChange", function GasSelectorComponent_Template_lib_number_field_valueChange_2_listener($event) { ctx.temperature = $event; return ctx.valueChanged(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("dataSource", ctx.gases)("searchEnabled", true)("placeholder", ctx.placeholder)("value", ctx.gasId);
        ɵɵadvance(2);
        ɵɵproperty("belowZeroTemperatures", true)("error", ctx.error)("value", ctx.temperature);
    } }, directives: [DxSelectBoxComponent, NumberFieldComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GasSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'lib-gas-selector',
                templateUrl: './gas-selector.component.html',
                styleUrls: ['./gas-selector.component.css']
            }]
    }], function () { return [{ type: GasService }]; }, { valueChange: [{
            type: Output
        }], error: [{
            type: Input
        }], temperature: [{
            type: Input
        }] }); })();

const xdim = {
    name: 'XDim',
    units: {
        'm': [1],
        'cm': [100],
        'mm': [1000],
        'in': [1000 / 25.4],
        'ft': [1000 / 12 / 25.4],
    },
};
const area = {
    name: 'Area',
    units: {
        'm²': [1],
        'cm²': [10000],
        'ft²': [10.7639]
    },
};
const frequency = {
    name: 'Frequency',
    units: {
        'Hz': [1],
        //'kHz': [1e-3],
        //'MHz': [1e-6],
        'rpm': [60],
    },
};
const volume = {
    name: 'Volume',
    units: {
        'm³': [1],
        'cm³': [1000000],
        'mm³': [1000000000],
        'l': [1000],
        'ft³': [35.3147]
    },
};
const time = {
    name: 'Time',
    units: {
        's': [1],
        'min': [1 / 60],
        'h': [1 / 3600],
    },
};
const throughput = {
    name: 'Throughput',
    units: {
        'Pa\u00B7m\u00B3/s': [1.0],
        'Pa\u00B7m\u00B3/h': [3600],
        'Pa\u00B7l/s ': [1000],
        'mbar\u00B7l/s': [10.0],
        'mbar\u00B7m\u00B3/h': [3600 / 100],
        'mbar\u00B7m\u00B3/s': [1 / 100],
        'Torr\u00B7m\u00B3/h': [7.501e-03 * 3600],
        'Torr\u00B7m\u00B3/s': [7.501e-03],
        'Torr\u00B7ft\u00B3/min': [7.501e-03 * 35.315 * 60],
        'Torr\u00B7ft\u00B3/h': [7.501e-03 * 35.315 * 3600],
        'mTorr\u00B7l/s': [7.501e-03 * 1000 * 1000],
        'mTorr\u00B7ft\u00B3/min': [7.501e-03 * 1000 * 35.315 * 60],
    },
};
const temperature = {
    name: 'Temperature',
    units: {
        'K': [1],
        '°C': [1, 273.15],
        '°F': [1.8, (273.15 * 1.8) - 32],
    },
};
const speed = {
    name: 'Speed',
    units: {
        'm\u00B3/s': [1.0],
        'l/s': [1000.0],
        'l/min': [1000.0 * 60],
        'm\u00B3/min': [60.0],
        'm\u00B3/h': [3600.0],
        'ft\u00B3/min': [35.3147 * 60],
        'ft\u00B3/h': [35.3147 * 3600],
    },
};
const pressure = {
    name: 'Pressure',
    units: {
        'Pa': [1],
        'bar': [1e-5],
        'mbar': [1e-2],
        'Torr': [760 / 101325],
        'mTorr': [760000 / 101325],
        'psia': [1.450E-04],
        'inHg': [760 / 101325 / 25.4],
    },
};
const power = {
    name: 'Power',
    units: {
        'W': [1],
        'kW': [1e-3],
    },
};
const outgassing = {
    name: 'Outgassing',
    units: {
        'Pa.m/s': [1.0],
        'mbar.l/s/cm²': [0.001],
    },
};
const molarflow = {
    name: 'Throughput Molar Flow',
    units: {
        //taken from pumpcalc desktop unit coverter
        'mol/s': [1.0],
        'slm': [1344.829],
        'sccm': [1.345E+06],
    },
};
const massflow = {
    name: 'Throughput Mass Flow',
    units: {
        'kg/s': [1.0],
        'kg/min': [60.0],
        'kg/hr': [3600.0],
        'lb/hr': [7936.641],
    },
};
const mass = {
    name: 'Mass',
    units: {
        'g': [1e3],
        'kg': [1],
        't': [1e-3],
    },
};
const length = {
    name: 'Length',
    units: {
        'm': [1],
        'cm': [100],
        'mm': [1000],
        'in': [1000 / 25.4],
        'ft': [1000 / 12 / 25.4],
    },
};
function systemOfUnitsInitializer() {
    return {
        quantities: [pressure, frequency, throughput, power, speed, length, xdim, molarflow, massflow, volume, area, time, temperature, outgassing],
    };
}

function StatusBarComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "dx-load-indicator", 5);
    ɵɵelementStart(2, "span", 6);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(3);
    ɵɵtextInterpolate1("", ctx_r2.status.message, " ");
} }
function StatusBarComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "span", 7);
    ɵɵtext(2, "\u26A0");
    ɵɵelementEnd();
    ɵɵelementStart(3, "span", 8);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(4);
    ɵɵtextInterpolate1(" ", ctx_r3.status.message, " ");
} }
function StatusBarComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 9);
    ɵɵelement(1, "span", 10);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ctx_r4.status.message, ɵɵsanitizeHtml);
} }
function StatusBarComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 2);
    ɵɵtemplate(1, StatusBarComponent_div_0_div_1_Template, 4, 1, "div", 3);
    ɵɵtemplate(2, StatusBarComponent_div_0_div_2_Template, 5, 1, "div", 3);
    ɵɵtemplate(3, StatusBarComponent_div_0_div_3_Template, 2, 1, "div", 4);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.status.state == "loading");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.status.state == "warning");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.status.state == "info");
} }
function StatusBarComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "dx-load-indicator", 12);
    ɵɵelementStart(2, "span", 13);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", ctx_r5.status.message, " ");
} }
function StatusBarComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "span", 14);
    ɵɵtext(2, "\u26A0");
    ɵɵelementEnd();
    ɵɵelementStart(3, "span", 8);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(4);
    ɵɵtextInterpolate1(" ", ctx_r6.status.message, " ");
} }
function StatusBarComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 9);
    ɵɵelement(1, "span", 10);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ctx_r7.status.message, ɵɵsanitizeHtml);
} }
function StatusBarComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 11);
    ɵɵtemplate(1, StatusBarComponent_div_1_div_1_Template, 4, 1, "div", 3);
    ɵɵtemplate(2, StatusBarComponent_div_1_div_2_Template, 5, 1, "div", 3);
    ɵɵtemplate(3, StatusBarComponent_div_1_div_3_Template, 2, 1, "div", 4);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.status.state == "loading");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.status.state == "warning");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.status.state == "info");
} }
class StatusBarComponent {
    constructor() { }
}
StatusBarComponent.ɵfac = function StatusBarComponent_Factory(t) { return new (t || StatusBarComponent)(); };
StatusBarComponent.ɵcmp = ɵɵdefineComponent({ type: StatusBarComponent, selectors: [["status-bar"]], inputs: { status: "status", size: "size" }, decls: 2, vars: 2, consts: [["style", "font-size: 18px; line-height:18px", 4, "ngIf"], ["style", "font-size: 14px; line-height:14px", 4, "ngIf"], [2, "font-size", "18px", "line-height", "18px"], [4, "ngIf"], ["style", "white-space: pre", 4, "ngIf"], ["id", "medium-indicator", "height", "25", "width", "25", 2, "vertical-align", "middle"], [2, "padding-top", "10px", "padding-left", "10px"], [2, "font-size", "22px", "vertical-align", "middle", "color", "red"], [2, "vertical-align", "middle", "color", "red"], [2, "white-space", "pre"], [2, "white-space", "pre", 3, "innerHTML"], [2, "font-size", "14px", "line-height", "14px"], ["id", "medium-indicator", "height", "16", "width", "16", 2, "vertical-align", "middle"], [2, "padding-top", "10px"], [2, "font-size", "14px", "vertical-align", "middle", "color", "red"]], template: function StatusBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, StatusBarComponent_div_0_Template, 4, 3, "div", 0);
        ɵɵtemplate(1, StatusBarComponent_div_1_Template, 4, 3, "div", 1);
    } if (rf & 2) {
        ɵɵproperty("ngIf", !ctx.size || ctx.size == "");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.size == "small");
    } }, directives: [NgIf, DxLoadIndicatorComponent], styles: ["[_nghost-%COMP%]     strong{color:red;font-weight:400}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(StatusBarComponent, [{
        type: Component,
        args: [{
                selector: 'status-bar',
                templateUrl: './status-bar.component.html',
                styleUrls: ['./status-bar.component.css']
            }]
    }], function () { return []; }, { status: [{
            type: Input
        }], size: [{
            type: Input
        }] }); })();

class UIEvent {
}
class UIEventsService {
    constructor() {
        this.UiEventSource = new Subject();
        this.UiEvents = this.UiEventSource.asObservable();
    }
}
UIEventsService.ɵfac = function UIEventsService_Factory(t) { return new (t || UIEventsService)(); };
UIEventsService.ɵprov = ɵɵdefineInjectable({ token: UIEventsService, factory: UIEventsService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UIEventsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0$1 = ["grid"];
function PipeworkComponent_dxi_column_29_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "dxi-column", 29);
} if (rf & 2) {
    ɵɵproperty("allowEditing", true)("allowSorting", false);
} }
function PipeworkComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "input", 30);
    ɵɵlistener("change", function PipeworkComponent_div_33_Template_input_change_1_listener($event) { ɵɵrestoreView(_r10); const cellInfo_r8 = ctx.$implicit; const ctx_r9 = ɵɵnextContext(); return ctx_r9.toggleValue($event, cellInfo_r8, "flexible"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const cellInfo_r8 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("checked", cellInfo_r8.value);
} }
function PipeworkComponent_div_34_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "input", 30);
    ɵɵlistener("change", function PipeworkComponent_div_34_Template_input_change_1_listener($event) { ɵɵrestoreView(_r13); const cellInfo_r11 = ctx.$implicit; const ctx_r12 = ɵɵnextContext(); return ctx_r12.toggleValue($event, cellInfo_r11, "entrance"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const cellInfo_r11 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("checked", cellInfo_r11.value);
} }
function PipeworkComponent_div_35_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "input", 30);
    ɵɵlistener("change", function PipeworkComponent_div_35_Template_input_change_1_listener($event) { ɵɵrestoreView(_r16); const cellInfo_r14 = ctx.$implicit; const ctx_r15 = ɵɵnextContext(); return ctx_r15.toggleValue($event, cellInfo_r14, "selected"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const cellInfo_r14 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("checked", cellInfo_r14.value);
} }
function PipeworkComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "span");
    ɵɵelementStart(2, "input", 31);
    ɵɵlistener("click", function PipeworkComponent_div_36_Template_input_click_2_listener($event) { ɵɵrestoreView(_r19); const cellInfo_r17 = ctx.$implicit; const ctx_r18 = ɵɵnextContext(); return ctx_r18.addAtRow($event, cellInfo_r17); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const cellInfo_r17 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵproperty("checked", cellInfo_r17.value);
} }
function PipeworkComponent_div_37_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "span");
    ɵɵelementStart(2, "input", 32);
    ɵɵlistener("click", function PipeworkComponent_div_37_Template_input_click_2_listener($event) { ɵɵrestoreView(_r22); const cellInfo_r20 = ctx.$implicit; const ctx_r21 = ɵɵnextContext(); return ctx_r21.removeRow($event, cellInfo_r20); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const cellInfo_r20 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵproperty("checked", cellInfo_r20.value);
} }
function PipeworkComponent_div_39_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const distinctError_r23 = ctx.$implicit;
    const ctx_r7 = ɵɵnextContext();
    ɵɵstyleProp("color", ctx_r7.distinctErrors[distinctError_r23].level > 1 ? "orange" : "red");
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", distinctError_r23, " ");
} }
class PipeworkComponent {
    constructor(unitsService, uiEventsService) {
        this.unitsService = unitsService;
        this.uiEventsService = uiEventsService;
        //pipes = pipes in si unit
        this.pipes = [];
        this.errors = [];
        this.listChanged = new EventEmitter();
        this.pipeClick = new EventEmitter();
        this.editing = new EventEmitter();
        this.fields = ['bends', 'flexible', 'length', 'parallel', 'section', 'xdim1', 'xdim2', 'entrance'];
        //pipesInSelectedUnits = pipes in selected unit
        this.pipesInSelectedUnits = [];
        this.sections = [{ name: 'Circular' }, { name: 'Annular' }, { name: 'Rectangular' }];
        this.distinctErrors = {};
        this.distinctErrorKeys = [];
        this.buttonText = "Add";
        this.tick = String.fromCharCode(0x2713);
        this.editState = false;
        this.unitsService.unitChangeAnnounced.subscribe((change => {
            this.setPipesToSelectedUnit();
        }));
    }
    ngOnChanges(changes) {
        this.init();
    }
    ngOnInit() {
        this.init();
    }
    init() {
        this.setPipesToSelectedUnit();
        this.setErrorSummary();
    }
    setPipesToSelectedUnit() {
        this.pipesInSelectedUnits = this.clone(this.pipes);
        this.pipesInSelectedUnits.forEach(pipe => {
            pipe.xdim1 = this.unitsService.convertFromSIForQuantity(Quantity.XDIM, pipe.xdim1);
            pipe.xdim2 = this.unitsService.convertFromSIForQuantity(Quantity.XDIM, pipe.xdim2);
            pipe.length = this.unitsService.convertFromSIForQuantity(Quantity.LENGTH, pipe.length);
        });
    }
    unitSymbolForQuantity(quantity) {
        return this.unitsService.getSelectedUnitForQuantity(quantity);
    }
    toggleValue(event, cellInfo, key) {
        this.pipesInSelectedUnits.forEach((_pipe, index) => {
            if (_pipe.id == cellInfo.key) {
                _pipe[key] = !_pipe[key];
                this.copyPipeInSelectedUnitValuesToPipeInSiUnit(_pipe, this.pipes[index]);
            }
        });
        if (key == 'selected') {
            this.selectPipes();
        }
        this.announceChange();
    }
    addAtRow(event, cellInfo) {
        this.pipesInSelectedUnits.splice(cellInfo.rowIndex + 1, 0, new Pipe(this.pipes.length + 1 + ""));
        this.pipes.splice(cellInfo.rowIndex + 1, 0, new Pipe(this.pipes.length + 1 + ""));
        this.announceChange();
    }
    removeRow($event, cellInfo) {
        this.pipesInSelectedUnits.splice(cellInfo.rowIndex, 1);
        this.pipes.splice(cellInfo.rowIndex, 1);
        this.announceChange();
    }
    copyPipeInSelectedUnitValuesToPipeInSiUnit(pipeinSelectedUnit, pipeInSIUnit) {
        pipeInSIUnit.bends = pipeinSelectedUnit.bends;
        pipeInSIUnit.entrance = pipeinSelectedUnit.entrance;
        pipeInSIUnit.parallel = pipeinSelectedUnit.parallel;
        pipeInSIUnit.xdim1 = this.unitsService.convertToSIForQuantity(Quantity.XDIM, pipeinSelectedUnit.xdim1);
        pipeInSIUnit.xdim2 = pipeinSelectedUnit.xdim2 + "" == "" ? 0 : this.unitsService.convertToSIForQuantity(Quantity.XDIM, pipeinSelectedUnit.xdim2);
        pipeInSIUnit.length = this.unitsService.convertToSIForQuantity(Quantity.LENGTH, pipeinSelectedUnit.length);
        pipeInSIUnit.section = pipeinSelectedUnit.section;
        pipeInSIUnit.selected = pipeinSelectedUnit.selected;
        pipeInSIUnit.flexible = pipeinSelectedUnit.flexible;
    }
    setErrorSummary() {
        this.distinctErrors = {};
        this.distinctErrorKeys = [];
        if (!this.errors)
            return;
        this.errors.forEach(error => {
            this.distinctErrors[error.message] = error.level;
        });
        this.distinctErrorKeys = Object.keys(this.distinctErrors);
    }
    applyStandardSize() {
        if (this.buttonText == "Change Selected") {
            this.pipesInSelectedUnits.forEach(function (pipeinSelectedUnit, index) {
                if (pipeinSelectedUnit.selected) {
                    pipeinSelectedUnit.xdim1 = this.unitsService.convertFromSIForQuantity(Quantity.XDIM, this.standardSizeSelection.diameter);
                }
                pipeinSelectedUnit.section = "Circular";
                this.copyPipeInSelectedUnitValuesToPipeInSiUnit(pipeinSelectedUnit, this.pipes[index]);
            }.bind(this));
        }
        else {
            let newPipe = new Pipe(this.pipes.length + 1 + "");
            newPipe.xdim1 = this.standardSizeSelection.diameter;
            newPipe.section = "Circular";
            this.pipes.push(newPipe);
            this.setPipesToSelectedUnit();
        }
        this.announceChange();
    }
    selectPipes() {
        this.buttonText = "Add";
        this.pipesInSelectedUnits.forEach(pipe => {
            if (pipe.selected) {
                this.buttonText = "Change Selected";
                return;
            }
        });
    }
    setStandardSizeSelection(standardSizeSelection) {
        this.standardSizeSelection = standardSizeSelection;
    }
    selectRowToEdit(index) {
        this.grid.instance.editCell(index, "section");
    }
    cellPrepared($event) {
        if ($event.column.dataField == "xdim2" && $event.row && $event.row.data.section == "Circular") {
            $event.row.data.xdim2 = null;
            $event.cellElement.style.background = "#EAF4F5";
            $event.cellElement.style.color = "#EAF4F5";
        }
        if (($event.column.dataField == "length" ||
            $event.column.dataField == "xdim2" ||
            $event.column.dataField == "xdim1") && this.errors && this.errors.length > 0 && $event.row) {
            this.errors.forEach(error => {
                if (error.rowIndex == $event.row.dataIndex && error.dataField == $event.column.dataField) {
                    $event.cellElement.style.background = error.level && error.level > 1 ? "#ffdccc" : "#FFD0D0";
                }
            });
        }
    }
    editorPreparing(event) {
        this.setEditState(true);
        this.lastEditedKey = event.row.dataIndex;
        if (event.component.cellValue(event.row.rowIndex, "Section") == "Circular" && event.dataField == "xdim2") {
            event.editorOptions.readOnly = "true";
        }
        event.editorOptions.onFocusOut = (event) => {
            this.copyPipeInSelectedUnitValuesToPipeInSiUnit(this.pipesInSelectedUnits[this.lastEditedKey], this.pipes[this.lastEditedKey]);
            this.announceChange();
        };
        event.editorElement.parentElement.parentElement.style.background = "#fbe6b7";
        this.pipeClick.emit(this.pipes[event.row.rowIndex]);
    }
    onRowUpdated(event) {
        if (event.data.section != "Circular" && event.data.xdim2 == null) {
            this.setValueForPipe("xdim2", 0, this.pipesInSelectedUnits, event.data.id);
            this.setValueForPipe("xdim2", 0, this.pipes, event.data.id);
        }
        this.pipes.forEach(pipe => {
            if (pipe.id == event.key) {
                this.copyPipeInSelectedUnitValuesToPipeInSiUnit(event.data, pipe);
            }
        });
        this.announceChange();
    }
    setValueForPipe(key, value, inPipes, forId) {
        inPipes.forEach(pipe => { if (pipe.id == forId) {
            pipe[key] = value;
        } ; return; });
    }
    announceChange() {
        this.listChanged.emit(this.pipes);
        this.setEditState(false);
    }
    clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    applyChanges() {
    }
    setEditState(state) {
        this.editState = state;
        this.editing.emit(this.editState);
    }
    showField(fieldName) {
        return this.fields.indexOf(fieldName) != -1;
    }
}
PipeworkComponent.ɵfac = function PipeworkComponent_Factory(t) { return new (t || PipeworkComponent)(ɵɵdirectiveInject(UnitsService), ɵɵdirectiveInject(UIEventsService)); };
PipeworkComponent.ɵcmp = ɵɵdefineComponent({ type: PipeworkComponent, selectors: [["lib-pipework"]], viewQuery: function PipeworkComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$1, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.grid = _t.first);
    } }, inputs: { pipes: "pipes", errors: "errors", fields: "fields" }, outputs: { listChanged: "listChanged", pipeClick: "pipeClick", editing: "editing" }, features: [ɵɵNgOnChangesFeature], decls: 40, vars: 36, consts: [[1, "pcc-field"], [1, "pcc-field-label"], [1, "pcc-field-text-value"], [2, "float", "left"], [3, "onPipeSelect"], [3, "text", "disabled", "onClick"], ["id", "gridContainer", "keyExpr", "id", 2, "padding-top", "10px", "font-size", "100%", 3, "dataSource", "onRowUpdated", "onCellPrepared", "onEditorPreparing"], ["grid", ""], [3, "enabled"], ["mode", "cell", 3, "allowUpdating"], ["width", "110", "dataField", "section", "caption", "Section", 3, "allowSorting"], ["displayExpr", "name", "valueExpr", "name", 3, "dataSource"], ["width", "97", "dataField", "length", "dataType", "number", 3, "caption", "allowSorting"], ["type", "fixedPoint", 3, "precision"], ["width", "97", "dataField", "xdim1", "dataType", "number", 3, "caption", "allowSorting"], ["type", "range", "min", "0", "message", "Must be greater than 0"], ["width", "97", "dataField", "xdim2", "dataType", "number", 3, "caption", "allowSorting"], ["width", "68", "dataField", "parallel", "caption", "Parallel", "dataType", "number", 3, "allowSorting"], ["type", "range", "min", "0.1", "message", "Cannot be less than 0.1"], ["width", "60", "dataField", "bends", "caption", "Bends", "dataType", "number", 3, "allowSorting"], ["type", "range", "min", "0", "message", "Cannot be less than 0"], ["width", "70", "dataField", "flexible", "caption", "Flexible", "cellTemplate", "", "editCellTemplate", "flexibleTemplate", 3, "allowEditing", "allowSorting"], ["width", "80", "dataField", "entrance", "caption", "Entrance", "cellTemplate", "", "editCellTemplate", "entranceTemplate", 3, "allowEditing", "allowSorting", 4, "ngIf"], ["width", "40", "dataField", "", "caption", "", "cellTemplate", "rembuttonTemplate", "editCellTemplate", "buttonTemplate", 3, "allowEditing", "allowSorting"], ["width", "40", "dataField", "", "caption", "", "cellTemplate", "addbuttonTemplate", "editCellTemplate", "buttonTemplate", 3, "allowEditing", "allowSorting"], ["width", "40", "dataField", "selected", "cellTemplate", "", "editCellTemplate", "selectTemplate", 3, "caption", "allowEditing", "allowSorting"], [4, "dxTemplate", "dxTemplateOf"], [2, "padding-top", "20px"], [3, "color", 4, "ngFor", "ngForOf"], ["width", "80", "dataField", "entrance", "caption", "Entrance", "cellTemplate", "", "editCellTemplate", "entranceTemplate", 3, "allowEditing", "allowSorting"], ["type", "checkbox", 2, "transform", "scale(1.6)", 3, "checked", "change"], ["type", "button", "value", "+", 2, "transform", "scale(1.1)", 3, "checked", "click"], ["type", "button", "value", "-", 2, "transform", "scale(1.1)", 3, "checked", "click"]], template: function PipeworkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵtext(2, "Standard Pipe Size");
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", 2);
        ɵɵelementStart(4, "div", 3);
        ɵɵelementStart(5, "lib-standard-pipe-selector", 4);
        ɵɵlistener("onPipeSelect", function PipeworkComponent_Template_lib_standard_pipe_selector_onPipeSelect_5_listener($event) { return ctx.setStandardSizeSelection($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 3);
        ɵɵelementStart(7, "dx-button", 5);
        ɵɵlistener("onClick", function PipeworkComponent_Template_dx_button_onClick_7_listener() { return ctx.applyStandardSize(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "dx-data-grid", 6, 7);
        ɵɵlistener("onRowUpdated", function PipeworkComponent_Template_dx_data_grid_onRowUpdated_8_listener($event) { return ctx.onRowUpdated($event); })("onCellPrepared", function PipeworkComponent_Template_dx_data_grid_onCellPrepared_8_listener($event) { return ctx.cellPrepared($event); })("onEditorPreparing", function PipeworkComponent_Template_dx_data_grid_onEditorPreparing_8_listener($event) { return ctx.editorPreparing($event); });
        ɵɵelement(10, "dxo-paging", 8);
        ɵɵelement(11, "dxo-editing", 9);
        ɵɵelementStart(12, "dxi-column", 10);
        ɵɵelement(13, "dxo-lookup", 11);
        ɵɵelementEnd();
        ɵɵelementStart(14, "dxi-column", 12);
        ɵɵelement(15, "dxo-format", 13);
        ɵɵelementEnd();
        ɵɵelementStart(16, "dxi-column", 14);
        ɵɵelement(17, "dxi-validation-rule", 15);
        ɵɵelement(18, "dxo-format", 13);
        ɵɵelementEnd();
        ɵɵelementStart(19, "dxi-column", 16);
        ɵɵelement(20, "dxo-format", 13);
        ɵɵelement(21, "dxi-validation-rule", 15);
        ɵɵelementEnd();
        ɵɵelementStart(22, "dxi-column", 17);
        ɵɵelement(23, "dxo-format", 13);
        ɵɵelement(24, "dxi-validation-rule", 18);
        ɵɵelementEnd();
        ɵɵelementStart(25, "dxi-column", 19);
        ɵɵelement(26, "dxo-format", 13);
        ɵɵelement(27, "dxi-validation-rule", 20);
        ɵɵelementEnd();
        ɵɵelement(28, "dxi-column", 21);
        ɵɵtemplate(29, PipeworkComponent_dxi_column_29_Template, 1, 2, "dxi-column", 22);
        ɵɵelement(30, "dxi-column", 23);
        ɵɵelement(31, "dxi-column", 24);
        ɵɵelement(32, "dxi-column", 25);
        ɵɵtemplate(33, PipeworkComponent_div_33_Template, 2, 1, "div", 26);
        ɵɵtemplate(34, PipeworkComponent_div_34_Template, 2, 1, "div", 26);
        ɵɵtemplate(35, PipeworkComponent_div_35_Template, 2, 1, "div", 26);
        ɵɵtemplate(36, PipeworkComponent_div_36_Template, 3, 1, "div", 26);
        ɵɵtemplate(37, PipeworkComponent_div_37_Template, 3, 1, "div", 26);
        ɵɵelementEnd();
        ɵɵelementStart(38, "div", 27);
        ɵɵtemplate(39, PipeworkComponent_div_39_Template, 2, 3, "div", 28);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(7);
        ɵɵproperty("text", ctx.buttonText)("disabled", ctx.standardSizeSelection ? false : true);
        ɵɵadvance(1);
        ɵɵproperty("dataSource", ctx.pipesInSelectedUnits);
        ɵɵadvance(2);
        ɵɵproperty("enabled", false);
        ɵɵadvance(1);
        ɵɵproperty("allowUpdating", true);
        ɵɵadvance(1);
        ɵɵproperty("allowSorting", false);
        ɵɵadvance(1);
        ɵɵproperty("dataSource", ctx.sections);
        ɵɵadvance(1);
        ɵɵproperty("caption", "Length/" + ctx.unitSymbolForQuantity("Length"))("allowSorting", false);
        ɵɵadvance(1);
        ɵɵproperty("precision", 2);
        ɵɵadvance(1);
        ɵɵproperty("caption", "XDim1/" + ctx.unitSymbolForQuantity("XDim"))("allowSorting", false);
        ɵɵadvance(2);
        ɵɵproperty("precision", 2);
        ɵɵadvance(1);
        ɵɵproperty("caption", "XDim2/" + ctx.unitSymbolForQuantity("XDim"))("allowSorting", false);
        ɵɵadvance(1);
        ɵɵproperty("precision", 2);
        ɵɵadvance(2);
        ɵɵproperty("allowSorting", false);
        ɵɵadvance(1);
        ɵɵproperty("precision", 1);
        ɵɵadvance(2);
        ɵɵproperty("allowSorting", false);
        ɵɵadvance(1);
        ɵɵproperty("precision", 1);
        ɵɵadvance(2);
        ɵɵproperty("allowEditing", true)("allowSorting", false);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showField("entrance"));
        ɵɵadvance(1);
        ɵɵproperty("allowEditing", true)("allowSorting", false);
        ɵɵadvance(1);
        ɵɵproperty("allowEditing", true)("allowSorting", false);
        ɵɵadvance(1);
        ɵɵproperty("caption", ctx.tick)("allowEditing", true)("allowSorting", false);
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "flexibleTemplate");
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "entranceTemplate");
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "selectTemplate");
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "addbuttonTemplate");
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "rembuttonTemplate");
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ctx.distinctErrorKeys);
    } }, directives: [StandardPipeSelectorComponent, DxButtonComponent, DxDataGridComponent, DxoPagingComponent, DxoEditingComponent, DxiColumnComponent, DxoLookupComponent, DxoFormatComponent, DxiValidationRuleComponent, NgIf, DxTemplateDirective, NgForOf], styles: [".dx-datagrid-revert-tooltip[_ngcontent-%COMP%], .dx-revert-button[_ngcontent-%COMP%],   .dx-datagrid-revert-tooltip{display:none}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PipeworkComponent, [{
        type: Component,
        args: [{
                selector: 'lib-pipework',
                templateUrl: './pipework.component.html',
                styleUrls: ['./pipework.component.css']
            }]
    }], function () { return [{ type: UnitsService }, { type: UIEventsService }]; }, { pipes: [{
            type: Input
        }], errors: [{
            type: Input
        }], listChanged: [{
            type: Output
        }], pipeClick: [{
            type: Output
        }], editing: [{
            type: Output
        }], grid: [{
            type: ViewChild,
            args: ["grid"]
        }], fields: [{
            type: Input
        }] }); })();

class AppEvent {
}
class AppEventService {
    constructor() {
        this.appEventAnnounce = new Subject();
        this.events = this.appEventAnnounce.asObservable();
    }
    emit(appEvent) {
        this.appEventAnnounce.next(appEvent);
    }
}
AppEventService.ɵfac = function AppEventService_Factory(t) { return new (t || AppEventService)(); };
AppEventService.ɵprov = ɵɵdefineInjectable({ token: AppEventService, factory: AppEventService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AppEventService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class LoginService {
    constructor(authService, environment, userService, appEventService) {
        this.authService = authService;
        this.environment = environment;
        this.userService = userService;
        this.appEventService = appEventService;
    }
    getAccount() {
        return this.authService.instance.getAllAccounts()[0];
    }
    login() {
        this.authService.loginRedirect();
    }
    logOut() {
        this.authService.logout();
    }
    startRefreshTokenCycle() {
        this.refreshToken();
        setInterval(function () {
            this.refreshToken();
        }.bind(this), 300000);
    }
    refreshToken() {
        console.log("Refreshing Token .. ");
        try {
            this.authService.instance.acquireTokenSilent({
                account: this.authService.instance.getAllAccounts()[0],
                scopes: ['https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user']
            })
                .then(() => {
                console.log("token refreshed");
            });
        }
        catch (error) {
            console.log(error);
        }
    }
    refreshTokenPromise() {
        return this.authService.instance.acquireTokenSilent({
            account: this.authService.instance.getAllAccounts()[0],
            scopes: ['https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user']
        }).then(() => {
            console.log("token refreshed");
        });
    }
    //checks user logged in and has user record
    getLoginState() {
        return new Promise((resolve) => {
            if (this.getAccount()) {
                this.refreshTokenPromise().then(() => {
                    this.userService.checkUserIsSetUp(this.getAccount().username).then(userSetup => {
                        this.appEventService.emit({ name: "LOGGEDIN" /* LOGGEDIN */, context: "" });
                        resolve(userSetup ? "LOGGEDIN" /* LOGGEDIN */ : "NOUSER" /* NOUSER */);
                    });
                });
            }
            else {
                resolve("NOTLOGGEDIN" /* NOTLOGGEDIN */);
            }
        });
    }
}
LoginService.ɵfac = function LoginService_Factory(t) { return new (t || LoginService)(ɵɵinject(MsalService), ɵɵinject('app_config'), ɵɵinject(UserService), ɵɵinject(AppEventService)); };
LoginService.ɵprov = ɵɵdefineInjectable({ token: LoginService, factory: LoginService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoginService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: MsalService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['app_config']
            }] }, { type: UserService }, { type: AppEventService }]; }, null); })();

function LoginComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 4);
    ɵɵtext(1, " Welcome to PumpCalc\n");
    ɵɵelementEnd();
} }
function LoginComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 4);
    ɵɵelementStart(1, "div", 5);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelement(3, "status-bar", 6);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate1("Welcome to PumpCalc ", ctx_r1.account.username, "");
    ɵɵadvance(1);
    ɵɵproperty("status", ctx_r1.status);
} }
function LoginComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 7);
    ɵɵelementStart(1, "dx-button", 8);
    ɵɵlistener("onClick", function LoginComponent_div_2_Template_dx_button_onClick_1_listener() { ɵɵrestoreView(_r6); const ctx_r5 = ɵɵnextContext(); return ctx_r5.loginService.login(); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function LoginComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 9);
    ɵɵelementStart(1, "div", 5);
    ɵɵtext(2, "Sorry it's taking longer than expected to load your settings. If it looks like it is stuck logging out and logging back in might help. If not please contact support. ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function LoginComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "dx-button", 11);
    ɵɵlistener("onClick", function LoginComponent_div_4_Template_dx_button_onClick_1_listener() { ɵɵrestoreView(_r8); const ctx_r7 = ɵɵnextContext(); return ctx_r7.loginService.logOut(); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
class LoginComponent {
    constructor(loginService, msalBroadcastService) {
        this.loginService = loginService;
        this.msalBroadcastService = msalBroadcastService;
        this.loginStateChange = new EventEmitter();
        this.account = null;
        this.status = { message: 'Loading your saved settings', state: 'loading' };
        this.showLogoutOption = false;
        this.showLoginOption = false;
        this.msalBroadcastService.msalSubject$.subscribe(msg => {
            this.account = this.loginService.getAccount();
            if (msg.eventType === EventType.HANDLE_REDIRECT_END) {
                if (this.account) {
                    this.loginService.getLoginState().then((loginState) => {
                        this.loginState = loginState;
                        this.loginStateChange.next(loginState);
                    });
                }
                else {
                    this.showLoginOption = true;
                }
            }
        });
    }
    ngOnInit() {
        // this.account = this.loginService.getAccount();
        // this.loginService.getLoginState().then((loginState:LoginState)=>{
        //   this.loginState = loginState;
        //   this.loginStateChange.next(loginState);
        // })
        // setTimeout(function(){
        //   this.showLogoutOption = this.account && this.loginState != LoginState.LOGGEDIN;
        // }.bind(this), 10000);
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(ɵɵdirectiveInject(LoginService), ɵɵdirectiveInject(MsalBroadcastService)); };
LoginComponent.ɵcmp = ɵɵdefineComponent({ type: LoginComponent, selectors: [["login"]], outputs: { loginStateChange: "loginStateChange" }, decls: 5, vars: 5, consts: [["style", "width:100%;text-align: center;padding-top: 50px;font-size: 1.3rem;color:#828789", 4, "ngIf"], ["style", "margin: auto;width:100px;padding: 10px; margin-top: 20px;", 4, "ngIf"], ["style", "width:400px;margin:auto; text-align:center;padding-top: 50px;", 4, "ngIf"], ["style", "margin: auto;width:120px;", 4, "ngIf"], [2, "width", "100%", "text-align", "center", "padding-top", "50px", "font-size", "1.3rem", "color", "#828789"], [2, "padding-bottom", "20px"], [3, "status"], [2, "margin", "auto", "width", "100px", "padding", "10px", "margin-top", "20px"], ["text", "Login", 2, "font-size", "1.3rem", 3, "onClick"], [2, "width", "400px", "margin", "auto", "text-align", "center", "padding-top", "50px"], [2, "margin", "auto", "width", "120px"], ["text", "Logout", 2, "font-size", "1.3rem", 3, "onClick"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, LoginComponent_div_0_Template, 2, 0, "div", 0);
        ɵɵtemplate(1, LoginComponent_div_1_Template, 4, 2, "div", 0);
        ɵɵtemplate(2, LoginComponent_div_2_Template, 2, 0, "div", 1);
        ɵɵtemplate(3, LoginComponent_div_3_Template, 3, 0, "div", 2);
        ɵɵtemplate(4, LoginComponent_div_4_Template, 2, 0, "div", 3);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.account == null);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.account != null);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showLoginOption);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showLogoutOption);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showLogoutOption);
    } }, directives: [NgIf, StatusBarComponent, DxButtonComponent], styles: ["[_nghost-%COMP%]     strong{color:red;font-weight:400}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: 'login',
                templateUrl: './login.component.html',
                styleUrls: ['./login.component.css']
            }]
    }], function () { return [{ type: LoginService }, { type: MsalBroadcastService }]; }, { loginStateChange: [{
            type: Output
        }] }); })();

// This component is used only to avoid Angular reload
// when doing acquireTokenSilent()
class MsalComponent {
    constructor() {
    }
}
MsalComponent.ɵfac = function MsalComponent_Factory(t) { return new (t || MsalComponent)(); };
MsalComponent.ɵcmp = ɵɵdefineComponent({ type: MsalComponent, selectors: [["app-root"]], decls: 0, vars: 0, template: function MsalComponent_Template(rf, ctx) { }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MsalComponent, [{
        type: Component,
        args: [{
                selector: 'app-root',
                template: '',
            }]
    }], function () { return []; }, null); })();

function UnitsSelector_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Pressure");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 5, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_2_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r16); const ctx_r15 = ɵɵnextContext(); return ctx_r15.selectionChanged($event, "Pressure"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r0.units["Pressure"])("value", ctx_r0.unitsService.getSelectedUnitForQuantity("Pressure"));
} }
function UnitsSelector_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Speed");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 7, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_3_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r19); const ctx_r18 = ɵɵnextContext(); return ctx_r18.selectionChanged($event, "Speed"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r1.units["Speed"])("value", ctx_r1.unitsService.getSelectedUnitForQuantity("Speed"));
} }
function UnitsSelector_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Throughput");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 8, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_4_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r22); const ctx_r21 = ɵɵnextContext(); return ctx_r21.selectionChanged($event, "Throughput"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r2.units["Throughput"])("value", ctx_r2.unitsService.getSelectedUnitForQuantity("Throughput"));
} }
function UnitsSelector_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Throughput Molar Flow");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 9, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_5_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r25); const ctx_r24 = ɵɵnextContext(); return ctx_r24.selectionChanged($event, "Throughput Molar Flow"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r3.units["Throughput Molar Flow"])("value", ctx_r3.unitsService.getSelectedUnitForQuantity("Throughput Molar Flow"));
} }
function UnitsSelector_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Throughput Mass Flow");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 10, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_6_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r28); const ctx_r27 = ɵɵnextContext(); return ctx_r27.selectionChanged($event, "Throughput Mass Flow"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r4.units["Throughput Mass Flow"])("value", ctx_r4.unitsService.getSelectedUnitForQuantity("Throughput Mass Flow"));
} }
function UnitsSelector_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Frequency");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 11, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_7_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r31); const ctx_r30 = ɵɵnextContext(); return ctx_r30.selectionChanged($event, "Frequency"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r5.units["Frequency"])("value", ctx_r5.unitsService.getSelectedUnitForQuantity("Frequency"));
} }
function UnitsSelector_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Power");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 12, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_8_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r34); const ctx_r33 = ɵɵnextContext(); return ctx_r33.selectionChanged($event, "Power"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r6.units["Power"])("value", ctx_r6.unitsService.getSelectedUnitForQuantity("Power"));
} }
function UnitsSelector_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Length");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 13, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_10_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r37); const ctx_r36 = ɵɵnextContext(); return ctx_r36.selectionChanged($event, "Length"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r7.units["Length"])("value", ctx_r7.unitsService.getSelectedUnitForQuantity("Length"));
} }
function UnitsSelector_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r40 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "XDim");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 14, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_11_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r40); const ctx_r39 = ɵɵnextContext(); return ctx_r39.selectionChanged($event, "XDim"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r8.units["XDim"])("value", ctx_r8.unitsService.getSelectedUnitForQuantity("XDim"));
} }
function UnitsSelector_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r43 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Area");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 15, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_12_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r43); const ctx_r42 = ɵɵnextContext(); return ctx_r42.selectionChanged($event, "Area"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r9.units["Area"])("value", ctx_r9.unitsService.getSelectedUnitForQuantity("Area"));
} }
function UnitsSelector_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r46 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Volume");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 16, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_13_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r46); const ctx_r45 = ɵɵnextContext(); return ctx_r45.selectionChanged($event, "Volume"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r10.units["Volume"])("value", ctx_r10.unitsService.getSelectedUnitForQuantity("Volume"));
} }
function UnitsSelector_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r49 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Time");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 17, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_14_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r49); const ctx_r48 = ɵɵnextContext(); return ctx_r48.selectionChanged($event, "Time"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r11.units["Time"])("value", ctx_r11.unitsService.getSelectedUnitForQuantity("Time"));
} }
function UnitsSelector_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r52 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Temperature");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 17, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_15_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r52); const ctx_r51 = ɵɵnextContext(); return ctx_r51.selectionChanged($event, "Temperature"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r12.units["Temperature"])("value", ctx_r12.unitsService.getSelectedUnitForQuantity("Temperature"));
} }
function UnitsSelector_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r55 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 3);
    ɵɵtext(2, "Outgassing");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "dx-select-box", 18, 6);
    ɵɵlistener("onSelectionChanged", function UnitsSelector_div_16_Template_dx_select_box_onSelectionChanged_4_listener($event) { ɵɵrestoreView(_r55); const ctx_r54 = ɵɵnextContext(); return ctx_r54.selectionChanged($event, "Outgassing"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("dataSource", ctx_r13.units["Outgassing"])("value", ctx_r13.unitsService.getSelectedUnitForQuantity("Outgassing"));
} }
class UnitsSelector {
    constructor(unitsService) {
        this.unitsService = unitsService;
        this.onUnitChange = new EventEmitter();
        // container_css_class = "container";
        this.container_css_class = "";
        this.container_row_class = "";
        this.units = [];
        this.viewInit = false;
        this.status = { state: "", message: "" };
        this.unitsService.unitChangeAnnounced.subscribe(change => {
            this.initUnits();
        });
    }
    ngOnInit() {
        this.status = { state: "loading", message: "Loading saved settings" };
        this.unitsService.init().subscribe(result => {
            this.initUnits();
            this.status = { state: "", message: "" };
        }, error => {
            this.status = { state: "warning", message: "Unable to load settings" };
            this.initUnits();
            console.log(error);
        });
    }
    ngOnChanges(changes) {
        this.container_css_class = this.flex == 1 ? "container" : "";
        this.container_row_class = this.flex == 1 ? "row" : "noFlexRow";
    }
    show(quantityName) {
        return this.displayQuantities && this.displayQuantities.indexOf(quantityName) >= 0 ? true : !this.displayQuantities ? true : false;
    }
    locked(quantityName) {
        return this.lockedQuantities && this.lockedQuantities.indexOf(quantityName) >= 0 ? true : false;
    }
    selectionChanged($event, quantityName) {
        if (this.viewInit) {
            this.unitsService.setUnitForQuantityAndAnnounce(quantityName, $event.selectedItem);
            this.onUnitChange.emit(quantityName);
        }
    }
    ngAfterViewInit() {
        this.viewInit = true;
    }
    initUnits() {
        this.units["Pressure"] = this.unitsService.getUnitsForQuantity("Pressure");
        this.units["Speed"] = this.unitsService.getUnitsForQuantity("Speed");
        this.units["Throughput"] = this.unitsService.getUnitsForQuantity("Throughput");
        this.units["Power"] = this.unitsService.getUnitsForQuantity("Power");
        this.units["Frequency"] = this.unitsService.getUnitsForQuantity("Frequency");
        this.units["Length"] = this.unitsService.getUnitsForQuantity("Length");
        this.units["XDim"] = this.unitsService.getUnitsForQuantity("XDim");
        this.units["Throughput Mass Flow"] = this.unitsService.getUnitsForQuantity("Throughput Mass Flow");
        this.units["Throughput Molar Flow"] = this.unitsService.getUnitsForQuantity("Throughput Molar Flow");
        this.units["Area"] = this.unitsService.getUnitsForQuantity("Area");
        this.units["Volume"] = this.unitsService.getUnitsForQuantity("Volume");
        this.units["Time"] = this.unitsService.getUnitsForQuantity("Time");
        this.units["Temperature"] = this.unitsService.getUnitsForQuantity("Temperature");
        this.units["Outgassing"] = this.unitsService.getUnitsForQuantity("Outgassing");
        this.status = { state: "", message: "" };
    }
}
UnitsSelector.ɵfac = function UnitsSelector_Factory(t) { return new (t || UnitsSelector)(ɵɵdirectiveInject(UnitsService)); };
UnitsSelector.ɵcmp = ɵɵdefineComponent({ type: UnitsSelector, selectors: [["lib-units-selector"]], inputs: { flex: "flex", displayQuantities: "displayQuantities", lockedQuantities: "lockedQuantities" }, outputs: { onUnitChange: "onUnitChange" }, features: [ɵɵNgOnChangesFeature], decls: 17, vars: 17, consts: [[3, "className"], ["class", "dx-field", 4, "ngIf"], [1, "dx-field"], [1, "dx-field-label"], [1, "dx-field-value"], ["name", "Pressure", 3, "dataSource", "value", "onSelectionChanged"], ["select", ""], ["name", "Speed", 3, "dataSource", "value", "onSelectionChanged"], ["name", "Throughput", 3, "dataSource", "value", "onSelectionChanged"], ["name", "ThroughputMolarFlow", 3, "dataSource", "value", "onSelectionChanged"], ["name", "MassFlow", 3, "dataSource", "value", "onSelectionChanged"], ["name", "Frequency", 3, "dataSource", "value", "onSelectionChanged"], ["name", "Power", 3, "dataSource", "value", "onSelectionChanged"], ["name", "Length", 3, "dataSource", "value", "onSelectionChanged"], ["name", "XDim", 3, "dataSource", "value", "onSelectionChanged"], ["name", "Area", 3, "dataSource", "value", "onSelectionChanged"], ["name", "Volume", 3, "dataSource", "value", "onSelectionChanged"], ["name", "Time", 3, "dataSource", "value", "onSelectionChanged"], ["name", "Outgassing", 3, "dataSource", "value", "onSelectionChanged"]], template: function UnitsSelector_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 0);
        ɵɵtemplate(2, UnitsSelector_div_2_Template, 6, 2, "div", 1);
        ɵɵtemplate(3, UnitsSelector_div_3_Template, 6, 2, "div", 1);
        ɵɵtemplate(4, UnitsSelector_div_4_Template, 6, 2, "div", 1);
        ɵɵtemplate(5, UnitsSelector_div_5_Template, 6, 2, "div", 1);
        ɵɵtemplate(6, UnitsSelector_div_6_Template, 6, 2, "div", 1);
        ɵɵtemplate(7, UnitsSelector_div_7_Template, 6, 2, "div", 1);
        ɵɵtemplate(8, UnitsSelector_div_8_Template, 6, 2, "div", 1);
        ɵɵelementEnd();
        ɵɵelementStart(9, "div", 0);
        ɵɵtemplate(10, UnitsSelector_div_10_Template, 6, 2, "div", 1);
        ɵɵtemplate(11, UnitsSelector_div_11_Template, 6, 2, "div", 1);
        ɵɵtemplate(12, UnitsSelector_div_12_Template, 6, 2, "div", 1);
        ɵɵtemplate(13, UnitsSelector_div_13_Template, 6, 2, "div", 1);
        ɵɵtemplate(14, UnitsSelector_div_14_Template, 6, 2, "div", 1);
        ɵɵtemplate(15, UnitsSelector_div_15_Template, 6, 2, "div", 1);
        ɵɵtemplate(16, UnitsSelector_div_16_Template, 6, 2, "div", 1);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("className", ctx.container_css_class);
        ɵɵadvance(1);
        ɵɵproperty("className", ctx.container_row_class);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Pressure"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Speed"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Throughput"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Throughput Molar Flow"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Throughput Mass Flow"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Frequency"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Power"));
        ɵɵadvance(1);
        ɵɵproperty("className", ctx.container_row_class);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Length"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("XDim"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Area"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Volume"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Time"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Temperature"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show("Outgassing"));
    } }, directives: [NgIf, DxSelectBoxComponent], styles: [".quantity[_ngcontent-%COMP%]{padding-top:10px}.dx-field-label[_ngcontent-%COMP%]{padding-right:0}.dx-field-value[_ngcontent-%COMP%] > dx-select-box[_ngcontent-%COMP%]{width:60%}.row[_ngcontent-%COMP%]{width:50%}.noFlexRow[_ngcontent-%COMP%]{width:100%}.container[_ngcontent-%COMP%]{display:flex;width:100%}.dx-field-label[_ngcontent-%COMP%]:hover{text-overflow:visible}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UnitsSelector, [{
        type: Component,
        args: [{
                selector: 'lib-units-selector',
                templateUrl: './units-selector.component.html',
                styleUrls: ['./units-selector.component.css']
            }]
    }], function () { return [{ type: UnitsService }]; }, { flex: [{
            type: Input
        }], displayQuantities: [{
            type: Input
        }], lockedQuantities: [{
            type: Input
        }], onUnitChange: [{
            type: Output
        }] }); })();

class UnitsSettingsComponent {
    constructor(unitsService, appEventService) {
        this.unitsService = unitsService;
        this.appEventService = appEventService;
        this.presets = UnitsService.PRESETS;
        this.unitsService.unitChangeAnnounced.subscribe(change => {
            this.selectedPreset = this.unitsService.getPreset();
        });
    }
    ngOnInit() {
        this.selectedPreset = this.unitsService.getPreset() ? this.unitsService.getPreset() : this.presets[0];
    }
    selectionChanged(event) {
        this.unitsService.setAsPreset(event.selectedItem);
    }
    unitChange(event) {
        if (event == Quantity.SPEED || event == Quantity.PRESSURE) {
            let throughPutUnit = this.unitsService.getThroughPutUnitAsSpeedxPressure();
            if (throughPutUnit)
                this.unitsService.setUnitForQuantity(Quantity.THROUGHPUT, throughPutUnit);
        }
    }
}
UnitsSettingsComponent.ɵfac = function UnitsSettingsComponent_Factory(t) { return new (t || UnitsSettingsComponent)(ɵɵdirectiveInject(UnitsService), ɵɵdirectiveInject(AppEventService)); };
UnitsSettingsComponent.ɵcmp = ɵɵdefineComponent({ type: UnitsSettingsComponent, selectors: [["lib-units-settings"]], decls: 6, vars: 3, consts: [[2, "width", "100%"], [2, "width", "20%", "padding", "10px"], [3, "dataSource", "value", "onSelectionChanged"], ["select", ""], [2, "padding", "10px"], ["lockedQuantities", "['Throughput']", 3, "flex", "onUnitChange"]], template: function UnitsSettingsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "dx-select-box", 2, 3);
        ɵɵlistener("onSelectionChanged", function UnitsSettingsComponent_Template_dx_select_box_onSelectionChanged_2_listener($event) { return ctx.selectionChanged($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "lib-units-selector", 5);
        ɵɵlistener("onUnitChange", function UnitsSettingsComponent_Template_lib_units_selector_onUnitChange_5_listener($event) { return ctx.unitChange($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("dataSource", ctx.presets)("value", ctx.selectedPreset);
        ɵɵadvance(3);
        ɵɵproperty("flex", 1);
    } }, directives: [DxSelectBoxComponent, UnitsSelector], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UnitsSettingsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-units-settings',
                templateUrl: './units-settings.component.html',
                styleUrls: ['./units-settings.component.css']
            }]
    }], function () { return [{ type: UnitsService }, { type: AppEventService }]; }, null); })();

function UnitSettingsDialogueComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵelement(1, "lib-units-settings", 3);
    ɵɵelementStart(2, "div", 4);
    ɵɵelementStart(3, "div", 5);
    ɵɵelementStart(4, "dx-button", 6);
    ɵɵlistener("onClick", function UnitSettingsDialogueComponent_div_1_Template_dx_button_onClick_4_listener() { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.visible = false; });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 5);
    ɵɵelementStart(6, "dx-button", 7);
    ɵɵlistener("onClick", function UnitSettingsDialogueComponent_div_1_Template_dx_button_onClick_6_listener() { ɵɵrestoreView(_r3); const ctx_r4 = ɵɵnextContext(); return ctx_r4.saveSettings(); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 5);
    ɵɵelementStart(8, "dx-button", 8);
    ɵɵlistener("onClick", function UnitSettingsDialogueComponent_div_1_Template_dx_button_onClick_8_listener() { ɵɵrestoreView(_r3); const ctx_r5 = ɵɵnextContext(); return ctx_r5.loadDefault(); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
class UnitSettingsDialogueComponent {
    constructor(appEventService, unitsService) {
        this.appEventService = appEventService;
        this.unitsService = unitsService;
        this.visible = false;
        this.appEventService.events.subscribe(event => {
            this.visible = event.name == "TOPMENU_SETTINGS_CLICK";
        });
    }
    ngOnInit() {
    }
    saveSettings() {
        this.unitsService.saveSettings().subscribe(result => { }, err => { console.log(err); });
    }
    loadDefault() {
        this.unitsService.reload().subscribe(result => { }, err => { console.log(err); });
    }
}
UnitSettingsDialogueComponent.ɵfac = function UnitSettingsDialogueComponent_Factory(t) { return new (t || UnitSettingsDialogueComponent)(ɵɵdirectiveInject(AppEventService), ɵɵdirectiveInject(UnitsService)); };
UnitSettingsDialogueComponent.ɵcmp = ɵɵdefineComponent({ type: UnitSettingsDialogueComponent, selectors: [["lib-unit-settings-dialogue"]], decls: 2, vars: 6, consts: [["title", "Settings", 1, "popup", 2, "padding", "0px", 3, "width", "height", "showTitle", "closeOnOutsideClick", "visible", "visibleChange"], ["style", "padding:0px", 4, "dxTemplate", "dxTemplateOf"], [2, "padding", "0px"], [2, "width", "100%"], [2, "padding-top", "40px"], [2, "padding-left", "10px", "float", "right"], ["text", "OK", 3, "onClick"], ["text", "Save as default", 3, "onClick"], ["text", "Restore default", 3, "onClick"]], template: function UnitSettingsDialogueComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-popup", 0);
        ɵɵlistener("visibleChange", function UnitSettingsDialogueComponent_Template_dx_popup_visibleChange_0_listener($event) { return ctx.visible = $event; });
        ɵɵtemplate(1, UnitSettingsDialogueComponent_div_1_Template, 9, 0, "div", 1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("width", 800)("height", 550)("showTitle", true)("closeOnOutsideClick", true)("visible", ctx.visible);
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "content");
    } }, directives: [DxPopupComponent, DxTemplateDirective, UnitsSettingsComponent, DxButtonComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UnitSettingsDialogueComponent, [{
        type: Component,
        args: [{
                selector: 'lib-unit-settings-dialogue',
                templateUrl: './unit-settings-dialogue.component.html',
                styleUrls: ['./unit-settings-dialogue.component.css']
            }]
    }], function () { return [{ type: AppEventService }, { type: UnitsService }]; }, null); })();

function TopMenuComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 2);
    ɵɵlistener("click", function TopMenuComponent_div_1_Template_div_click_0_listener() { ɵɵrestoreView(_r3); const menuItem_r1 = ctx.$implicit; const ctx_r2 = ɵɵnextContext(); return ctx_r2.emit(menuItem_r1.event); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const menuItem_r1 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(menuItem_r1.label);
} }
class TopMenuComponent {
    constructor(appEventService, loginService) {
        this.appEventService = appEventService;
        this.loginService = loginService;
        this.menuClass = "headerMenuContainer_disabled";
        this.enabled = false;
        appEventService.events.subscribe(event => {
            this.menuClass = event.name == "APP_READY" ? "headerMenuContainer" : this.menuClass;
            this.enabled = true;
        });
    }
    ngOnInit() {
    }
    settings() {
        this.appEventService.emit({ name: "TOPMENU_SETTINGS_CLICK", context: "" });
    }
    logout() {
        this.loginService.logOut();
    }
    emit(event) {
        this.appEventService.emit(event);
    }
}
TopMenuComponent.ɵfac = function TopMenuComponent_Factory(t) { return new (t || TopMenuComponent)(ɵɵdirectiveInject(AppEventService), ɵɵdirectiveInject(LoginService)); };
TopMenuComponent.ɵcmp = ɵɵdefineComponent({ type: TopMenuComponent, selectors: [["lib-top-menu"]], inputs: { menuItems: "menuItems" }, decls: 7, vars: 2, consts: [[3, "ngClass"], ["class", "tab", 3, "click", 4, "ngFor", "ngForOf"], [1, "tab", 3, "click"], [1, "version"]], template: function TopMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, TopMenuComponent_div_1_Template, 2, 1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵlistener("click", function TopMenuComponent_Template_div_click_2_listener() { return ctx.settings(); });
        ɵɵtext(3, "Settings");
        ɵɵelementEnd();
        ɵɵelementStart(4, "div", 2);
        ɵɵlistener("click", function TopMenuComponent_Template_div_click_4_listener() { return ctx.logout(); });
        ɵɵtext(5, "Logout");
        ɵɵelementEnd();
        ɵɵelement(6, "div", 3);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ctx.menuClass);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.menuItems);
    } }, directives: [NgClass, NgForOf], styles: [".menu-item[_ngcontent-%COMP%], .menu-item[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{padding-right:20px;padding-top:10px}.menu-item[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:inherit;text-decoration:none}#appMenuContainer[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;height:100%;justify-content:flex-end;width:100%}#appMenuContainer[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{color:#575e61;font-size:.9rem;line-height:2.5rem;padding-left:1vw;text-align:center}#appMenuContainer[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:hover{border-bottom:4px solid #959a9c;color:#373d41}#appMenuContainer[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:last-child{margin-right:1vw}.headerMenuContainer[_ngcontent-%COMP%], .headerMenuContainer_disabled[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;height:100%;justify-content:flex-end;width:100%}.headerMenuContainer[_ngcontent-%COMP%] > .tab[_ngcontent-%COMP%], .headerMenuContainer[_ngcontent-%COMP%] > .version[_ngcontent-%COMP%], .headerMenuContainer_disabled[_ngcontent-%COMP%] > .tab[_ngcontent-%COMP%], .headerMenuContainer_disabled[_ngcontent-%COMP%] > .version[_ngcontent-%COMP%]{color:#575e61;font-size:1.1rem;font-weight:400;line-height:2.8rem;padding-left:.5rem;padding-right:.5rem}.headerMenuContainer_disabled[_ngcontent-%COMP%] > .tab[_ngcontent-%COMP%]{color:#b0b6b8}.headerMenuContainer[_ngcontent-%COMP%] > .tab[_ngcontent-%COMP%]:hover{border-bottom:4px solid #959a9c}.logout[_ngcontent-%COMP%]{color:#575e61;font-size:1.1rem;font-weight:400;line-height:2.8rem;padding-left:.5rem;padding-right:.5rem}.logout[_ngcontent-%COMP%]:hover{border-bottom:4px solid #959a9c}.headerMenuContainer[_ngcontent-%COMP%] > .button[_ngcontent-%COMP%], .headerMenuContainer_disabled[_ngcontent-%COMP%] > .button[_ngcontent-%COMP%]{background-position:100%;background-repeat:no-repeat;background-size:contain;height:100%;width:1rem}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TopMenuComponent, [{
        type: Component,
        args: [{
                selector: 'lib-top-menu',
                templateUrl: './top-menu.component.html',
                styleUrls: ['./top-menu.component.css']
            }]
    }], function () { return [{ type: AppEventService }, { type: LoginService }]; }, { menuItems: [{
            type: Input
        }] }); })();

class HeaderComponent {
    constructor() { }
    ngOnInit() {
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(); };
HeaderComponent.ɵcmp = ɵɵdefineComponent({ type: HeaderComponent, selectors: [["lib-header"]], inputs: { menuItems: "menuItems", app: "app" }, decls: 10, vars: 3, consts: [["id", "header"], [1, "headerrow"], ["id", "header_1_1"], ["id", "header_1_2"], ["id", "header_1_3"], ["id", "header_2_1"], ["id", "header_2_2", 2, "background-image", "url(assets/img/edwardslogo.png)"], ["id", "header_2_3"], [3, "menuItems"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelement(2, "div", 2);
        ɵɵelement(3, "div", 3);
        ɵɵelement(4, "div", 4);
        ɵɵelementEnd();
        ɵɵelementStart(5, "div", 1);
        ɵɵelement(6, "div", 5);
        ɵɵelement(7, "div", 6);
        ɵɵelementStart(8, "div", 7);
        ɵɵelement(9, "lib-top-menu", 8);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(4);
        ɵɵstyleProp("background-image", ctx.app == "builder" ? "url(assets/img/PumpCalcBuilderLogo.svg)" : ctx.app == "gasflow" ? "url(assets/img/PumpCalcGasFlowLogo.svg)" : "url(assets/img/PumpCalc-logo.svg)");
        ɵɵadvance(5);
        ɵɵproperty("menuItems", ctx.menuItems);
    } }, directives: [TopMenuComponent], styles: [".headerrow[_ngcontent-%COMP%]{background-color:#828789;display:flex;flex-wrap:nowrap;height:50px;width:100%}.headerrow[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{height:100%}#header_1_1[_ngcontent-%COMP%]{background-color:#c4262e;width:25%}#header_1_2[_ngcontent-%COMP%]{width:50%}#header_1_2[_ngcontent-%COMP%], #header_1_3[_ngcontent-%COMP%]{background-color:#828789}#header_1_3[_ngcontent-%COMP%]{background-position:50%;background-repeat:no-repeat;background-size:contain;height:80%;transform:translateY(10%);width:25%}#pumpCalc[_ngcontent-%COMP%]{color:#fff;font-size:25px;line-height:100%;padding-right:10px;padding-top:10px;text-align:right}#header_2_1[_ngcontent-%COMP%]{background-color:#c4262e;width:10%}#header_2_2[_ngcontent-%COMP%]{background-color:#fff;background-position:100%;background-repeat:no-repeat;background-size:contain;position:relative;top:70%;transform:translateY(-70%);width:15%}#header_2_3[_ngcontent-%COMP%]{width:75%}#header_2_3[_ngcontent-%COMP%], #header_2_4[_ngcontent-%COMP%]{background-color:#eaeaeb}#header_2_4[_ngcontent-%COMP%]{width:25%}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'lib-header',
                templateUrl: './header.component.html',
                styleUrls: ['./header.component.css']
            }]
    }], function () { return []; }, { menuItems: [{
            type: Input
        }], app: [{
            type: Input
        }] }); })();

class LoaderComponent {
    constructor(unitsService, appEventService) {
        this.unitsService = unitsService;
        this.appEventService = appEventService;
        this.loginStateChange = new EventEmitter();
        this.appEventService.events.subscribe(event => {
            if (event.name == "LOGGEDIN" /* LOGGEDIN */) {
                this.unitsService.hasSavedSettings().subscribe(result => {
                    this.appEventService.emit({ name: "APP_READY", context: "" });
                });
            }
        });
    }
    ngOnInit() {
    }
}
LoaderComponent.ɵfac = function LoaderComponent_Factory(t) { return new (t || LoaderComponent)(ɵɵdirectiveInject(UnitsService), ɵɵdirectiveInject(AppEventService)); };
LoaderComponent.ɵcmp = ɵɵdefineComponent({ type: LoaderComponent, selectors: [["lib-loader"]], outputs: { loginStateChange: "loginStateChange" }, decls: 0, vars: 0, template: function LoaderComponent_Template(rf, ctx) { }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoaderComponent, [{
        type: Component,
        args: [{
                selector: 'lib-loader',
                templateUrl: './loader.component.html',
                styleUrls: ['./loader.component.css']
            }]
    }], function () { return [{ type: UnitsService }, { type: AppEventService }]; }, { loginStateChange: [{
            type: Output
        }] }); })();

class DiagramSelectionService {
    constructor() {
        this.selectedSource = new Subject();
        this.diagramElementSelected = this.selectedSource.asObservable();
    }
    selectElementId(elementId) {
        this.selectedElementId = elementId;
        this.selectedSource.next(elementId);
    }
    isElementSelected(elementId) {
        return this.selectedElementId == elementId;
    }
    getSelection() {
        return this.selectedElementId;
    }
}
DiagramSelectionService.ɵfac = function DiagramSelectionService_Factory(t) { return new (t || DiagramSelectionService)(); };
DiagramSelectionService.ɵprov = ɵɵdefineInjectable({ token: DiagramSelectionService, factory: DiagramSelectionService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DiagramSelectionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class PipeworkSvgService {
    totalPipeLength(pipeWork) {
        let totalPipeLength = 0;
        pipeWork.forEach(pipe => {
            totalPipeLength += pipe.length;
        });
        return totalPipeLength;
    }
    pipeLengthRatio(totalPipeWorkLength, maxPipeLength) {
        return maxPipeLength / totalPipeWorkLength;
    }
    pipeLengthDrawnToRatio(totalPipeWorkLength, pipeLengthRatio) {
        return totalPipeWorkLength * pipeLengthRatio;
    }
    pipeManifoldStartX(maxPipeWidth, maxDrawnParallel, parallelPipeOffsets, ctx, pipework, pipeIndex) {
        if (this.pipeAboveHasGreaterParallel(maxDrawnParallel, pipeIndex, pipework)) {
            return this.pipeStartX(maxPipeWidth, maxDrawnParallel, parallelPipeOffsets, ctx, pipework, pipeIndex - 1, 0);
        }
        //the startpipe x of left most pipe
        return this.pipeStartX(maxPipeWidth, maxDrawnParallel, parallelPipeOffsets, ctx, pipework, pipeIndex, 0);
    }
    pipeStartX(maxPipeWidth, maxDrawnParallel, parallelPipeOffsets, ctx, pipework, pipeIndex, parallelPipeIndex) {
        return ctx + parallelPipeOffsets[this.parallelAsDrawn(maxDrawnParallel, pipework[pipeIndex].parallel) - 1][parallelPipeIndex] - maxPipeWidth / 2;
    }
    parallelAsDrawn(maxDrawnParallel, parallel) {
        return parallel <= maxDrawnParallel ? parallel : 1;
    }
    pipeAboveHasGreaterParallel(maxDrawnParallel, pipeIndex, pipework) {
        return pipework[pipeIndex - 1]
            && this.parallelAsDrawn(maxDrawnParallel, pipework[pipeIndex - 1].parallel) >
                this.parallelAsDrawn(maxDrawnParallel, pipework[pipeIndex].parallel);
    }
    pipeManifoldWidth(maxPipeWidth, maxDrawnParallel, parallelPipeOffsets, ctx, pipework, pipeIndex) {
        if (this.pipeAboveHasGreaterParallel(maxDrawnParallel, pipeIndex, pipework)) {
            return this.pipeStartX(maxPipeWidth, maxDrawnParallel, parallelPipeOffsets, ctx, pipework, pipeIndex - 1, this.parallelAsDrawn(maxDrawnParallel, pipework[pipeIndex - 1].parallel) - 1) - this.pipeManifoldStartX(maxPipeWidth, maxDrawnParallel, parallelPipeOffsets, ctx, pipework, pipeIndex) + maxPipeWidth;
        }
        return this.pipeStartX(maxPipeWidth, maxDrawnParallel, parallelPipeOffsets, ctx, pipework, pipeIndex, this.parallelAsDrawn(maxDrawnParallel, pipework[pipeIndex].parallel) - 1) - this.pipeManifoldStartX(maxPipeWidth, maxDrawnParallel, parallelPipeOffsets, ctx, pipework, pipeIndex) + maxPipeWidth;
    }
}

class BoosterLayerDetail {
}
class PumpSet {
}
class PumpSetSvgService {
    constructor() {
        this.pipeworkSvgService = new PipeworkSvgService();
        this.padding = 5;
        this.maxPipeHeight = 350;
        this.defaultBoosterRY = 20;
        this.defaultBoosterRX = 35;
        this.boosterInletHeight = 5;
        this.boosterOutletHeight = 5;
        this.backingPumpInletHeight = 5;
        this.inletWidth = 10;
        this.defaultBackingPumpHeight = 120;
        this.backingPumpWidth = 70;
        this.manifoldPipeWidth = 2;
        this.backingPumpPadding = 10;
        //keep strokeWidth in sync with css
        this.strokeWidth = 2;
        this.maxDrawnParallel = 3;
        this.maxPipeWidth = 10;
        this.spaceForParallelLabels = 60;
        this.parallelBackingPumpOffset = [
            [
                [this.strokeWidth + this.padding]
            ],
            [
                [this.strokeWidth + this.padding + (this.backingPumpWidth / 2) + this.inletWidth / 2],
                [this.strokeWidth + this.padding, this.strokeWidth + this.padding + this.backingPumpPadding + this.backingPumpWidth]
            ],
            [
                [this.strokeWidth + this.padding + this.backingPumpWidth + this.inletWidth],
                [this.padding, this.strokeWidth + this.padding + this.backingPumpPadding + (this.backingPumpWidth * 2) + this.inletWidth],
                [this.strokeWidth + this.padding, this.strokeWidth + this.padding + this.backingPumpPadding + this.backingPumpWidth, this.strokeWidth + this.padding + (this.backingPumpPadding * 2) + (this.backingPumpWidth * 2)]
            ]
        ];
        this.parallelBoosterOffset = [
            [
                [this.parallelBackingPumpOffset[0][0][0] + (this.backingPumpWidth / 2)]
            ],
            [
                [this.parallelBackingPumpOffset[0][0][0] + this.backingPumpWidth + (this.backingPumpPadding / 2)],
                [this.parallelBackingPumpOffset[2][2][0] + (this.backingPumpWidth / 2), this.parallelBackingPumpOffset[2][2][2] - ((this.backingPumpWidth / 2) + this.inletWidth)]
            ],
            [
                [this.parallelBackingPumpOffset[2][2][1] + this.backingPumpWidth / 2],
                [this.parallelBackingPumpOffset[2][2][0] + (this.backingPumpWidth / 2), this.parallelBackingPumpOffset[2][2][2] + (this.backingPumpWidth / 2)],
                [this.parallelBackingPumpOffset[2][2][0] + (this.backingPumpWidth / 2), this.parallelBackingPumpOffset[2][2][1] + (this.backingPumpWidth / 2), this.parallelBackingPumpOffset[2][2][2] + (this.backingPumpWidth / 2)]
            ]
        ];
    }
    boosterLayerStartY(pumpSet, pipeLengthRatio, boosterLayerIndex, isDetailedDiagram) {
        let startY = this.padding + this.strokeWidth;
        for (let i = 0; i < boosterLayerIndex; i++) {
            startY += this.boosterLayerHeight(pumpSet, pipeLengthRatio, i, isDetailedDiagram);
        }
        return startY;
    }
    boosterLayerHeight(pumpSet, pipeLengthRatio, boosterLayerIndex, isDetailedDiagram) {
        let totalheight = this.boosterRY(isDetailedDiagram) * 2 + this.boosterInletHeight;
        if (pumpSet.pumpsetDetails.boosterLayersDetails.length == 0) {
            return totalheight;
        }
        ;
        totalheight += this.pipeworkSvgService.pipeLengthDrawnToRatio(this.pipeworkSvgService.totalPipeLength(pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].pipework), pipeLengthRatio);
        return totalheight + (boosterLayerIndex > 0 ? this.boosterOutletHeight : 0);
    }
    totalPipeLength(pumpSet) {
        let totalPipeLength = 0;
        pumpSet.pumpsetDetails.boosterLayersDetails.forEach(boosterLayer => {
            boosterLayer.pipework.forEach(pipe => {
                totalPipeLength += pipe.length <= 0 ? 0.01 : pipe.length;
            });
        });
        return totalPipeLength;
    }
    pipeHeight(pumpSet, boosterLayerIndex, pipeIndex) {
        return (pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].pipework[pipeIndex].length <= 0 ? 0.01 : pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].pipework[pipeIndex].length) * this.pipeLengthRatio(pumpSet);
    }
    pipeLengthRatio(pumpSet) {
        let totalPipeLength = this.totalPipeLength(pumpSet);
        return totalPipeLength > 0 ? this.maxPipeHeight / totalPipeLength : 1;
    }
    boosterCenterX(pumpSet, boosterLayerIndex, parallelBoosterNumberInLayer) {
        return this.parallelBoosterOffset[this.lastParalellIndexAsDrawn(this.maxParallelInPumpSet(pumpSet))][this.lastParallelBoosterIndexAsDrawn(pumpSet, boosterLayerIndex)][parallelBoosterNumberInLayer];
    }
    boosterCenterY(pumpSet, pipeLengthRatio, boosterLayerIndex, isDetailedDiagram) {
        return this.boosterLayerStartY(pumpSet, pipeLengthRatio, boosterLayerIndex, isDetailedDiagram) + this.boosterRY(isDetailedDiagram) + (boosterLayerIndex > 0 ? this.boosterInletHeight : 0);
    }
    backingPumpStartY(pumpSet, pipeLengthRatio, isDetailedDiagram) {
        return this.noBoosterLayers(pumpSet) ? this.padding * 2 : this.boosterLayerStartY(pumpSet, pipeLengthRatio, pumpSet.pumpsetDetails.boosterLayersDetails.length - 1, isDetailedDiagram) + this.boosterLayerHeight(pumpSet, pipeLengthRatio, pumpSet.pumpsetDetails.boosterLayersDetails.length - 1, isDetailedDiagram) + this.backingPumpInletHeight;
    }
    backingPumpStartX(pumpSet, parallelBackingPumpNumber) {
        return this.parallelBackingPumpOffset[this.lastParalellIndexAsDrawn(this.maxParallelInPumpSet(pumpSet))][this.lastParalellIndexAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel)][parallelBackingPumpNumber];
        // + (this.noBoosterLayers(pumpSet)?0:this.backingPumpOffsetToMatchBoosters(pumpSet))
    }
    pumpSetStartY() {
        return 0;
    }
    pumpSetStartX() {
        return 0;
    }
    pumpSetWidth(pumpSet, isDetailedDiagram) {
        return (this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel)
            >= this.parallelAsDrawn(this.maxNumParallelBoostersAsDrawn(pumpSet)) || this.noBoosterLayers(pumpSet))
            ? this.backingPumpStartX(pumpSet, this.lastParalellIndexAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel)) + this.backingPumpWidth + this.padding + this.strokeWidth +
                (this.numBackingPumpsInParallel(pumpSet) > this.maxDrawnParallel || this.numBackingPumpsInParallel(pumpSet) % 1 > 0 || this.boosterLayerRequiresSpaceForLabel(pumpSet) ? this.spaceForParallelLabels : 0)
            : this.boosterCenterX(pumpSet, this.indexOfBoosterLayerWithGreatestParallelAsDrawn(pumpSet), this.maxNumParallelBoostersAsDrawn(pumpSet) - 1)
                + this.boosterRX(isDetailedDiagram)
                + (this.padding * 2)
                + this.strokeWidth;
    }
    pumpSetHeight(pumpSet, pipeLengthRatio, isDetailedDiagram) {
        return this.backingPumpStartY(pumpSet, pipeLengthRatio, isDetailedDiagram) + this.backingPumpHeight(isDetailedDiagram) + (this.padding * 2) + this.strokeWidth;
    }
    boosterLayerManifoldStartX(pumpSet, boosterLayerIndex) {
        //if backing pump element below is wider draw to that
        if (this.isLastBoosterLayer(pumpSet, boosterLayerIndex)) {
            if (this.parallelAsDrawn(this.lastPipe(pumpSet, boosterLayerIndex).parallel) > 1 && this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) == 1) {
                return this.pipeworkSvgService.pipeStartX(this.maxPipeWidth, this.maxDrawnParallel, this.parallelPipeOffsetsForBoosterParallelAsDrawn(pumpSet, boosterLayerIndex), this.pipeWorkStartCTX(pumpSet, boosterLayerIndex), this.pipework(pumpSet, boosterLayerIndex), this.pipework(pumpSet, boosterLayerIndex).length - 1, 0);
            }
            return this.backingPumpStartX(pumpSet, 0) + (this.backingPumpWidth / 2) - (this.inletWidth / 2);
        }
        // if is booster layer below draw to the widest
        if (this.boosterLayer(pumpSet, boosterLayerIndex + 1)
            && this.parallelAsDrawn(this.boosterLayer(pumpSet, boosterLayerIndex + 1).numberOfBoostersInParallel)
                > this.parallelAsDrawn(pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].numberOfBoostersInParallel)) {
            return this.boosterCenterX(pumpSet, boosterLayerIndex + 1, 0) - this.maxPipeWidth / 2 - this.strokeWidth;
        }
        if (this.boosterLayer(pumpSet, boosterLayerIndex + 1)
            && this.parallelAsDrawn(this.boosterLayer(pumpSet, boosterLayerIndex + 1).numberOfBoostersInParallel)
                < this.parallelAsDrawn(this.lastPipe(pumpSet, boosterLayerIndex).parallel)) {
            return this.pipeworkSvgService.pipeManifoldStartX(this.maxPipeWidth, this.maxDrawnParallel, this.parallelPipeOffsetsForBoosterParallelAsDrawn(pumpSet, boosterLayerIndex), this.pipeWorkStartCTX(pumpSet, boosterLayerIndex), this.pipework(pumpSet, boosterLayerIndex), this.pipework(pumpSet, boosterLayerIndex).length - 1);
        }
        //else draw to the extremeties of booster layer pipework
        return this.startOfLastLeftMostPipeInBoosterLayer(pumpSet, boosterLayerIndex) - this.maxPipeWidth / 2 - this.strokeWidth;
    }
    boosterLayerManifoldStartY(pumpSet, pipeLengthRatio, boosterLayerIndex, isDetailedDiagram) {
        //last pipe starty + length - pipewidth
        return this.boosterCenterY(pumpSet, pipeLengthRatio, boosterLayerIndex + 1, isDetailedDiagram) - (this.boosterRY(isDetailedDiagram) + this.boosterInletHeight + this.manifoldPipeWidth);
    }
    boosterLayerManifoldWidth(pumpSet, boosterLayerIndex) {
        //is last booster layer
        if (this.isLastBoosterLayer(pumpSet, boosterLayerIndex)) {
            if (this.parallelAsDrawn(this.lastPipe(pumpSet, boosterLayerIndex).parallel) > 1 && this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) == 1) {
                return this.pipeworkSvgService.pipeManifoldWidth(this.maxPipeWidth, this.maxDrawnParallel, this.parallelPipeOffsetsForBoosterParallelAsDrawn(pumpSet, boosterLayerIndex), this.boosterCenterX(pumpSet, boosterLayerIndex, 0), this.pipework(pumpSet, boosterLayerIndex), this.pipework(pumpSet, boosterLayerIndex).length - 1);
            }
            return (this.backingPumpStartX(pumpSet, this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) - 1) + (this.backingPumpWidth / 2) + (this.inletWidth / 2))
                - (this.backingPumpStartX(pumpSet, 0) + (this.backingPumpWidth / 2) - (this.inletWidth / 2));
        }
        //next layer has greater parallel
        if (!this.isLastBoosterLayer(pumpSet, boosterLayerIndex) &&
            this.parallelAsDrawn(pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex + 1].numberOfBoostersInParallel)
                > this.parallelAsDrawn(pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].numberOfBoostersInParallel)) {
            return this.boosterCenterX(pumpSet, boosterLayerIndex + 1, this.lastParallelBoosterIndexAsDrawn(pumpSet, boosterLayerIndex + 1)) + (this.maxPipeWidth + this.strokeWidth) - this.boosterCenterX(pumpSet, boosterLayerIndex + 1, 0);
        }
        if (this.boosterLayer(pumpSet, boosterLayerIndex + 1)
            && this.parallelAsDrawn(this.boosterLayer(pumpSet, boosterLayerIndex + 1).numberOfBoostersInParallel)
                < this.parallelAsDrawn(this.lastPipe(pumpSet, boosterLayerIndex).parallel)) {
            return this.pipeworkSvgService.pipeManifoldWidth(this.maxPipeWidth, this.maxDrawnParallel, this.parallelPipeOffsetsForBoosterParallelAsDrawn(pumpSet, boosterLayerIndex), this.pipeWorkManifoldStartX(pumpSet, boosterLayerIndex), this.pipework(pumpSet, boosterLayerIndex), this.pipework(pumpSet, boosterLayerIndex).length - 1);
        }
        //next layer has same parallel
        return this.widthOfLastPipeOfBoosterLayer(pumpSet, boosterLayerIndex) + (this.maxPipeWidth + this.strokeWidth);
    }
    drawManifoldAtBottomOfLayer(pumpSet, boosterLayerIndex) {
        if (this.isLastBoosterLayer(pumpSet, boosterLayerIndex) && this.lastParallelPipeIndexAsDrawn(pumpSet, boosterLayerIndex) == this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex)) {
            return false;
        }
        if (this.numParallelAsDrawnBoosterLayer(pumpSet, boosterLayerIndex) == 1 && this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex) == 2) {
            return true;
        }
        if (this.lastParallelPipeIndexAsDrawn(pumpSet, boosterLayerIndex) == 1 && this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex) == 2) {
            return true;
        }
        if (this.lastParallelPipeIndexAsDrawn(pumpSet, boosterLayerIndex) < this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex)) {
            return true;
        }
        if (this.lastParallelPipeIndexAsDrawn(pumpSet, boosterLayerIndex) > this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex)) {
            return true;
        }
        if (this.numParallelAsDrawnBoosterLayer(pumpSet, boosterLayerIndex) < this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex)) {
            return true;
        }
        return false;
    }
    drawPipeworkManifold(pumpSet, boosterLayerIndex) {
        return this.parallelAsDrawn(this.boosterLayer(pumpSet, boosterLayerIndex).numberOfBoostersInParallel) == this.firstParallelPipeIndexAsDrawn(pumpSet, boosterLayerIndex) ? false : true;
    }
    pipeWorkManifoldStartX(pumpSet, boosterLayerIndex) {
        let boosterCenterX = this.boosterCenterX(pumpSet, boosterLayerIndex, 0) - this.maxPipeWidth / 2 - this.strokeWidth;
        let pipeWorkStartX = this.pipeworkSvgService.pipeStartX(this.maxPipeWidth, this.maxDrawnParallel, this.parallelPipeOffsetsForBoosterParallelAsDrawn(pumpSet, boosterLayerIndex), this.pipeWorkStartCTX(pumpSet, boosterLayerIndex), this.pipework(pumpSet, boosterLayerIndex), 0, 0);
        return boosterCenterX < pipeWorkStartX ? boosterCenterX : pipeWorkStartX;
    }
    pipeWorkManifoldStartY(pumpSet, boosterLayerIndex, pipeLengthRatio, isDetailedDiagram) {
        return this.pipeWorkStartCTY(pumpSet, pipeLengthRatio, boosterLayerIndex, isDetailedDiagram);
    }
    pipeWorkManifoldWidth(pumpSet, boosterLayerIndex) {
        let toBoosterWidth = this.boosterCenterX(pumpSet, boosterLayerIndex, this.lastParallelBoosterIndexAsDrawn(pumpSet, boosterLayerIndex)) + (this.maxPipeWidth + this.strokeWidth) - this.boosterCenterX(pumpSet, boosterLayerIndex, 0);
        let toPipeWidth = this.pipeworkSvgService.pipeManifoldWidth(this.maxPipeWidth, this.maxDrawnParallel, this.parallelPipeOffsetsForBoosterParallelAsDrawn(pumpSet, boosterLayerIndex), this.pipeWorkStartCTX(pumpSet, boosterLayerIndex), this.pipework(pumpSet, boosterLayerIndex), 0);
        return toBoosterWidth > toPipeWidth ? toBoosterWidth : toPipeWidth;
    }
    firstParallelPipeIndexAsDrawn(pumpSet, boosterLayerIndex) {
        return this.parallelAsDrawn(pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].pipework[0].parallel);
    }
    isLastBoosterLayer(pumpSet, boosterLayerIndex) {
        return pumpSet.pumpsetDetails.boosterLayersDetails.length - 1 == boosterLayerIndex;
    }
    drawBoosterLayerManifold(pumpSet, boosterLayerIndex) {
        return true;
    }
    parallelAsDrawn(parallel) {
        if (parallel % 1 != 0)
            return 1;
        return parallel <= this.maxDrawnParallel && parallel >= 1 ? parallel : 1;
    }
    lastParallelPipeIndexAsDrawn(pumpSet, boosterLayerIndex) {
        return this.parallelAsDrawn(pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].pipework[pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].pipework.length - 1].parallel);
    }
    lastParallelBoosterIndexAsDrawn(pumpSet, boosterLayerIndex) {
        return this.lastParalellIndexAsDrawn(pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].numberOfBoostersInParallel);
    }
    lastParalellIndexAsDrawn(parallel) {
        return this.parallelAsDrawn(parallel) - 1;
        // if(parallel%1!=0) return 0;
        // return roundedParallel <= this.maxDrawnParallel && roundedParallel>=1 ? roundedParallel - 1 : 0;
    }
    maxNumParallelBoostersAsDrawn(pumpSet) {
        let max = 0;
        pumpSet.pumpsetDetails.boosterLayersDetails.forEach((boosterLayer) => {
            max = this.parallelAsDrawn(boosterLayer.numberOfBoostersInParallel)
                > max ? this.parallelAsDrawn(boosterLayer.numberOfBoostersInParallel) : max;
        });
        return max;
    }
    maxParallelInPumpSet(pumpSet) {
        return this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) > this.maxNumParallelBoostersAsDrawn(pumpSet) ?
            this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) : this.maxNumParallelBoostersAsDrawn(pumpSet);
    }
    lastBoosterHasMoreParallelThanPumps(pumpSet) {
        return this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) <
            this.parallelAsDrawn(pumpSet.pumpsetDetails.boosterLayersDetails[pumpSet.pumpsetDetails.boosterLayersDetails.length - 1].numberOfBoostersInParallel);
    }
    indexOfBoosterLayerWithGreatestParallelAsDrawn(pumpSet) {
        let max = 0;
        let maxIndex = 0;
        pumpSet.pumpsetDetails.boosterLayersDetails.forEach((boosterLayer, index) => {
            if (this.parallelAsDrawn(boosterLayer.numberOfBoostersInParallel) > max) {
                max = this.parallelAsDrawn(boosterLayer.numberOfBoostersInParallel);
                maxIndex = index;
            }
        });
        return maxIndex;
    }
    drawnWidthOfBoosterLayer(pumpSet, boosterLayerIndex, isDetailedDiagram) {
        return (this.boosterCenterX(pumpSet, boosterLayerIndex, this.lastParallelBoosterIndexAsDrawn(pumpSet, boosterLayerIndex)) + this.boosterRX(isDetailedDiagram)) -
            (this.boosterCenterX(pumpSet, boosterLayerIndex, 0) - this.boosterRX(isDetailedDiagram));
    }
    drawnWidthOfBackingPumpLayer(pumpSet) {
        return (this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) * this.backingPumpWidth) +
            ((this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) - 1) * this.backingPumpPadding);
    }
    lastBoosterLayerParallel(pumpSet) {
        return this.lastBoosterLayer(pumpSet).numberOfBoostersInParallel;
    }
    lastBoosterLayer(pumpSet) {
        return pumpSet.pumpsetDetails.boosterLayersDetails[pumpSet.pumpsetDetails.boosterLayersDetails.length - 1];
    }
    backingPumpOffsetToMatchBoosters(pumpSet) {
        if (this.parallelAsDrawn(this.maxNumParallelBoostersAsDrawn(pumpSet)) == 3 && this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) == 1) {
            return this.backingPumpWidth + this.backingPumpPadding + 2;
        }
        if (this.parallelAsDrawn(this.maxNumParallelBoostersAsDrawn(pumpSet)) == 2 && this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) == 1) {
            return -(this.backingPumpWidth / 2) + this.backingPumpPadding / 2;
        }
        if (this.parallelAsDrawn(this.maxNumParallelBoostersAsDrawn(pumpSet)) == 3 && this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) == 2) {
            return this.backingPumpWidth / 2 + (this.backingPumpPadding / 2);
        }
        if (this.parallelAsDrawn(this.lastBoosterLayerParallel(pumpSet)) == 1 && this.parallelAsDrawn(this.maxNumParallelBoostersAsDrawn(pumpSet)) == 3 && this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) == 1) {
            return this.backingPumpWidth + this.backingPumpPadding + this.strokeWidth;
        }
        if (this.parallelAsDrawn(this.lastBoosterLayerParallel(pumpSet)) == 3 && this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) == 2) {
            return (this.backingPumpWidth / 2) + (this.backingPumpPadding / 2);
        }
        if (this.parallelAsDrawn(this.lastBoosterLayerParallel(pumpSet)) == 2 && this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) == 1) {
            return (-1 * (this.backingPumpWidth / 2)) + this.backingPumpPadding / 2;
        }
        if (this.parallelAsDrawn(this.lastBoosterLayerParallel(pumpSet)) == 3 && this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) == 1) {
            return this.backingPumpWidth + this.backingPumpPadding;
        }
        if (this.parallelAsDrawn(this.lastBoosterLayerParallel(pumpSet)) == 3 && this.parallelAsDrawn(pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) == 1) {
            return this.backingPumpWidth + this.backingPumpPadding;
        }
        return 0;
    }
    pipeWorkStartCTY(pumpSet, pipeLengthRatio, boosterLayerIndex, isDetailedDiagram) {
        return this.boosterCenterY(pumpSet, pipeLengthRatio, boosterLayerIndex, isDetailedDiagram) + this.boosterRY(isDetailedDiagram) + this.boosterInletHeight;
    }
    widthOfLastPipeOfBoosterLayer(pumpSet, boosterLayerIndex) {
        return this.startOfLastRightMostPipeInBoosterLayer(pumpSet, boosterLayerIndex) - this.startOfLastLeftMostPipeInBoosterLayer(pumpSet, boosterLayerIndex);
    }
    startOfLastLeftMostPipeInBoosterLayer(pumpSet, boosterLayerIndex) {
        return this.boosterCenterX(pumpSet, boosterLayerIndex, 0) +
            this.parallelPipeOffsetsForBoosterParallelAsDrawn(pumpSet, boosterLayerIndex)[this.parallelAsDrawn(this.lastPipe(pumpSet, boosterLayerIndex).parallel) - 1][0];
    }
    startOfLastRightMostPipeInBoosterLayer(pumpSet, boosterLayerIndex) {
        return this.boosterCenterX(pumpSet, boosterLayerIndex, this.parallelAsDrawn(pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].numberOfBoostersInParallel) - 1) +
            this.parallelPipeOffsetsForBoosterParallelAsDrawn(pumpSet, boosterLayerIndex)[this.parallelAsDrawn(this.lastPipe(pumpSet, boosterLayerIndex).parallel) - 1][this.parallelAsDrawn(this.lastPipe(pumpSet, boosterLayerIndex).parallel) - 1];
    }
    lastPipe(pumpSet, boosterLayerIndex) {
        return pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].pipework[pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].pipework.length - 1];
    }
    firstPipe(pumpSet, boosterLayerIndex) {
        return pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].pipework[0];
    }
    boosterLayer(pumpSet, boosterLayerIndex) {
        return pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex];
    }
    noBoosterLayers(pumpSet) {
        return pumpSet.pumpsetDetails.boosterLayersDetails.length == 0;
    }
    numBackingPumpsInParallel(pumpSet) {
        return pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel;
    }
    truncateTextToFitWidth(text, width) {
        let result = text.substring(0, (width / 6) - 3);
        return result + (result.length < text.length ? ".." : "");
    }
    backingPumpDrawnWidth(pumpSet) {
        return (this.parallelAsDrawn(this.numBackingPumpsInParallel(pumpSet)) * this.backingPumpWidth) +
            ((this.parallelAsDrawn(this.numBackingPumpsInParallel(pumpSet)) - 1) * this.backingPumpPadding);
    }
    backingPumpDrawnCenterX(pumpSet) {
        switch (this.parallelAsDrawn(this.numBackingPumpsInParallel(pumpSet))) {
            case 1: return this.backingPumpStartX(pumpSet, 0) + this.backingPumpWidth / 2;
            case 2: return this.backingPumpStartX(pumpSet, 0) + this.backingPumpWidth + (this.backingPumpPadding / 2);
            case 3: return this.backingPumpStartX(pumpSet, 1) + this.backingPumpWidth / 2;
            default: return this.backingPumpStartX(pumpSet, 0) + this.backingPumpWidth / 2;
        }
    }
    boosterLayerDrawnCenterX(pumpSet, boosterLayerIndex, isDetailedDiagram) {
        switch (this.parallelAsDrawn(pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].numberOfBoostersInParallel)) {
            case 1: return this.boosterCenterX(pumpSet, boosterLayerIndex, 0);
            case 2: return this.parallelAsDrawn(this.numBackingPumpsInParallel(pumpSet) == 1) || this.parallelAsDrawn(this.numBackingPumpsInParallel(pumpSet) == 2) ? this.boosterCenterX(pumpSet, boosterLayerIndex, 0) + (this.boosterRY(isDetailedDiagram) * 2) : this.boosterCenterX(pumpSet, boosterLayerIndex, 0) + (this.boosterRY(isDetailedDiagram) * 4);
            case 3: return this.boosterCenterX(pumpSet, boosterLayerIndex, 1);
            default: return this.boosterCenterX(pumpSet, boosterLayerIndex, 0);
        }
    }
    boosterLayerDrawnWidth(pumpSet, boosterLayerIndex, isDetailedDiagram) {
        switch (this.parallelAsDrawn(pumpSet.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].numberOfBoostersInParallel)) {
            case 1: return this.boosterRX(isDetailedDiagram) * 1.5;
            case 2: return this.parallelAsDrawn(this.numBackingPumpsInParallel(pumpSet) == 1) || this.parallelAsDrawn(this.numBackingPumpsInParallel(pumpSet) == 2) ? this.boosterRX(isDetailedDiagram) * 4 : this.boosterRX(isDetailedDiagram) * 6;
            case 3: return this.boosterRX(isDetailedDiagram) * 6;
            default: return this.boosterRX(isDetailedDiagram) * 2;
        }
    }
    heightOfFixedElements(pumpSet, isDetailedDiagram) {
        return (pumpSet.pumpsetDetails.boosterLayersDetails.length * (this.boosterRY(isDetailedDiagram) * 2)) //boosters
            + this.padding + this.strokeWidth //start of first booster layer
            + (pumpSet.pumpsetDetails.boosterLayersDetails.length * (this.strokeWidth * 2)) //booster layer bounding box
            + (pumpSet.pumpsetDetails.boosterLayersDetails.length * this.boosterInletHeight) - (pumpSet.pumpsetDetails.boosterLayersDetails.length == 1 ? this.boosterInletHeight : 0) //boosterInlets
            + (this.backingPumpHeight(isDetailedDiagram) + this.backingPumpInletHeight) //backing pump
            + (this.padding * 2) //padding top and bottom
            + (this.strokeWidth * 2); //pumpset bounding box top and bottom
    }
    backingPumpHeight(isDetailedDiagram) {
        return isDetailedDiagram ? this.defaultBackingPumpHeight : this.defaultBackingPumpHeight / 2;
    }
    boosterLayerNumber(pumpSet, boosterLayerIndex) {
        return "" + (pumpSet.pumpsetDetails.boosterLayersDetails.length - boosterLayerIndex);
    }
    boosterRY(isDetailedDiagram) {
        return isDetailedDiagram ? this.defaultBoosterRY : this.defaultBoosterRY / 2;
    }
    boosterRX(isDetailedDiagram) {
        return isDetailedDiagram ? this.defaultBoosterRX : this.defaultBoosterRX / 2;
    }
    parallelPipeOffsetsForBoosterParallelAsDrawn(pumpSet, boosterLayerIndex) {
        if (this.isLastBoosterLayer(pumpSet, boosterLayerIndex) && this.numParallelAsDrawnBoosterLayer(pumpSet, boosterLayerIndex) == 1 && this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex) >= 2) {
            if (this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex) == 2 && this.maxNumParallelBoostersAsDrawn(pumpSet) == 3) {
                return [[0],
                    [-(this.backingPumpWidth + this.inletWidth + this.strokeWidth), this.backingPumpWidth + this.inletWidth],
                    [-(this.backingPumpWidth + this.inletWidth + this.strokeWidth), 0, (this.backingPumpWidth) + this.inletWidth]];
            }
            if (this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex) == 2 && this.maxNumParallelBoostersAsDrawn(pumpSet) == 2) {
                return [[0],
                    [-(this.backingPumpWidth / 2 + this.inletWidth / 2), this.backingPumpWidth / 2 + this.inletWidth / 2],
                    [-(this.backingPumpWidth / 2 + this.inletWidth / 2), 0, (this.backingPumpWidth / 2) + this.inletWidth / 2]];
            }
            if (this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex) == 2 && this.maxNumParallelBoostersAsDrawn(pumpSet) == 1) {
                return [[0],
                    [-(this.backingPumpWidth / 2 + this.inletWidth / 2), this.backingPumpWidth / 2 + this.inletWidth / 2],
                    [-(this.backingPumpWidth / 2 + this.inletWidth / 2), 0, (this.backingPumpWidth / 2) + this.inletWidth / 2]];
            }
            if (this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex) == 3) {
                return [[0], [-(this.backingPumpWidth + this.inletWidth), (this.backingPumpWidth) + this.inletWidth], [-(this.backingPumpWidth + this.inletWidth), 0, (this.backingPumpWidth) + this.inletWidth]];
            }
        }
        if (this.isLastBoosterLayer(pumpSet, boosterLayerIndex) && this.numParallelAsDrawnBoosterLayer(pumpSet, boosterLayerIndex) == 2 && this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex) > 2) {
            if (this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex) == 2) {
                return [[0], [-(this.backingPumpWidth + this.inletWidth / 2), (this.backingPumpWidth) + this.inletWidth / 2], [-(this.backingPumpWidth + this.inletWidth / 2), 0, (this.backingPumpWidth) + this.inletWidth / 2]];
            }
            if (this.numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpSet, boosterLayerIndex) == 3) {
                return [[0], [-(this.backingPumpWidth + this.inletWidth), (this.backingPumpWidth) + this.inletWidth], [-(this.backingPumpWidth + this.inletWidth), 0, (this.backingPumpWidth) + this.inletWidth]];
            }
        }
        let parallel = this.numParallelAsDrawnBoosterLayer(pumpSet, boosterLayerIndex);
        let parallelPipeOffsets;
        switch (parallel) {
            case 2:
                parallelPipeOffsets = [[0],
                    [this.parallelBoosterOffset[1][1][0] - this.pipeWorkStartCTX(pumpSet, boosterLayerIndex), (this.boosterCenterX(pumpSet, boosterLayerIndex, 1) - this.pipeWorkStartCTX(pumpSet, boosterLayerIndex))],
                    [this.parallelBoosterOffset[1][1][0] - this.pipeWorkStartCTX(pumpSet, boosterLayerIndex), 0, (this.boosterCenterX(pumpSet, boosterLayerIndex, 1) - this.pipeWorkStartCTX(pumpSet, boosterLayerIndex))
                    ]];
                break;
            case 3:
                parallelPipeOffsets = [[0],
                    [this.parallelBoosterOffset[2][2][0] - this.pipeWorkStartCTX(pumpSet, boosterLayerIndex), this.parallelBoosterOffset[2][2][2] - this.pipeWorkStartCTX(pumpSet, boosterLayerIndex)],
                    [this.parallelBoosterOffset[2][2][0] - this.pipeWorkStartCTX(pumpSet, boosterLayerIndex), 0, this.parallelBoosterOffset[2][2][2] - this.pipeWorkStartCTX(pumpSet, boosterLayerIndex)]];
                break;
            default:
                parallelPipeOffsets = [[0],
                    [-20, 20],
                    [-20, 0, 20]];
                break;
        }
        return parallelPipeOffsets;
    }
    pipeWorkStartCTX(pumpSet, boosterLayerIndex) {
        switch (this.parallelAsDrawn(this.boosterLayer(pumpSet, boosterLayerIndex).numberOfBoostersInParallel)) {
            case 2: return this.boosterCenterX(pumpSet, boosterLayerIndex, 0) + ((this.boosterCenterX(pumpSet, boosterLayerIndex, 1) - this.boosterCenterX(pumpSet, boosterLayerIndex, 0)) / 2);
            case 3: return this.boosterCenterX(pumpSet, boosterLayerIndex, 1);
            default: return this.boosterCenterX(pumpSet, boosterLayerIndex, 0);
        }
    }
    elementLabelStartX() {
        return this.padding;
    }
    elementLabelWidthForText(text) {
        return text.length * 5;
    }
    drawParallelLabelFor(parallel) {
        return (parallel % 1 > 0 || parallel > this.maxDrawnParallel);
    }
    boosterLayerLabelStartX(pumpset, boosterLayerIndex, isDetailedDiagram) {
        if (this.lastParalellIndexAsDrawn(pumpset.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].numberOfBoostersInParallel)) {
            return (this.boosterCenterX(pumpset, boosterLayerIndex, this.lastParalellIndexAsDrawn(pumpset.pumpsetDetails.boosterLayersDetails[boosterLayerIndex].numberOfBoostersInParallel))
                - this.boosterCenterX(pumpset, boosterLayerIndex, 0)) / 2;
        }
        return this.boosterCenterX(pumpset, boosterLayerIndex, 0);
    }
    boosterLabelText(boosterLayer) {
        return boosterLayer.boosterName.split(' ')[0];
    }
    backingPumpLabelStartX(pumpset, isDetailedDiagram) {
        if (this.lastParalellIndexAsDrawn(pumpset.pumpsetDetails.numberOfBackingPumpsInParallel)) {
            return (((this.backingPumpStartX(pumpset, this.lastParalellIndexAsDrawn(pumpset.pumpsetDetails.numberOfBackingPumpsInParallel)) + this.backingPumpWidth) -
                this.backingPumpStartX(pumpset, 0)) / 2);
        }
        return (this.backingPumpStartX(pumpset, 0) + (this.backingPumpWidth / 2));
    }
    backingPumpLabelText(pumpset) {
        return pumpset.pumpsetDetails.backingPumpName.split(' ')[0];
    }
    centerXOfBoosterLayers(pumpset) {
        let maxParallelAsDrawn = 1;
        let maxParallelAsDrawnIndex = 0;
        pumpset.pumpsetDetails.boosterLayersDetails.forEach((boosterLayer, index) => {
            if (this.parallelAsDrawn(boosterLayer.numberOfBoostersInParallel) > maxParallelAsDrawn) {
                maxParallelAsDrawn = this.parallelAsDrawn(boosterLayer.numberOfBoostersInParallel);
                maxParallelAsDrawnIndex = index;
            }
        });
        return maxParallelAsDrawn == 1 ? this.boosterCenterX(pumpset, maxParallelAsDrawnIndex, 0) :
            ((this.boosterCenterX(pumpset, maxParallelAsDrawnIndex, this.lastParalellIndexAsDrawn(maxParallelAsDrawn))
                - this.boosterCenterX(pumpset, maxParallelAsDrawnIndex, 0)) / 2) + this.boosterCenterX(pumpset, maxParallelAsDrawnIndex, 0);
    }
    centerXOfBackingPumps(pumpset) {
        if (this.parallelAsDrawn(pumpset.pumpsetDetails.numberOfBackingPumpsInParallel) == 1) {
            return this.backingPumpStartX(pumpset, 0) + (this.backingPumpWidth / 2);
        }
        return (((this.backingPumpStartX(pumpset, this.lastParalellIndexAsDrawn(pumpset.pumpsetDetails.numberOfBackingPumpsInParallel)) + this.backingPumpWidth) - this.backingPumpStartX(pumpset, 0)) / 2) + this.backingPumpStartX(pumpset, 0);
    }
    booster(pumpset, boosterLayerIndex) {
        return pumpset.pumpsetDetails.boosterLayersDetails[boosterLayerIndex];
    }
    pipework(pumpset, boosterLayerIndex) {
        return this.booster(pumpset, boosterLayerIndex).pipework;
    }
    pipe(pumpset, boosterLayerIndex, pipeIndex) {
        return this.pipework(pumpset, boosterLayerIndex)[pipeIndex];
    }
    lastBoosterLayerIndex(pumpset) {
        return pumpset.pumpsetDetails.boosterLayersDetails.length - 1;
    }
    numParallelAsDrawnBoosterLayer(pumpset, boosterLayerIndex) {
        return this.parallelAsDrawn(this.boosterLayer(pumpset, boosterLayerIndex).numberOfBoostersInParallel);
    }
    numParallelAsDrawnBackingPump(pumpset) {
        return this.parallelAsDrawn(this.numBackingPumpsInParallel(pumpset));
    }
    numParallelAsDrawnOfNextBoosterLayerOrBackingPump(pumpset, boosterLayerIndex) {
        if (this.isLastBoosterLayer(pumpset, boosterLayerIndex)) {
            return this.numParallelAsDrawnBackingPump(pumpset);
        }
        return this.numParallelAsDrawnBoosterLayer(pumpset, boosterLayerIndex + 1);
    }
    boosterLayerRequiresSpaceForLabel(pumpset) {
        return true;
    }
}

const _c0$2 = ["lib-pipework-svg", ""];
function PipeworkSvgComponent_ng_container_0__svg_rect_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵɵgetCurrentView();
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "rect", 4);
    ɵɵlistener("mousedown", function PipeworkSvgComponent_ng_container_0__svg_rect_1_Template__svg_rect_mousedown_0_listener() { ɵɵrestoreView(_r11); const pipeIndex_r2 = ɵɵnextContext().index; const ctx_r9 = ɵɵnextContext(); return ctx_r9.select(pipeIndex_r2); });
    ɵɵelementStart(1, "title");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const parallelPipeIndex_r8 = ctx.index;
    const pipeIndex_r2 = ɵɵnextContext().index;
    const ctx_r3 = ɵɵnextContext();
    ɵɵproperty("ngClass", ctx_r3.pipeClass(pipeIndex_r2));
    ɵɵattribute("y", ctx_r3.pipeStartY(pipeIndex_r2))("x", ctx_r3.pipeStartX(pipeIndex_r2, parallelPipeIndex_r8))("width", ctx_r3.maxPipeWidth)("height", ctx_r3.pipeHeight(pipeIndex_r2));
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ctx_r3.pipeSummary(pipeIndex_r2), " ");
} }
function PipeworkSvgComponent_ng_container_0__svg_line_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelement(0, "line", 5);
} if (rf & 2) {
    const parallelPipeIndex_r14 = ctx.index;
    const pipeIndex_r2 = ɵɵnextContext().index;
    const ctx_r4 = ɵɵnextContext();
    ɵɵattribute("x1", ctx_r4.pipeStartX(pipeIndex_r2, parallelPipeIndex_r14))("y1", ctx_r4.pipeStartY(pipeIndex_r2) + ctx_r4.pipeHeight(pipeIndex_r2))("x2", ctx_r4.pipeStartX(pipeIndex_r2, parallelPipeIndex_r14) + ctx_r4.maxPipeWidth)("y2", ctx_r4.pipeStartY(pipeIndex_r2) + ctx_r4.pipeHeight(pipeIndex_r2));
} }
function PipeworkSvgComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵnamespaceSVG();
    ɵɵelementStart(1, "text");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = ɵɵnextContext();
    const pipeIndex_r2 = ctx_r16.index;
    const pipe_r1 = ctx_r16.$implicit;
    const ctx_r5 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵattribute("y", ctx_r5.pipeStartY(pipeIndex_r2) + ctx_r5.pipeHeight(pipeIndex_r2) / 2)("x", ctx_r5.pipeStartX(pipeIndex_r2, 0) + 20);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", "x" + ctx_r5.formatNumber(pipe_r1.parallel), " ");
} }
function PipeworkSvgComponent_ng_container_0_ng_container_4__svg_rect_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelement(0, "rect", 7);
} if (rf & 2) {
    const pipeIndex_r2 = ɵɵnextContext(2).index;
    const ctx_r19 = ɵɵnextContext();
    ɵɵproperty("ngClass", ctx_r19.manifoldClass());
    ɵɵattribute("y", ctx_r19.pipeManifoldStartY(pipeIndex_r2))("x", ctx_r19.pipeManifoldStartX(pipeIndex_r2))("width", ctx_r19.pipeManifoldWidth(pipeIndex_r2))("height", ctx_r19.manifoldWidth);
} }
function PipeworkSvgComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PipeworkSvgComponent_ng_container_0_ng_container_4__svg_rect_1_Template, 1, 5, "rect", 6);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const pipeIndex_r2 = ɵɵnextContext().index;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", pipeIndex_r2 > 0);
} }
function PipeworkSvgComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PipeworkSvgComponent_ng_container_0__svg_rect_1_Template, 3, 6, "rect", 1);
    ɵɵtemplate(2, PipeworkSvgComponent_ng_container_0__svg_line_2_Template, 1, 4, "line", 2);
    ɵɵtemplate(3, PipeworkSvgComponent_ng_container_0_ng_container_3_Template, 3, 3, "ng-container", 3);
    ɵɵtemplate(4, PipeworkSvgComponent_ng_container_0_ng_container_4_Template, 2, 1, "ng-container", 0);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const pipe_r1 = ctx.$implicit;
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.array(ctx_r0.parallelAsDrawn(pipe_r1.parallel)));
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.array(ctx_r0.parallelAsDrawn(pipe_r1.parallel)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", pipe_r1.parallel > 3 && ctx_r0.showLabels);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.array(ctx_r0.parallelAsDrawn(pipe_r1.parallel)));
} }
class PipeworkSvgComponent {
    constructor(diagramSelectionService, pipeworkSvgService, formattingService) {
        this.diagramSelectionService = diagramSelectionService;
        this.pipeworkSvgService = pipeworkSvgService;
        this.formattingService = formattingService;
        this.cty = 0;
        this.ctx = 0;
        this.maxDrawnParallel = 3;
        this.maxPipeHeight = 250;
        this.showLabels = true;
        this.lighterStyle = false;
        this.selectable = true;
        this.manifoldWidth = 2;
    }
    ngOnInit() {
        this.pipeworkDrawn = this.clone(this.pipework);
    }
    array(size) {
        return [].constructor(size);
    }
    pipeStartY(pipeIndex) {
        let startY = this.cty;
        this.pipeworkDrawn.forEach((pipe, index) => {
            startY += (index < pipeIndex ? this.pipeHeight(index) : 0);
        });
        return startY;
    }
    pipeStartX(pipeIndex, parallelPipeIndex) {
        return this.pipeworkSvgService.pipeStartX(this.maxPipeWidth, this.maxDrawnParallel, this.parallelPipeOffsets, this.ctx, this.pipeworkDrawn, pipeIndex, parallelPipeIndex);
    }
    pipeHeight(pipeIndex) {
        return (this.pipeworkDrawn[pipeIndex].length <= 0 ? 0.01 : this.pipeworkDrawn[pipeIndex].length) * this.lengthRatio();
    }
    parallelAsDrawn(parallel) {
        return parallel <= this.maxDrawnParallel ? parallel : 1;
    }
    //a manifold is a horizontal pipe connecting pipes of different parallel
    pipeManifoldStartX(pipeIndex) {
        return this.pipeworkSvgService.pipeManifoldStartX(this.maxPipeWidth, this.maxDrawnParallel, this.parallelPipeOffsets, this.ctx, this.pipeworkDrawn, pipeIndex);
    }
    pipeManifoldStartY(pipeIndex) {
        return this.pipeStartY(pipeIndex);
    }
    pipeManifoldWidth(pipeIndex) {
        return this.pipeworkSvgService.pipeManifoldWidth(this.maxPipeWidth, this.maxDrawnParallel, this.parallelPipeOffsets, this.ctx, this.pipeworkDrawn, pipeIndex);
    }
    clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    pipeAboveHasGreaterParallel(pipeIndex) {
        return this.pipeworkDrawn[pipeIndex - 1]
            && this.parallelAsDrawn(this.pipeworkDrawn[pipeIndex - 1].parallel) >
                this.parallelAsDrawn(this.pipeworkDrawn[pipeIndex].parallel);
    }
    pipeClass(pipeIndex) {
        return (this.diagramSelectionService.isElementSelected('pw#' + this.id + '#' + 'p#' + pipeIndex) && this.selectable) ? 'pipe selected' : (this.selectable ? 'pipe' : 'unselectable-pipe');
    }
    manifoldClass() {
        return this.lighterStyle ? 'manifold' : 'manifold';
    }
    select(pipeIndex) {
        if (!this.selectable) {
            return;
        }
        this.diagramSelectionService.selectElementId('pw#' + this.id + '#' + 'p#' + pipeIndex);
    }
    pipeSummary(pipeIndex) {
        return "x" + this.pipeworkDrawn[pipeIndex].parallel + " @ xdim1=" + this.pipeworkDrawn[pipeIndex].xDim1 + ", l=" + this.pipeworkDrawn[pipeIndex].length;
    }
    lengthRatio() {
        return this.pipeLengthRatio ? this.pipeLengthRatio : this.totalPipeLength() > 0 ? this.maxPipeHeight / this.totalPipeLength() : 1;
    }
    totalPipeLength() {
        let totalPipeLength = 0;
        this.pipeworkDrawn.forEach(pipe => {
            totalPipeLength += pipe.length;
        });
        return totalPipeLength;
    }
    formatNumber(number) {
        return this.formattingService.formatNumber(number);
    }
}
PipeworkSvgComponent.ɵfac = function PipeworkSvgComponent_Factory(t) { return new (t || PipeworkSvgComponent)(ɵɵdirectiveInject(DiagramSelectionService), ɵɵdirectiveInject(PipeworkSvgService), ɵɵdirectiveInject(FormattingService)); };
PipeworkSvgComponent.ɵcmp = ɵɵdefineComponent({ type: PipeworkSvgComponent, selectors: [["", "lib-pipework-svg", ""]], inputs: { cty: "cty", ctx: "ctx", pipework: "pipework", pipeLengthRatio: "pipeLengthRatio", maxPipeWidth: "maxPipeWidth", id: "id", parallelPipeOffsets: "parallelPipeOffsets", maxPipeHeight: "maxPipeHeight", showLabels: "showLabels", lighterStyle: "lighterStyle", selectable: "selectable" }, attrs: _c0$2, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [3, "ngClass", "mousedown", 4, "ngFor", "ngForOf"], ["class", "pipeEnd", 4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "ngClass", "mousedown"], [1, "pipeEnd"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"]], template: function PipeworkSvgComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, PipeworkSvgComponent_ng_container_0_Template, 5, 4, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngForOf", ctx.pipeworkDrawn);
    } }, directives: [NgForOf, NgIf, NgClass], styles: [".unselectable-pipe[_ngcontent-%COMP%]{fill:#98b5b5;stroke:#eaf4f5;stroke-width:2}.pipe[_ngcontent-%COMP%]{fill:#98b5b5;stroke:#eaf4f5;stroke-width:1}.lightStyle[_ngcontent-%COMP%]{fill:none;stroke:#98b5b5;stroke-width:2}.manifold[_ngcontent-%COMP%]{fill:#c2d2d3;stroke-width:0}.manifold-lightStyle[_ngcontent-%COMP%]{fill:none;stroke:#5a7d7e;stroke-width:2}.pipe[_ngcontent-%COMP%]:hover{fill:#f4f7f7;stroke:#5a7d7e;stroke-width:1}text[_ngcontent-%COMP%]{font-size:12px;font-weight:400}.pipeEnd[_ngcontent-%COMP%]{stroke:#f4f7f7;stroke-width:2}.selected[_ngcontent-%COMP%]{stroke:#5a7d7e;stroke-width:1}.selected[_ngcontent-%COMP%], .selected[_ngcontent-%COMP%]:hover{fill:#fbe6b7}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PipeworkSvgComponent, [{
        type: Component,
        args: [{
                selector: '[lib-pipework-svg]',
                templateUrl: './pipework-svg.component.svg',
                styleUrls: ['./pipework-svg.component.css']
            }]
    }], function () { return [{ type: DiagramSelectionService }, { type: PipeworkSvgService }, { type: FormattingService }]; }, { cty: [{
            type: Input
        }], ctx: [{
            type: Input
        }], pipework: [{
            type: Input
        }], pipeLengthRatio: [{
            type: Input
        }], maxPipeWidth: [{
            type: Input
        }], id: [{
            type: Input
        }], parallelPipeOffsets: [{
            type: Input
        }], maxPipeHeight: [{
            type: Input
        }], showLabels: [{
            type: Input
        }], lighterStyle: [{
            type: Input
        }], selectable: [{
            type: Input
        }] }); })();

const _c0$3 = ["lib-pumpset-svg", ""];
function PumpSetSvgComponent__svg_g_0__svg_rect_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "rect", 5);
    ɵɵlistener("mousedown", function PumpSetSvgComponent__svg_g_0__svg_rect_1_Template__svg_rect_mousedown_0_listener() { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(2); return ctx_r4.selectPumpSet(); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ctx_r1.elementClass("ps#", "pumpSet"));
    ɵɵattribute("y", ctx_r1.lty + ctx_r1.pumpSetSvgService.pumpSetStartY())("x", ctx_r1.ltx + ctx_r1.pumpSetSvgService.pumpSetStartX())("width", ctx_r1.pumpSetSvgService.pumpSetWidth(ctx_r1.pumpSet, ctx_r1.detailedDiagram))("height", ctx_r1.pumpSetSvgService.pumpSetHeight(ctx_r1.pumpSet, ctx_r1.pipeLengthRatio, ctx_r1.detailedDiagram));
} }
function PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_rect_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelement(0, "rect", 12);
} if (rf & 2) {
    const boosterLayerIndex_r7 = ɵɵnextContext(2).index;
    const ctx_r11 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ctx_r11.manifoldClass());
    ɵɵattribute("x", ctx_r11.ltx + ctx_r11.pumpSetSvgService.boosterLayerManifoldStartX(ctx_r11.pumpSet, boosterLayerIndex_r7))("y", ctx_r11.lty + ctx_r11.pumpSetSvgService.boosterLayerManifoldStartY(ctx_r11.pumpSet, ctx_r11.pipeLengthRatio, boosterLayerIndex_r7, ctx_r11.detailedDiagram))("width", ctx_r11.pumpSetSvgService.boosterLayerManifoldWidth(ctx_r11.pumpSet, boosterLayerIndex_r7))("height", ctx_r11.pumpSetSvgService.manifoldPipeWidth);
} }
function PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_rect_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelement(0, "rect", 12);
} if (rf & 2) {
    const boosterLayerIndex_r7 = ɵɵnextContext(2).index;
    const ctx_r12 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ctx_r12.manifoldClass());
    ɵɵattribute("x", ctx_r12.ltx + ctx_r12.pumpSetSvgService.pipeWorkManifoldStartX(ctx_r12.pumpSet, boosterLayerIndex_r7))("y", ctx_r12.lty + ctx_r12.pumpSetSvgService.pipeWorkStartCTY(ctx_r12.pumpSet, ctx_r12.pipeLengthRatio, boosterLayerIndex_r7, ctx_r12.detailedDiagram))("width", ctx_r12.pumpSetSvgService.pipeWorkManifoldWidth(ctx_r12.pumpSet, boosterLayerIndex_r7))("height", ctx_r12.pumpSetSvgService.manifoldPipeWidth);
} }
function PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "text");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const parallelBoosterIndex_r10 = ɵɵnextContext().index;
    const ctx_r19 = ɵɵnextContext();
    const boosterLayerIndex_r7 = ctx_r19.index;
    const boosterLayer_r6 = ctx_r19.$implicit;
    const ctx_r13 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵattribute("y", ctx_r13.lty + ctx_r13.pumpSetSvgService.boosterCenterY(ctx_r13.pumpSet, ctx_r13.pipeLengthRatio, boosterLayerIndex_r7, ctx_r13.detailedDiagram) + 3)("x", ctx_r13.ltx + ctx_r13.pumpSetSvgService.boosterCenterX(ctx_r13.pumpSet, boosterLayerIndex_r7, parallelBoosterIndex_r10) + ctx_r13.pumpSetSvgService.boosterRX(ctx_r13.detailedDiagram) + 5);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", "x" + ctx_r13.formatNumber(boosterLayer_r6.numberOfBoostersInParallel), " ");
} }
function PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_rect_5_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵɵgetCurrentView();
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "rect", 13);
    ɵɵlistener("mousedown", function PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_rect_5_Template__svg_rect_mousedown_0_listener() { ɵɵrestoreView(_r23); const boosterLayerIndex_r7 = ɵɵnextContext(2).index; const ctx_r21 = ɵɵnextContext(2); return ctx_r21.selectComponent("b#" + boosterLayerIndex_r7); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = ɵɵnextContext(2);
    const boosterLayerIndex_r7 = ctx_r24.index;
    const boosterLayer_r6 = ctx_r24.$implicit;
    const ctx_r14 = ɵɵnextContext(2);
    ɵɵattribute("y", ctx_r14.lty + ctx_r14.pumpSetSvgService.boosterCenterY(ctx_r14.pumpSet, ctx_r14.pipeLengthRatio, boosterLayerIndex_r7, ctx_r14.detailedDiagram) - 10)("x", ctx_r14.ltx + ctx_r14.ltx + ctx_r14.pumpSetSvgService.centerXOfBoosterLayers(ctx_r14.pumpSet) - ctx_r14.pumpSetSvgService.elementLabelWidthForText(ctx_r14.pumpSetSvgService.boosterLabelText(boosterLayer_r6)) / 2)("width", ctx_r14.pumpSetSvgService.elementLabelWidthForText(ctx_r14.pumpSetSvgService.boosterLabelText(boosterLayer_r6)))("height", 20);
} }
function PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_text_6_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵɵgetCurrentView();
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "text", 14);
    ɵɵlistener("mousedown", function PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_text_6_Template__svg_text_mousedown_0_listener() { ɵɵrestoreView(_r27); const boosterLayerIndex_r7 = ɵɵnextContext(2).index; const ctx_r25 = ɵɵnextContext(2); return ctx_r25.selectComponent("b#" + boosterLayerIndex_r7); });
    ɵɵelementStart(1, "title");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵtext(3);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = ɵɵnextContext(2);
    const boosterLayerIndex_r7 = ctx_r28.index;
    const boosterLayer_r6 = ctx_r28.$implicit;
    const ctx_r15 = ɵɵnextContext(2);
    ɵɵattribute("y", ctx_r15.lty + ctx_r15.pumpSetSvgService.boosterCenterY(ctx_r15.pumpSet, ctx_r15.pipeLengthRatio, boosterLayerIndex_r7, ctx_r15.detailedDiagram) + 4)("x", ctx_r15.ltx + ctx_r15.pumpSetSvgService.centerXOfBoosterLayers(ctx_r15.pumpSet));
    ɵɵadvance(2);
    ɵɵtextInterpolate(boosterLayer_r6.boosterName);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r15.pumpSetSvgService.boosterLabelText(boosterLayer_r6), " ");
} }
function PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "rect", 11);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const parallelBoosterIndex_r10 = ɵɵnextContext().index;
    const boosterLayerIndex_r7 = ɵɵnextContext().index;
    const ctx_r16 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵattribute("y", ctx_r16.lty + ctx_r16.pumpSetSvgService.boosterCenterY(ctx_r16.pumpSet, ctx_r16.pipeLengthRatio, boosterLayerIndex_r7, ctx_r16.detailedDiagram) - (ctx_r16.pumpSetSvgService.boosterRY(ctx_r16.detailedDiagram) + ctx_r16.pumpSetSvgService.boosterInletHeight))("x", ctx_r16.ltx + ctx_r16.pumpSetSvgService.boosterCenterX(ctx_r16.pumpSet, boosterLayerIndex_r7, parallelBoosterIndex_r10) - ctx_r16.pumpSetSvgService.inletWidth / 2)("width", ctx_r16.pumpSetSvgService.inletWidth)("height", ctx_r16.pumpSetSvgService.boosterInletHeight);
} }
function PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵɵgetCurrentView();
    ɵɵnamespaceSVG();
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_rect_1_Template, 1, 5, "rect", 7);
    ɵɵtemplate(2, PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_rect_2_Template, 1, 5, "rect", 7);
    ɵɵelementStart(3, "ellipse", 8);
    ɵɵlistener("mousedown", function PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2_Template__svg_ellipse_mousedown_3_listener() { ɵɵrestoreView(_r33); const boosterLayerIndex_r7 = ɵɵnextContext().index; const ctx_r31 = ɵɵnextContext(2); return ctx_r31.selectComponent("b#" + boosterLayerIndex_r7); });
    ɵɵelementEnd();
    ɵɵtemplate(4, PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_ng_container_4_Template, 3, 3, "ng-container", 4);
    ɵɵtemplate(5, PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_rect_5_Template, 1, 4, "rect", 9);
    ɵɵtemplate(6, PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_text_6_Template, 4, 4, "text", 10);
    ɵɵtemplate(7, PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2__svg_ng_container_7_Template, 2, 4, "ng-container", 4);
    ɵɵelement(8, "rect", 11);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const parallelBoosterIndex_r10 = ctx.index;
    const ctx_r34 = ɵɵnextContext();
    const boosterLayerIndex_r7 = ctx_r34.index;
    const boosterLayer_r6 = ctx_r34.$implicit;
    const ctx_r8 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.pumpSetSvgService.drawManifoldAtBottomOfLayer(ctx_r8.pumpSet, boosterLayerIndex_r7));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.pumpSetSvgService.drawPipeworkManifold(ctx_r8.pumpSet, boosterLayerIndex_r7));
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ctx_r8.elementClass("b#" + boosterLayerIndex_r7, "booster"));
    ɵɵattribute("cx", ctx_r8.ltx + ctx_r8.pumpSetSvgService.boosterCenterX(ctx_r8.pumpSet, boosterLayerIndex_r7, parallelBoosterIndex_r10))("cy", ctx_r8.lty + ctx_r8.pumpSetSvgService.boosterCenterY(ctx_r8.pumpSet, ctx_r8.pipeLengthRatio, boosterLayerIndex_r7, ctx_r8.detailedDiagram))("rx", ctx_r8.pumpSetSvgService.boosterRX(ctx_r8.detailedDiagram))("ry", ctx_r8.pumpSetSvgService.boosterRY(ctx_r8.detailedDiagram));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.pumpSetSvgService.drawParallelLabelFor(boosterLayer_r6.numberOfBoostersInParallel));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.detailedDiagram);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.detailedDiagram);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", boosterLayerIndex_r7 > 0);
    ɵɵadvance(1);
    ɵɵattribute("y", ctx_r8.lty + ctx_r8.pumpSetSvgService.boosterCenterY(ctx_r8.pumpSet, ctx_r8.pipeLengthRatio, boosterLayerIndex_r7, ctx_r8.detailedDiagram) + ctx_r8.pumpSetSvgService.boosterRY(ctx_r8.detailedDiagram))("x", ctx_r8.ltx + ctx_r8.pumpSetSvgService.boosterCenterX(ctx_r8.pumpSet, boosterLayerIndex_r7, parallelBoosterIndex_r10) - ctx_r8.pumpSetSvgService.inletWidth / 2)("width", ctx_r8.pumpSetSvgService.inletWidth)("height", ctx_r8.pumpSetSvgService.boosterInletHeight);
} }
function PumpSetSvgComponent__svg_g_0__svg_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "g", 6);
    ɵɵtemplate(2, PumpSetSvgComponent__svg_g_0__svg_ng_container_2__svg_ng_container_2_Template, 9, 15, "ng-container", 3);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const boosterLayer_r6 = ctx.$implicit;
    const boosterLayerIndex_r7 = ctx.index;
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("id", boosterLayerIndex_r7)("pipework", boosterLayer_r6.pipework)("ctx", ctx_r2.ltx + ctx_r2.pumpSetSvgService.pipeWorkStartCTX(ctx_r2.pumpSet, boosterLayerIndex_r7))("cty", ctx_r2.lty + ctx_r2.pumpSetSvgService.pipeWorkStartCTY(ctx_r2.pumpSet, ctx_r2.pipeLengthRatio, boosterLayerIndex_r7, ctx_r2.detailedDiagram))("pipeLengthRatio", ctx_r2.pumpSetSvgService.pipeLengthRatio(ctx_r2.pumpSet))("maxPipeWidth", ctx_r2.pumpSetSvgService.maxPipeWidth)("parallelPipeOffsets", ctx_r2.pumpSetSvgService.parallelPipeOffsetsForBoosterParallelAsDrawn(ctx_r2.pumpSet, boosterLayerIndex_r7))("pipeLengthRatio", ctx_r2.pipeLengthRatio)("showLabels", ctx_r2.detailedDiagram)("lighterStyle", !ctx_r2.detailedDiagram)("selectable", ctx_r2.detailedDiagram);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r2.array(ctx_r2.pumpSetSvgService.parallelAsDrawn(boosterLayer_r6.numberOfBoostersInParallel)));
} }
function PumpSetSvgComponent__svg_g_0__svg_ng_container_3__svg_ng_container_1__svg_text_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "text");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const parallelBackingPumpNumber_r39 = ɵɵnextContext().index;
    const ctx_r40 = ɵɵnextContext(3);
    ɵɵattribute("y", ctx_r40.lty + ctx_r40.pumpSetSvgService.backingPumpStartY(ctx_r40.pumpSet, ctx_r40.pipeLengthRatio, ctx_r40.detailedDiagram) + ctx_r40.pumpSetSvgService.backingPumpHeight(ctx_r40.detailedDiagram) / 2)("x", ctx_r40.ltx + ctx_r40.pumpSetSvgService.backingPumpStartX(ctx_r40.pumpSet, parallelBackingPumpNumber_r39) + ctx_r40.pumpSetSvgService.backingPumpWidth + ctx_r40.pumpSetSvgService.backingPumpWidth * 0.1);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", "x" + ctx_r40.formatNumber(ctx_r40.pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel), " ");
} }
function PumpSetSvgComponent__svg_g_0__svg_ng_container_3__svg_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r43 = ɵɵgetCurrentView();
    ɵɵnamespaceSVG();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "rect", 15);
    ɵɵlistener("mousedown", function PumpSetSvgComponent__svg_g_0__svg_ng_container_3__svg_ng_container_1_Template__svg_rect_mousedown_1_listener() { ɵɵrestoreView(_r43); const ctx_r42 = ɵɵnextContext(3); return ctx_r42.selectComponent("bp#"); });
    ɵɵelementEnd();
    ɵɵelement(2, "rect", 11);
    ɵɵtemplate(3, PumpSetSvgComponent__svg_g_0__svg_ng_container_3__svg_ng_container_1__svg_text_3_Template, 2, 3, "text", 4);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const parallelBackingPumpNumber_r39 = ctx.index;
    const ctx_r35 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ctx_r35.elementClass("bp#", "backingPump"));
    ɵɵattribute("y", ctx_r35.lty + ctx_r35.pumpSetSvgService.backingPumpStartY(ctx_r35.pumpSet, ctx_r35.pipeLengthRatio, ctx_r35.detailedDiagram))("x", ctx_r35.ltx + ctx_r35.pumpSetSvgService.backingPumpStartX(ctx_r35.pumpSet, parallelBackingPumpNumber_r39))("width", ctx_r35.pumpSetSvgService.backingPumpWidth)("height", ctx_r35.pumpSetSvgService.backingPumpHeight(ctx_r35.detailedDiagram));
    ɵɵadvance(1);
    ɵɵattribute("y", ctx_r35.lty + ctx_r35.pumpSetSvgService.backingPumpStartY(ctx_r35.pumpSet, ctx_r35.pipeLengthRatio, ctx_r35.detailedDiagram) - ctx_r35.pumpSetSvgService.backingPumpInletHeight)("x", ctx_r35.ltx + ctx_r35.pumpSetSvgService.backingPumpStartX(ctx_r35.pumpSet, parallelBackingPumpNumber_r39) + ctx_r35.pumpSetSvgService.backingPumpWidth / 2 - ctx_r35.pumpSetSvgService.inletWidth / 2)("width", ctx_r35.pumpSetSvgService.inletWidth)("height", ctx_r35.pumpSetSvgService.backingPumpInletHeight);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r35.pumpSetSvgService.drawParallelLabelFor(ctx_r35.pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel) && ctx_r35.detailedDiagram);
} }
function PumpSetSvgComponent__svg_g_0__svg_ng_container_3__svg_rect_2_Template(rf, ctx) { if (rf & 1) {
    const _r45 = ɵɵgetCurrentView();
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "rect", 13);
    ɵɵlistener("mousedown", function PumpSetSvgComponent__svg_g_0__svg_ng_container_3__svg_rect_2_Template__svg_rect_mousedown_0_listener() { ɵɵrestoreView(_r45); const ctx_r44 = ɵɵnextContext(3); return ctx_r44.selectComponent("bp#"); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = ɵɵnextContext(3);
    ɵɵattribute("y", ctx_r36.lty + ctx_r36.pumpSetSvgService.backingPumpStartY(ctx_r36.pumpSet, ctx_r36.pipeLengthRatio, ctx_r36.detailedDiagram) + ctx_r36.pumpSetSvgService.backingPumpHeight(ctx_r36.detailedDiagram) / 2 - 15)("x", ctx_r36.ltx + ctx_r36.pumpSetSvgService.centerXOfBackingPumps(ctx_r36.pumpSet) - ctx_r36.pumpSetSvgService.elementLabelWidthForText(ctx_r36.pumpSet.pumpsetDetails.backingPumpName.split(" ")[0]) / 2)("width", ctx_r36.pumpSetSvgService.elementLabelWidthForText(ctx_r36.pumpSet.pumpsetDetails.backingPumpName.split(" ")[0]))("height", 20);
} }
function PumpSetSvgComponent__svg_g_0__svg_ng_container_3__svg_text_3_Template(rf, ctx) { if (rf & 1) {
    const _r47 = ɵɵgetCurrentView();
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "text", 14);
    ɵɵlistener("mousedown", function PumpSetSvgComponent__svg_g_0__svg_ng_container_3__svg_text_3_Template__svg_text_mousedown_0_listener() { ɵɵrestoreView(_r47); const ctx_r46 = ɵɵnextContext(3); return ctx_r46.selectComponent("bp#"); });
    ɵɵelementStart(1, "title");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵtext(3);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = ɵɵnextContext(3);
    ɵɵattribute("y", ctx_r37.lty + ctx_r37.pumpSetSvgService.backingPumpStartY(ctx_r37.pumpSet, ctx_r37.pipeLengthRatio, ctx_r37.detailedDiagram) + ctx_r37.pumpSetSvgService.backingPumpHeight(ctx_r37.detailedDiagram) / 2)("x", ctx_r37.ltx + ctx_r37.pumpSetSvgService.centerXOfBackingPumps(ctx_r37.pumpSet))("title", ctx_r37.pumpSet.pumpsetDetails.backingPumpName);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r37.pumpSet.pumpsetDetails.backingPumpName);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r37.pumpSetSvgService.backingPumpLabelText(ctx_r37.pumpSet), " ");
} }
const _c1 = function () { return []; };
function PumpSetSvgComponent__svg_g_0__svg_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PumpSetSvgComponent__svg_g_0__svg_ng_container_3__svg_ng_container_1_Template, 4, 10, "ng-container", 3);
    ɵɵtemplate(2, PumpSetSvgComponent__svg_g_0__svg_ng_container_3__svg_rect_2_Template, 1, 4, "rect", 9);
    ɵɵtemplate(3, PumpSetSvgComponent__svg_g_0__svg_ng_container_3__svg_text_3_Template, 4, 5, "text", 10);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ɵɵpureFunction0(3, _c1).constructor(ctx_r3.pumpSetSvgService.parallelAsDrawn(ctx_r3.pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.detailedDiagram);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.detailedDiagram);
} }
function PumpSetSvgComponent__svg_g_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "g", 1);
    ɵɵtemplate(1, PumpSetSvgComponent__svg_g_0__svg_rect_1_Template, 1, 5, "rect", 2);
    ɵɵtemplate(2, PumpSetSvgComponent__svg_g_0__svg_ng_container_2_Template, 3, 12, "ng-container", 3);
    ɵɵtemplate(3, PumpSetSvgComponent__svg_g_0__svg_ng_container_3_Template, 4, 4, "ng-container", 4);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.drawBoundingBox);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.pumpSet.pumpsetDetails.boosterLayersDetails);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.pumpSet.pumpsetDetails.numberOfBackingPumpsInParallel > 0);
} }
class PumpSetSvgComponent {
    constructor(diagramSelectionService, formattingService) {
        this.diagramSelectionService = diagramSelectionService;
        this.formattingService = formattingService;
        this.pumpSetSvgService = new PumpSetSvgService();
        this.maxPipeHeight = 0;
        this.pipeLengthRatio = 0;
        this.detailedDiagram = true;
        this.lighterStyle = false;
        this.selectableComponents = false;
        this.drawBoundingBox = true;
    }
    ngOnChanges(changes) {
        this.pumpSet = JSON.parse(JSON.stringify(this.pumpSetObj));
        this.pumpSet.pumpsetDetails.boosterLayersDetails.reverse();
    }
    ngOnInit() {
    }
    selectComponent(id) {
        if (this.selectableComponents) {
            this.selectElement(id);
        }
    }
    selectPumpSet() {
        if (!this.selectableComponents) {
            this.selectElement("ps#");
        }
    }
    selectElement(id) {
        this.diagramSelectionService.selectElementId(id);
    }
    elementClass(id, unselectedClass) {
        return this.diagramSelectionService.isElementSelected(id) ? unselectedClass + ' selected' : unselectedClass;
    }
    array(size) {
        return [].constructor(size);
    }
    manifoldClass() {
        return this.lighterStyle ? 'manifold' : 'manifold';
    }
    formatNumber(number) {
        return this.formattingService.formatNumber(number);
    }
}
PumpSetSvgComponent.ɵfac = function PumpSetSvgComponent_Factory(t) { return new (t || PumpSetSvgComponent)(ɵɵdirectiveInject(DiagramSelectionService), ɵɵdirectiveInject(FormattingService)); };
PumpSetSvgComponent.ɵcmp = ɵɵdefineComponent({ type: PumpSetSvgComponent, selectors: [["", "lib-pumpset-svg", ""]], inputs: { pumpSetObj: "pumpSetObj", ltx: "ltx", lty: "lty", maxPipeHeight: "maxPipeHeight", pipeLengthRatio: "pipeLengthRatio", detailedDiagram: "detailedDiagram", lighterStyle: "lighterStyle", selectableComponents: "selectableComponents", drawBoundingBox: "drawBoundingBox" }, features: [ɵɵNgOnChangesFeature], attrs: _c0$3, decls: 1, vars: 1, consts: [["style", "transform:scale(1)", 4, "ngIf"], [2, "transform", "scale(1)"], ["class", "pumpSet", 3, "ngClass", "mousedown", 4, "ngIf"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "pumpSet", 3, "ngClass", "mousedown"], ["lib-pipework-svg", "", 3, "id", "pipework", "ctx", "cty", "pipeLengthRatio", "maxPipeWidth", "parallelPipeOffsets", "showLabels", "lighterStyle", "selectable"], [3, "ngClass", 4, "ngIf"], [1, "booster", 3, "ngClass", "mousedown"], ["class", "label", 3, "mousedown", 4, "ngIf"], ["class", "labelText", "text-anchor", "middle", 3, "mousedown", 4, "ngIf"], [1, "inlet"], [3, "ngClass"], [1, "label", 3, "mousedown"], ["text-anchor", "middle", 1, "labelText", 3, "mousedown"], [3, "ngClass", "mousedown"]], template: function PumpSetSvgComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, PumpSetSvgComponent__svg_g_0_Template, 4, 3, "g", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.pumpSet);
    } }, directives: [NgIf, NgForOf, NgClass, PipeworkSvgComponent], styles: [".pipe[_ngcontent-%COMP%]{fill:#98b5b5;stroke:#5a7d7e;stroke-width:0}.joint[_ngcontent-%COMP%]{fill:#eaf4f5;stroke:#5a7d7e;stroke-width:.5}.pumpSet[_ngcontent-%COMP%]{fill:#f4f7f7;stroke:#5a7d7e;stroke-width:2}.booster[_ngcontent-%COMP%]{fill:#eaf4f5;stroke:#6c9494;stroke-width:2}.booster[_ngcontent-%COMP%]:hover{fill:#fafbfb}.backingPump[_ngcontent-%COMP%]{fill:#eaf4f5;stroke:#6c9494;stroke-width:2}.inlet[_ngcontent-%COMP%]{fill:#eaf4f5;stroke:#6c9494;stroke-width:.5}.backingPump[_ngcontent-%COMP%]:hover{fill:#fafbfb}text[_ngcontent-%COMP%]{font-size:12px;font-weight:400}.label[_ngcontent-%COMP%]{fill:#eaf4f5;stroke:none}.labelText[_ngcontent-%COMP%]{fill:#eaf4f5;font-weight:10;stroke:#618585}.selected[_ngcontent-%COMP%]{stroke:#5a7d7e;stroke-width:1}.selected[_ngcontent-%COMP%], .selected[_ngcontent-%COMP%]:hover{fill:#fbe6b7}.manifold[_ngcontent-%COMP%]{fill:#c2d2d3;stroke-width:0}.manifold-lightStyle[_ngcontent-%COMP%]{fill:none;stroke:#5a7d7e;stroke-width:1.5}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PumpSetSvgComponent, [{
        type: Component,
        args: [{
                selector: '[lib-pumpset-svg]',
                templateUrl: './pumpset-svg.component.svg',
                styleUrls: ['./pumpset-svg.component.css']
            }]
    }], function () { return [{ type: DiagramSelectionService }, { type: FormattingService }]; }, { pumpSetObj: [{
            type: Input
        }], ltx: [{
            type: Input
        }], lty: [{
            type: Input
        }], maxPipeHeight: [{
            type: Input
        }], pipeLengthRatio: [{
            type: Input
        }], detailedDiagram: [{
            type: Input
        }], lighterStyle: [{
            type: Input
        }], selectableComponents: [{
            type: Input
        }], drawBoundingBox: [{
            type: Input
        }] }); })();

const _c0$4 = ["lib-label-svg", ""];
function LabelSvgComponent__svg_rect_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelement(0, "rect", 2);
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵattribute("y", ctx_r0.cy - 14)("x", ctx_r0.cx - ctx_r0.maxWidth / 2)("width", ctx_r0.maxWidth)("height", 20);
} }
class LabelSvgComponent {
    constructor() {
        this.text = "";
        this.background = true;
    }
    ngOnInit() {
    }
    truncateTextToFitWidth(text, width) {
        let result = text.substring(0, (width / 6) - 3);
        return result + (result.length < text.length ? ".." : "");
    }
}
LabelSvgComponent.ɵfac = function LabelSvgComponent_Factory(t) { return new (t || LabelSvgComponent)(); };
LabelSvgComponent.ɵcmp = ɵɵdefineComponent({ type: LabelSvgComponent, selectors: [["", "lib-label-svg", ""]], inputs: { text: "text", cy: "cy", cx: "cx", maxWidth: "maxWidth", background: "background" }, attrs: _c0$4, decls: 5, vars: 5, consts: [["class", "label", 4, "ngIf"], ["text-anchor", "middle", 1, "labelText"], [1, "label"]], template: function LabelSvgComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, LabelSvgComponent__svg_rect_0_Template, 1, 4, "rect", 0);
        ɵɵnamespaceSVG();
        ɵɵelementStart(1, "text", 1);
        ɵɵelementStart(2, "title");
        ɵɵtext(3);
        ɵɵelementEnd();
        ɵɵtext(4);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.background);
        ɵɵadvance(1);
        ɵɵattribute("y", ctx.cy)("x", ctx.cx);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.text);
        ɵɵadvance(1);
        ɵɵtextInterpolate1(" ", ctx.truncateTextToFitWidth(ctx.text, ctx.maxWidth), "\n");
    } }, directives: [NgIf], styles: [".label[_ngcontent-%COMP%]{fill:#eaf4f5;stroke:none}.labelText[_ngcontent-%COMP%]{fill:#eaf4f5;font-weight:10;stroke:#618585}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LabelSvgComponent, [{
        type: Component,
        args: [{
                selector: '[lib-label-svg]',
                templateUrl: './label-svg.component.svg',
                styleUrls: ['./label-svg.component.css']
            }]
    }], function () { return []; }, { text: [{
            type: Input
        }], cy: [{
            type: Input
        }], cx: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], background: [{
            type: Input
        }] }); })();

class UtilsService {
    constructor() { }
    clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    getValueForPath(obj, path) {
        for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
            if (!obj)
                return undefined;
            obj = obj[path[i]];
        }
        ;
        return obj;
    }
    ;
    path(path) {
        return path.join('.');
    }
}
UtilsService.ɵfac = function UtilsService_Factory(t) { return new (t || UtilsService)(); };
UtilsService.ɵprov = ɵɵdefineInjectable({ token: UtilsService, factory: UtilsService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UtilsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
const isIframe = window !== window.parent && !window.opener;
function loggerCallback(logLevel, message) {
    console.log(message);
}
function MSALInstanceFactory() {
    return new PublicClientApplication({
        auth: {
            clientId: 'ddb09d67-b5ea-4442-b7f5-0d349a1d261a',
            authority: 'https://login.microsoftonline.com/43e4b026-d1f2-45e6-a6de-8abec322554a/',
            redirectUri: '/',
            postLogoutRedirectUri: '/'
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            storeAuthStateInCookie: isIE,
        },
        system: {
            loggerOptions: {
                loggerCallback,
                logLevel: LogLevel.Info,
                piiLoggingEnabled: false
            }
        }
    });
}
function MSALInterceptorConfigFactory() {
    const protectedResourceMap = new Map();
    protectedResourceMap.set('http://localhost:3000/api/', ['https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user']);
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}
function getMyFactory() {
    const res = () => window;
    return res;
}
class PumpcalcCoreModule {
    static forRoot(app_config) {
        return {
            ngModule: PumpcalcCoreModule,
            providers: [
                GasService,
                { provide: 'app_config', useValue: app_config },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: MsalInterceptor,
                    multi: true
                },
                {
                    provide: MSAL_INSTANCE,
                    useFactory: () => {
                        return new PublicClientApplication({
                            auth: {
                                clientId: 'ddb09d67-b5ea-4442-b7f5-0d349a1d261a',
                                authority: 'https://login.microsoftonline.com/43e4b026-d1f2-45e6-a6de-8abec322554a/',
                                redirectUri: app_config.app_config.redirectUrl,
                                postLogoutRedirectUri: '/'
                            },
                            cache: {
                                cacheLocation: BrowserCacheLocation.LocalStorage,
                                storeAuthStateInCookie: isIE,
                            },
                            system: {
                                loggerOptions: {
                                    loggerCallback,
                                    logLevel: LogLevel.Info,
                                    piiLoggingEnabled: false
                                }
                            }
                        });
                    }
                },
                {
                    provide: MSAL_INTERCEPTOR_CONFIG,
                    useFactory: () => {
                        const protectedResourceMap = new Map();
                        protectedResourceMap.set(app_config.app_config.apiRootURL, ['https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user']);
                        return { interactionType: InteractionType.Redirect, protectedResourceMap };
                    }
                },
                // {
                //   provide: MSAL_CONFIG, useValue: {
                //     auth: { clientId: '756e3656-80cc-4c5a-ab25-ced6c6fe7d0f', authority: 'https://login.microsoftonline.com/43e4b026-d1f2-45e6-a6de-8abec322554a/', redirectUri: app_config.app_config.redirectUrl }, cache: { cacheLocation: 'localStorage', }, popUp: false,
                //     unprotectedResources: [],
                //     consentScopes: [
                //       "https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user",
                //       "https://graph.microsoft.com/profile",
                //     ],
                //     protectedResourceMap: [
                //       [app_config.app_config.apiRootURL, ['https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user']],
                //     ],
                //   }
                // },
                // {
                //   provide: MSAL_CONFIG_ANGULAR, useValue: {
                //     auth: { clientId: '756e3656-80cc-4c5a-ab25-ced6c6fe7d0f', authority: 'https://login.microsoftonline.com/43e4b026-d1f2-45e6-a6de-8abec322554a/', redirectUri: app_config.app_config.redirectUrl }, cache: { cacheLocation: 'localStorage', }, popUp: false,
                //     unprotectedResources: [],
                //     consentScopes: [
                //       "https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user",
                //       "https://graph.microsoft.com/profile",
                //     ],
                //     protectedResourceMap: [
                //       [app_config.app_config.apiRootURL, ['https://vtpumpcalcweb.onmicrosoft.com/a8a7273e-005f-499e-ac8d-4c2d9c73e8ed/access_as_user']],
                //     ],
                //   }
                // },
                // {
                //   provide: HTTP_INTERCEPTORS,
                //   useClass: MsalInterceptor,
                //   multi: true
                // },
                MsalService,
                MsalBroadcastService,
                LoginService
            ],
        };
    }
}
PumpcalcCoreModule.ɵmod = ɵɵdefineNgModule({ type: PumpcalcCoreModule });
PumpcalcCoreModule.ɵinj = ɵɵdefineInjector({ factory: function PumpcalcCoreModule_Factory(t) { return new (t || PumpcalcCoreModule)(); }, providers: [
        DatatypesService,
        GasService,
        DataCacheService,
        RestDataService,
        FormattingService,
        UIEventsService,
        HttpClient,
        AppEventService,
        UserService,
        PumpSetSvgService,
        PipeworkSvgService,
        UtilsService,
        DiagramSelectionService
    ], imports: [[
            DxNumberBoxModule,
            DxDataGridModule,
            DxDropDownBoxModule,
            DxTreeViewModule,
            DxSelectBoxModule,
            DxLoadIndicatorModule,
            DxButtonModule,
            DxPopupModule,
            DxScrollViewModule,
            CommonModule,
            BrowserModule,
            FormsModule,
            NgUnitsModule.forRoot(systemOfUnitsInitializer()),
            MsalModule,
            HttpClientModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(PumpcalcCoreModule, { declarations: [PumpcalcCoreComponent,
        HeaderComponent,
        FooterComponent,
        NumberFieldComponent,
        StandardPipeSelectorComponent,
        GasSelectorComponent,
        StatusBarComponent,
        PipeworkComponent,
        LoginComponent,
        MsalComponent,
        UnitsSelector,
        UnitsSettingsComponent,
        UnitSettingsDialogueComponent,
        TopMenuComponent,
        HeaderComponent,
        LoaderComponent,
        LabelSvgComponent,
        PumpSetSvgComponent,
        PipeworkSvgComponent], imports: [DxNumberBoxModule,
        DxDataGridModule,
        DxDropDownBoxModule,
        DxTreeViewModule,
        DxSelectBoxModule,
        DxLoadIndicatorModule,
        DxButtonModule,
        DxPopupModule,
        DxScrollViewModule,
        CommonModule,
        BrowserModule,
        FormsModule, NgUnitsModule, MsalModule,
        HttpClientModule], exports: [PumpcalcCoreComponent,
        FooterComponent,
        NumberFieldComponent,
        StandardPipeSelectorComponent,
        GasSelectorComponent,
        StatusBarComponent,
        PipeworkComponent,
        LoginComponent,
        MsalComponent,
        UnitsSelector,
        UnitsSettingsComponent,
        UnitSettingsDialogueComponent,
        TopMenuComponent,
        HeaderComponent,
        LoaderComponent,
        LabelSvgComponent,
        PumpSetSvgComponent,
        PipeworkSvgComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(PumpcalcCoreModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    PumpcalcCoreComponent,
                    HeaderComponent,
                    FooterComponent,
                    NumberFieldComponent,
                    StandardPipeSelectorComponent,
                    GasSelectorComponent,
                    StatusBarComponent,
                    PipeworkComponent,
                    LoginComponent,
                    MsalComponent,
                    UnitsSelector,
                    UnitsSettingsComponent,
                    UnitSettingsDialogueComponent,
                    TopMenuComponent,
                    HeaderComponent,
                    LoaderComponent,
                    LabelSvgComponent,
                    PumpSetSvgComponent,
                    PipeworkSvgComponent
                ],
                providers: [
                    DatatypesService,
                    GasService,
                    DataCacheService,
                    RestDataService,
                    FormattingService,
                    UIEventsService,
                    HttpClient,
                    AppEventService,
                    UserService,
                    PumpSetSvgService,
                    PipeworkSvgService,
                    UtilsService,
                    DiagramSelectionService
                ],
                imports: [
                    DxNumberBoxModule,
                    DxDataGridModule,
                    DxDropDownBoxModule,
                    DxTreeViewModule,
                    DxSelectBoxModule,
                    DxLoadIndicatorModule,
                    DxButtonModule,
                    DxPopupModule,
                    DxScrollViewModule,
                    CommonModule,
                    BrowserModule,
                    FormsModule,
                    NgUnitsModule.forRoot(systemOfUnitsInitializer()),
                    MsalModule,
                    HttpClientModule,
                ],
                exports: [
                    PumpcalcCoreComponent,
                    FooterComponent,
                    NumberFieldComponent,
                    StandardPipeSelectorComponent,
                    GasSelectorComponent,
                    StatusBarComponent,
                    PipeworkComponent,
                    LoginComponent,
                    MsalComponent,
                    UnitsSelector,
                    UnitsSettingsComponent,
                    UnitSettingsDialogueComponent,
                    TopMenuComponent,
                    HeaderComponent,
                    LoaderComponent,
                    LabelSvgComponent,
                    PumpSetSvgComponent,
                    PipeworkSvgComponent
                ]
            }]
    }], null, null); })();

class SolverApiService {
    constructor(restDataService) {
        this.restDataService = restDataService;
        this.stopPoll = false;
    }
    pollJobUntilReady(jobsUrl) {
        this.stopPoll = false;
        return interval(1000).pipe(tap(() => { if (this.stopPoll) {
            throw ("User Cancelled");
        } }))
            .pipe(concatMap(() => this.restDataService.get(jobsUrl)
            .pipe(catchError(function (error, job) { this.handleError(error); return job; })))).pipe(filter((job) => job.status === "Completed"))
            .pipe(take(1));
    }
    handleError(operation = 'operation') {
        return (error) => {
            console.error(error);
            throw error;
        };
    }
    stopPolling() {
        this.stopPoll = true;
    }
}
SolverApiService.ɵfac = function SolverApiService_Factory(t) { return new (t || SolverApiService)(ɵɵinject(RestDataService)); };
SolverApiService.ɵprov = ɵɵdefineInjectable({ token: SolverApiService, factory: SolverApiService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SolverApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: RestDataService }]; }, null); })();
class Job {
}

const MockUnitsService = {
    unitChangeAnnounced: (new Subject()).asObservable(),
    setAsPreset(preset, silent) {
    },
    getUnitsForQuantity(quantityName) {
        return [];
    },
    getSelectedUnitForQuantity(quantityName) {
        return '°C';
    },
    setUnitForQuantity(quantityName, unit, intialisingCustomPreset) {
    },
    convertFromSIForQuantity(quantityName, value) {
        return value * 10;
    },
    convertToSIForQuantity(quantityName, value) {
        return value / 10;
    }
};
const MockMsalService = {};
const MockLoginService = {
    getAccount() {
        return {};
    }
};

class StatusMessage {
}
class StatusBarService {
    constructor() { }
    statusLoading(message) {
        return { message: message, state: "loading" };
    }
    statusWarning(message) {
        return { message: message, state: "warning" };
    }
    statusInfo(message) {
        return { message: message, state: "info" };
    }
    clear() {
        return { message: "", state: "" };
    }
}
StatusBarService.ɵfac = function StatusBarService_Factory(t) { return new (t || StatusBarService)(); };
StatusBarService.ɵprov = ɵɵdefineInjectable({ token: StatusBarService, factory: StatusBarService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(StatusBarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class FileSaveService {
    //TODO FIX Compilation error
    downloadText(text, fileName) {
        if (window.navigator.msSaveBlob) {
            //Internet Explorer
            //https://stackoverflow.com/a/42466254
            var blob = new Blob([decodeURIComponent(encodeURI("\uFEFF" + text))], { type: "text/csv;charset=utf-8;" });
            window.navigator.msSaveBlob(blob, fileName);
        }
        else {
            //Google Chrome and Mozilla Firefox
            var a = document.createElement("a");
            //https://stackoverflow.com/a/20952812
            a.href = "data:application/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(text);
            a.download = fileName;
            a.click();
            document.body.removeChild(a);
        }
    }
    copyStringToClipBoard(val) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.innerText = val;
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }
}
FileSaveService.ɵfac = function FileSaveService_Factory(t) { return new (t || FileSaveService)(); };
FileSaveService.ɵprov = ɵɵdefineInjectable({ token: FileSaveService, factory: FileSaveService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FileSaveService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

/*
 * Public API Surface of pumpcalc-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AppEvent, AppEventService, BoosterLayerDetail, DataCacheService, DatatypesService, DiagramSelectionService, FileSaveService, FooterComponent, FormattingService, Gas, GasSelectorComponent, GasService, HeaderComponent, Job, LabelSvgComponent, LoaderComponent, LoginComponent, LoginService, MSALInstanceFactory, MSALInterceptorConfigFactory, MockLoginService, MockMsalService, MockUnitsService, MsalComponent, NumberFieldComponent, Pipe, PipeworkComponent, PipeworkSvgComponent, PipeworkSvgService, Preset, PumpSet, PumpSetSvgComponent, PumpSetSvgService, PumpcalcCoreComponent, PumpcalcCoreModule, PumpcalcCoreService, Quantity, RestDataService, SolverApiService, StandardPipeSelectorComponent, StatusBarComponent, StatusBarService, StatusMessage, TopMenuComponent, UnitSetting, UnitSettingsDialogueComponent, UnitsSelector, UnitsService, UnitsSettingsComponent, User, UserService, UtilsService, getMyFactory, isIE, isIframe, loggerCallback };
//# sourceMappingURL=pumpcalc-core.js.map
